/**
 * Dictionnaire complet des traductions
 * FR, EN, AR, ES pour toutes les pages
 */

export const allTranslations = {
  fr: {
    'nav.home': 'Accueil',
    'nav.exhibitors': 'Exposants',
    'nav.partners': 'Partenaires',
    'nav.networking': 'Réseautage',
    'nav.event': 'Événement',
    'nav.participate': 'Participer',
    'nav.contact': 'Contact',
    'nav.pavilions': 'Pavillons',
    'nav.events': 'Événements',
    'nav.news': 'Actualités',
    'nav.information': 'Information',
    'nav.accommodation': 'Hébergement',
    'nav.subscriptions': 'Abonnements',
    'nav.dashboard': 'Tableau de bord',
    'nav.appointments': 'Rendez-vous',
    'nav.chat': 'Messagerie',
    'nav.profile': 'Mon Profil',
    'nav.login': 'Se connecter',
    'nav.register': 'S\'inscrire',
    'nav.logout': 'Se déconnecter',
    'menu.pavilions_desc': 'Explorez les pavillons du salon',
    'menu.events_desc': 'Conférences et ateliers',
    'menu.news_desc': 'Dernières actualités de l\'événement',
    'menu.subscriptions_desc': 'Plans d\'abonnement',
    'menu.accommodation_desc': 'Hôtels partenaires & tarifs préférentiels',
    'event.about': 'À propos de SIPORTS',
    'event.about_desc': 'Découvrez le salon international',
    'event.program': 'Programme',
    'event.program_desc': 'Conférences & speakers',
    'event.pavilions': 'Pavillons',
    'event.pavilions_desc': 'Zones thématiques & exposants',
    'event.news': 'Actualités',
    'event.news_desc': 'Dernières nouvelles',
    'event.prepare_visit': 'Préparer ma visite',
    'event.prepare_desc': 'Hébergement, accès & plan',
    'participate.visitors': 'Visiteurs',
    'participate.visitors_desc': 'Inscription gratuite ou Pass VIP',
    'participate.become_exhibitor': 'Devenir exposant',
    'participate.exhibitor_desc': 'Tarifs & packages exposants',
    'participate.become_partner': 'Devenir partenaire',
    'participate.partner_desc': 'Opportunités de sponsoring',
    'media.menu_title': 'Média',
    'media.webinars': 'Webinaires',
    'media.webinars_desc': 'Webinaires sponsorisés en replay',
    'media.podcasts': 'Podcasts',
    'media.podcasts_desc': 'SIPORT Talks - Épisodes audio',
    'media.capsules': 'Capsules Inside',
    'media.capsules_desc': 'Capsules vidéo Inside SIPORT',
    'media.live_studio': 'Live Studio',
    'media.live_studio_desc': 'Meet The Leaders - Interviews live',
    'media.best_moments': 'Best Moments',
    'media.best_moments_desc': 'Meilleurs moments du salon',
    'media.testimonials': 'Témoignages',
    'media.testimonials_desc': 'Témoignages vidéo',
    'media.library': 'Bibliothèque Média',
    'media.library_desc': 'Tous les contenus médias',
    'pages.exhibitors.title': 'Exposants',
    'pages.exhibitors.description': 'Découvrez les entreprises et organisations de l\'industrie portuaire',
    'pages.exhibitors.search': 'Chercher un exposant',
    'pages.exhibitors.filter_category': 'Catégorie',
    'pages.exhibitors.all_categories': 'Toutes les catégories',
    'pages.exhibitors.category_institutional': 'Institutionnel',
    'pages.exhibitors.category_port_industry': 'Industrie Portuaire',
    'pages.exhibitors.category_operations': 'Exploitation & Gestion',
    'pages.exhibitors.category_academic': 'Académique & Formation',
    'pages.exhibitors.category_technology': 'Technologie',
    'pages.exhibitors.category_automation': 'Automatisation',
    'pages.exhibitors.category_equipment': 'Équipement',
    'pages.exhibitors.featured': 'En vedette',
    'sector.technology': 'Technologie',
    'sector.port_industry': 'Industrie Portuaire',
    'sector.automation': 'Automatisation',
    'sector.equipment': 'Équipement',
    'sector.operations_management': 'Exploitation & Gestion',
    'pages.exhibitors.verified': 'Vérifié',
    'pages.exhibitors.contact': 'Contacter',
    'pages.exhibitors.view_profile': 'Voir le profil',
    'pages.exhibitors.no_results': 'Aucun exposant trouvé',
    'exhibitor_levels.basic_9': '9m² Basique',
    'exhibitor_levels.standard_18': '18m² Standard',
    'exhibitor_levels.premium_36': '36m² Premium',
    'exhibitor_levels.elite_54plus': '54m²+ Élite',
    'pages.partners.title': 'Partenaires et Sponsors',
    'pages.partners.description': 'Les organisations qui soutiennent SIPORTS 2026',
    'pages.partners.search': 'Chercher un partenaire',
    'pages.partners.filter_tier': 'Type de partenariat',
    'pages.partners.tier_museum': 'Musée',
    'pages.partners.tier_silver': 'Silver',
    'pages.partners.tier_gold': 'Gold',
    'pages.partners.tier_platinum': 'Platinum',
    'pages.partners.view_details': 'Voir détails',
    'pages.partners.no_results': 'Aucun partenaire trouvé',
    'pages.partners.category_education': 'Éducation & Formation',
    'pages.partners.category_institutional': 'Institutionnel',
    'pages.partners.category_logistics': 'Logistique',
    'pages.partners.category_technology': 'Technologie',
    'pages.partners.category_media': 'Média',
    'pages.partners.try_modify': 'Essayez de modifier vos filtres',
    'pages.partners.reset_filters': 'Réinitialiser les filtres',
    'pages.events.title': 'Événements',
    'pages.events.description': 'Les conférences, ateliers et activités du salon',
    'pages.events.search': 'Chercher un événement',
    'pages.events.filter_date': 'Date',
    'pages.events.date': 'Date',
    'pages.events.time': 'Heure',
    'pages.events.location': 'Lieu',
    'pages.events.capacity': 'Places disponibles',
    'pages.events.register': 'S\'inscrire à cet événement',
    'pages.events.registered': 'Inscrit',
    'pages.events.no_results': 'Aucun événement trouvé',
    'pages.events.scientific_programme': 'Programme Scientifique',
    'pages.events.type_officiel': 'Officiel',
    'pages.events.type_panel': 'Panel',
    'pages.events.type_table_ronde': 'Table Ronde',
    'pages.events.type_ted_talk': 'Ted Talk',
    'pages.events.type_atelier': 'Atelier',
    'pages.events.type_pause': 'Pause',
    'pages.events.type_concours': 'Concours',
    'pages.events.type_cloture': 'Clôture',
    'pages.events.strategic_reflection': 'Espace de réflexion stratégique réunissant décideurs institutionnels et acteurs majeurs de l\'industrie portuaire',
    'pages.events.info_dates_location': '{dates} · {location}',
    'pages.news.title': 'Actualités',
    'pages.news.description': 'Les dernières nouvelles du salon et de l\'industrie',
    'pages.news.search': 'Chercher une actualité',
    'pages.news.read_more': 'Lire plus',
    'pages.news.published': 'Publié le',
    'pages.news.no_results': 'Aucune actualité trouvée',
    'pages.news.min_read': 'min de lecture',
    'pages.news.categories': 'Catégories',
    'pages.news.all_categories': 'Toutes les catégories',
    'pages.news.featured': 'En vedette',
    'pages.news.trending': 'Tendance',
    'article.siports_2026': 'SIPORTS 2026 : Le Salon International des Ports et de la Logistique',
    'article.siports_excerpt': 'Découvrez le plus grand événement portuaire d\'Afrique',
    'article.siports_content': 'SIPORTS 2026 est le rendez-vous incontournable des professionnels du secteur portuaire et logistique. Cet événement majeur réunira les acteurs clés de l\'industrie pour trois jours d\'échanges et de networking.',
    'article.innovation_title': 'Innovation Portuaire : Les Technologies qui Transforment nos Ports',
    'article.innovation_excerpt': 'Intelligence artificielle, automatisation, IoT : les ports modernes adoptent les technologies de pointe pour améliorer leur efficacité.',
    'article.innovation_content': 'Les ports du monde entier investissent massivement dans les nouvelles technologies. De l\'automatisation aux systèmes intelligents, l\'innovation transforme le secteur.',
    'article.durability_title': 'Développement Durable : Les Ports s\'Engagent',
    'article.durability_excerpt': 'Les initiatives écologiques se multiplient dans les ports pour réduire l\'impact environnemental',
    'article.durability_content': 'Face aux enjeux climatiques, les ports adoptent des stratégies ambitieuses pour réduire leur impact environnemental. Énergies renouvelables, électrification des quais, gestion des déchets : tour d\'horizon des initiatives vertes.',
    'article.mediterranean_title': 'Le Commerce Maritime en Méditerranée : Perspectives 2026',
    'article.mediterranean_excerpt': 'Analyse des tendances du commerce maritime méditerranéen et des opportunités pour les acteurs du secteur.',
    'article.mediterranean_content': 'La Méditerranée reste un carrefour stratégique pour le commerce mondial. Avec l\'émergence de nouveaux corridors, la région connaît une transformation majeure.',
    'article.careers_title': 'Formation et Emploi : Les Métiers du Port de Demain',
    'article.careers_excerpt': 'Le secteur portuaire recrute ! Découvrez les formations et les opportunités de carrière dans l\'industrie maritime',
    'article.careers_content': 'Le secteur portuaire est en pleine mutation et recherche de nouveaux talents. Des métiers traditionnels aux nouvelles spécialités liées à la digitalisation, les opportunités sont nombreuses pour ceux qui souhaitent faire carrière dans ce domaine.',
    'article.security_title': 'Sécurité Portuaire : Les Nouvelles Normes Internationales',
    'article.security_excerpt': 'Les standards de sécurité évoluent pour répondre aux nouveaux défis du transport maritime mondial.',
    'article.security_content': 'La sécurité reste une priorité absolue dans les installations portuaires. Cybersécurité, contrôle des accès, prévention des risques : découvrez les dernières réglementations et innovations en matière de sécurité portuaire.',
    'admin.title': 'Administration',
    'admin.dashboard': 'Tableau de bord',
    'admin.dashboard_title': 'Tableau de Bord Admin',
    'admin.welcome': 'Bienvenue, {{name}}',
    'admin.system_operational': 'Système Opérationnel',
    'admin.system_uptime': 'Disponibilité système',
    'admin.api_calls_per_day': 'Appels API / jour',
    'admin.storage_used': 'Stockage utilisé',
    'admin.required_actions': 'Actions Requises',
    'admin.items_need_attention': '{{count}} éléments nécessitent votre attention',
    'admin.registration_requests': 'Demandes d\'inscription',
    'admin.click_to_process': 'Cliquer pour traiter',
    'admin.payment_validation': 'Validation paiements',
    'admin.manage_proofs': 'Gérer les justificatifs',
    'admin.exhibitors': 'Exposants',
    'admin.partners': 'Partenaires',
    'admin.visitors': 'Visiteurs',
    'admin.visits': 'Visites',
    'admin.list_and_subscriptions': 'Liste & Abonnements',
    'admin.list_and_packs': 'Liste & Packs',
    'admin.vip_visitors_management': 'Gestion Visiteurs VIP',
    'admin.view_list': 'Consulter la liste',
    'admin.content_moderation': 'Contenus à modérer',
    'admin.active_contracts': 'Contrats actifs',
    'admin.create_partner': 'Créer un partenaire',
    'admin.manage_partners_action': 'Gérer les partenaires',
    'admin.create_exhibitor': 'Créer un exposant',
    'admin.manage_exhibitors_action': 'Gérer les exposants',
    'admin.create_event': 'Créer un événement',
    'admin.manage_events_action': 'Gérer les événements',
    'admin.create_article': 'Créer un article',
    'admin.manage_articles_action': 'Gérer les articles',
    'admin.create_pavilion_action': 'Créer un pavillon',
    'admin.manage_pavilions_action': 'Gérer les pavillons',
    'admin.manage_media_action': 'Gérer les médias',
    'admin.validate_media': 'Valider les médias',
    'admin.sync_articles': 'Sync articles',
    'admin.syncing': 'Synchronisation...',
    'admin.publication_control': 'Contrôle de Publication',
    'admin.publication_warning': 'Activer/Désactiver la visibilité GLOBALE',
    'admin.total_control': 'CONTRÔLE TOTAL',
    'admin.quick_actions': 'Actions Rapides & Navigation',
    'admin.participant_management': 'Gestion Participants',
    'admin.content_management': 'Gestion Contenu',
    'admin.media_management_section': 'Gestion Médias',
    'admin.nav_and_stats': 'Navigation & Statistiques',
    'admin.analytics_trends': 'Analyse & Tendances',
    'admin.realtime_data': 'Données en temps réel',
    'admin.user_growth': 'Croissance des Utilisateurs (6 derniers mois)',
    'admin.total_users_chart': 'Total Utilisateurs',
    'admin.user_distribution': 'Distribution des Utilisateurs',
    'admin.platform_activity': 'Activité Plateforme (Cette semaine)',
    'admin.weekly_traffic': 'Trafic Hebdomadaire',
    'admin.chart_visits': 'Visites',
    'admin.chart_pageviews': 'Pages vues',
    'admin.metrics_label': 'Métriques',
    'admin.performance_label': 'Performance',
    'admin.users_label': 'Utilisateurs',
    'admin.pavilions_label': 'Pavillons',
    'admin.events_label': 'Événements',
    'admin.system_health': 'Santé Système',
    'admin.api_calls_24h': 'Appels API (24h)',
    'admin.avg_response_time': 'Temps réponse moyen',
    'admin.recent_activity': 'Activité Système Récente',
    'admin.view_all': 'Voir tout',
    'admin.active_exhibitors': 'Exposants Actifs',
    'admin.registered_visitors': 'Visiteurs Inscrits',
    'admin.official_partners': 'Partenaires Officiels',
    'admin.conferences_workshops': 'Conférences & Ateliers',
    'admin.detailed_metrics': 'Métriques & Performance Détaillées',
    'admin.detailed_metrics_desc': 'Accédez aux analyses complètes de performance du salon SIPORTS 2026',
    'admin.full_metrics': 'Voir les Métriques Complètes',
    'admin.admin_access_only': 'Accès Admin Uniquement',
    'admin.online': 'en ligne',
    'admin.sync_label': 'Synchronisation',
    'admin.events_section': 'Événements',
    'admin.articles_section': 'Articles',
    'admin.pavilions_section': 'Pavillons Thématiques',
    'admin.medias_section': 'Médias',
    'admin.users_management': 'Gestion des utilisateurs',
    'admin.exhibitors_management': 'Gestion des exposants',
    'admin.partners_management': 'Gestion des partenaires',
    'admin.events_management': 'Gestion des événements',
    'admin.news_management': 'Gestion des articles',
    'admin.pavilions_management': 'Gestion des pavillons thématiques',
    'admin.vip_visitors': 'Gestion des visiteurs VIP',
    'admin.live_studio_management': 'Gestion des Lives Studio',
    'admin.media_manager': 'Gestionnaire de médias',
    'admin.analytics': 'Statistiques',
    'admin.settings': 'Paramètres',
    'admin.total_users': 'Utilisateurs totaux',
    'admin.active_users_count': '{{count}} utilisateurs actifs',
    'admin.total_exhibitors': 'Exposants totaux',
    'admin.total_partners': 'Partenaires totaux',
    'admin.pending_approval': 'En attente d\'approbation',
    'admin.approve': 'Approuver',
    'admin.reject': 'Rejeter',
    'admin.edit': 'Modifier',
    'admin.delete': 'Supprimer',
    'admin.edit_profile': 'Modifier le profil',
    'admin.media_management': 'Gestion des médias',
    'admin.new_exhibitor': 'Nouvel Exposant',
    'admin.new_partner': 'Nouveau Partenaire',
    'admin.new_event': 'Nouvel Événement',
    'admin.new_article': 'Nouvel Article',
    'admin.manage_exhibitors_desc': 'Gérez tous les exposants de la plateforme',
    'admin.manage_partners_desc': 'Gérez tous les partenaires de la plateforme',
    'admin.manage_events_desc': 'Gérez tous les événements de la plateforme',
    'admin.manage_users_desc': 'Gérez tous les utilisateurs de la plateforme',
    'admin.edit_user': 'Modifier l\'utilisateur',
    'admin.change_status': 'Statut',
    'admin.change_level': 'Niveau',
    'admin.change_role': 'Rôle',
    'admin.save_changes': 'Sauvegarder',
    'admin.cancel': 'Annuler',
    'admin.user_updated': 'Utilisateur mis à jour avec succès',
    'admin.user_update_error': 'Erreur lors de la mise à jour',
    'admin.manage_news_desc': 'Gérez tous les articles et actualités de la plateforme',
    'admin.back_to_media': 'Retour à la gestion des médias',
    'admin.total_events': 'Total Événements',
    'admin.upcoming': 'À venir',
    'admin.types': 'Types',
    'admin.this_month': 'Ce mois',
    'admin.total_articles': 'Total Articles',
    'admin.published': 'Publiés',
    'admin.loading_events': 'Chargement des événements...',
    'admin.loading_articles': 'Chargement des articles...',
    'admin.search_event': 'Rechercher un événement...',
    'admin.search_article': 'Rechercher un article...',
    'admin.all_types': 'Tous les types',
    'admin.media_management_title': 'Gestion des Médias',
    'admin.media_management_desc': 'Validez, modérez et gérez tous les contenus médias',
    'admin.new_media': 'Créer Nouveau Média',
    'admin.total_media': 'Total Médias',
    'admin.pending': 'En attente',
    'admin.approved': 'Approuvés',
    'admin.rejected': 'Rejetés',
    'admin.status_published': 'Publié',
    'admin.status_pending': 'En attente',
    'admin.status_rejected': 'Rejeté',
    'admin.loading': 'Chargement...',
    'admin.no_media_found': 'Aucun média trouvé',
    'admin.confirm_delete_media': 'Êtes-vous sûr de vouloir supprimer ce média ?',
    'admin.pavilions_management_title': 'Gestion des Pavillons Thématiques',
    'admin.pavilions_management_desc': 'Administration et organisation des pavillons SIPORTS 2026',
    'admin.create_pavilion': 'Créer Pavillon',
    'admin.total_pavilions': 'Total Pavillons',
    'admin.active_pavilions': 'Actifs',
    'admin.total_exhibitors_in_pavilions': 'Exposants',
    'visitor.registration.free.title': 'Inscription Visiteur Gratuit',
    'visitor.registration.free.subtitle': 'Accès standard au salon SIPORTS 2026',
    'visitor.registration.free.badge_access': 'Accès Salon',
    'visitor.registration.free.badge_qr': 'Badge QR',
    'visitor.registration.free.badge_free': 'Gratuit',
    'visitor.form.firstname': 'Prénom',
    'visitor.form.lastname': 'Nom',
    'visitor.form.email': 'Email professionnel',
    'visitor.form.phone': 'Téléphone',
    'visitor.form.country': 'Pays',
    'visitor.form.sector': 'Secteur d\'activité',
    'visitor.form.position': 'Poste occupé',
    'visitor.form.company': 'Entreprise / Organisme',
    'visitor.form.password': 'Mot de passe',
    'visitor.form.confirm_password': 'Confirmer le mot de passe',
    'visitor.form.submit': 'Valider l\'inscription',
    'visitor.form.submitting': 'Traitement en cours...',
    'visitor.validation.firstname_required': 'Le prénom est requis',
    'visitor.validation.lastname_required': 'Le nom est requis',
    'visitor.validation.email_invalid': 'Adresse email invalide',
    'visitor.validation.phone_invalid': 'Numéro de téléphone invalide',
    'visitor.validation.country_required': 'Le pays est requis',
    'visitor.validation.sector_required': 'Le secteur d\'activité est requis',
    'visitor.validation.password_length': 'Le mot de passe doit faire au moins 12 caractères',
    'visitor.validation.password_requirements': 'Le mot de passe doit contenir majuscule, minuscule, chiffre et caractère spécial',
    'visitor.validation.password_match': 'Les mots de passe ne correspondent pas',
    'visitor.validation.phone_required': 'Le numéro de téléphone est requis',
    'visitor.validation.position_required': 'Le poste est requis',
    'visitor.validation.company_required': 'L\'entreprise est requise',
    'visitor.validation.check_errors': 'Veuillez corriger les erreurs surlignées en rouge',
    'visitor.sector.authority': 'Autorité Portuaire',
    'visitor.sector.transport': 'Transport Maritime',
    'visitor.sector.logistics': 'Logistique',
    'visitor.sector.consulting': 'Consulting',
    'visitor.sector.technology': 'Technologie',
    'visitor.sector.student': 'Étudiant',
    'visitor.sector.media': 'Média/Presse',
    'visitor.sector.institutional': 'Institutionnel',
    'visitor.sector.other': 'Autre',
    'visitor.free.features.title': 'Inclus avec votre compte gratuit :',
    'visitor.free.features.list.1': 'Accès aux zones publiques du salon',
    'visitor.free.features.list.2': 'Badge numérique simple',
    'visitor.free.features.list.3': 'Newsletter SIPORTS',
    'visitor.free.features.list.4': 'Accès à l\'espace presse',
    'visitor.upsell.vip.title': 'Vous souhaitez plus d\'avantages ?',
    'visitor.upsell.vip.button': 'Découvrir l\'offre VIP',
    'visitor.message.email_check_error': 'Erreur lors de la vérification de l\'email',
    'visitor.message.account_exists': 'Un compte existe déjà avec cet email',
    'visitor.message.account_exists_desc': 'Veuillez vous connecter directement.',
    'visitor.message.email_sent': 'Email de bienvenue envoyé !',
    'visitor.message.success_title': 'Inscription réussie !',
    'visitor.message.success_desc': 'Votre compte visiteur gratuit a été créé avec succès.',
    'visitor.message.redirect': 'Redirection vers votre espace...',
    'visitor.dashboard': 'Mon espace',
    'visitor.my_profile': 'Mon profil',
    'visitor.my_appointments': 'Mes rendez-vous',
    'visitor.my_favorites': 'Mes favoris',
    'visitor.upgrade': 'Upgrader mon compte',
    'visitor.subscription_level': 'Niveau d\'abonnement',
    'visitor.member_since': 'Membre depuis',
    'visitor.my_badge': 'Mon badge numérique',
    'visitor.discover_exhibitors': 'Découvrir les exposants',
    'visitor.registrations_title': 'Inscriptions',
    'visitor.event_past': 'Passé',
    'visitor.b2b_management_title': 'Gestion des Rendez-vous B2B',
    'visitor.b2b_management_subtitle': 'Organisez vos rencontres avec les exposants',
    'visitor.confirmed_agenda': 'Agenda Confirmé',
    'visitor.no_upcoming_confirmed': 'Aucun rendez-vous confirmé à venir',
    'visitor.past_appointments': 'Rendez-vous Passés',
    'visitor.no_past_appointments': 'Aucun rendez-vous passé',
    'visitor.cancelled_appointments': 'Rendez-vous Annulés',
    'visitor.no_cancelled_appointments': 'Aucun rendez-vous annulé',
    'visitor.appointment_cancelled': 'Annulé',
    'visitor.select_next_meeting': 'Sélectionnez votre prochaine rencontre stratégique',
    'visitor.error_loading_appointments': 'Impossible de charger les rendez-vous. Veuillez réessayer.',
    'visitor.unauthorized_access': 'Accès non autorisé',
    'visitor.please_login': 'Veuillez vous connecter pour accéder à cette page',
    'visitor.visitor_area': 'Espace Visiteur',
    'visitor.my_virtual_badge': 'Mon Badge Virtuel',
    'visitor.connected': 'Connecté',
    'visitor.appointments_remaining': 'Rendez-vous restants',
    'visitor.b2b_appointments': 'Rendez-vous B2B',
    'visitor.refused': 'Refusés',
    'visitor.exhibitors_visited': 'Exposants visités',
    'visitor.favorites': 'Favoris',
    'visitor.connections': 'Connexions',
    'visitor.messages': 'Messages',
    'visitor.appointments_booked': 'Rendez-vous réservés',
    'visitor.level_label': 'Niveau',
    'visitor.events_registered': 'Événements inscrits',
    'visitor.vip_benefits_title': 'Avantages VIP',
    'visitor.vip_benefits_subtitle': 'Profitez de tous les privilèges premium',
    'visitor.vip_appointments': '10 Rendez-vous B2B',
    'visitor.vip_appointments_desc': 'Profitez de 10 rendez-vous pour maximiser vos contacts',
    'visitor.vip_messaging': 'Messagerie Illimitée',
    'visitor.vip_messaging_desc': 'Contactez tous les exposants sans limite',
    'visitor.vip_badge': 'Badge VIP Visible',
    'visitor.vip_badge_desc': 'Soyez identifié comme visiteur premium',
    'visitor.vip_ai_matching': 'Matching IA Privilégié',
    'visitor.vip_ai_matching_desc': 'Algorithme prioritaire pour trouver les meilleurs contacts',
    'visitor.vip_webinars': 'Accès Webinaires Exclusifs',
    'visitor.vip_webinars_desc': 'Contenus réservés aux VIP',
    'visitor.vip_support_priority': 'Support Prioritaire',
    'visitor.vip_support_desc': 'Assistance dédiée 24/7',
    'visitor.vip_news_priority': 'Actualités en Avant-Première',
    'visitor.vip_news_desc': 'Recevez les news en priorité',
    'visitor.ai_networking': 'Réseautage IA',
    'visitor.ai_networking_desc': 'Découvrez les contacts pertinents avec notre IA',
    'visitor.explore_network': 'Explorer le réseau',
    'visitor.configure_matching': 'Configurer le matching',
    'visitor.schedule_appointment': 'Planifier un rendez-vous',
    'visitor.schedule_appointment_desc': 'Réservez un créneau avec un exposant',
    'visitor.program_appointment': 'Programmer un rendez-vous',
    'visitor.your_activity': 'Votre Activité',
    'visitor.your_activity_desc': 'Suivez vos statistiques en temps réel',
    'visitor.live': 'LIVE',
    'visitor.visits': 'Visites',
    'visitor.interactions': 'Interactions',
    'visitor.currently': 'Actuellement',
    'visitor.previous_period': 'Période précédente',
    'visitor.confirmed_appointments': 'Rendez-vous confirmés',
    'visitor.connections_established': 'Connexions établies',
    'visitor.messaging': 'Messagerie',
    'visitor.messaging_desc': 'Communiquez directement avec les exposants',
    'visitor.open_messaging': 'Ouvrir la messagerie',
    'events.unregister': 'Se désinscrire',
    'appointments.calendar': 'Calendrier',
    'partner.activation_required': 'Activation Requise',
    'partner.payment_validation_needed': 'Pour accéder à votre espace partenaire, veuillez finaliser le paiement de votre pack de partenariat.',
    'partner.finalize_payment': 'Finaliser le paiement',
    'partner.access_denied': 'Accès refusé',
    'partner.reserved_partners': 'Cette section est réservée aux partenaires officiels SIPORTS',
    'partner.hero_subtitle': 'Tableau de bord partenaire',
    'partner.virtual_badge': 'Badge Virtuel Partenaire',
    'partner.roi_performance': 'Performance ROI',
    'partner.dashboard_live': 'Dashboard LIVE',
    'partner.tabs.overview': 'Vue d\'ensemble',
    'partner.tabs.profile': 'Profil',
    'partner.tabs.networking': 'Réseautage',
    'partner.tabs.analytics': 'Analytiques',
    'partner.payment_validation_required': 'Validation de Paiement Requise',
    'partner.payment_activation_message': 'Votre profil partenaire sera activé après validation de votre paiement par notre équipe.',
    'partner.make_payment': 'Effectuer le paiement',
    'partner.stats.profile_views': 'Vues profil',
    'partner.stats.connections': 'Connexions',
    'partner.stats.appointments': 'Rendez-vous',
    'partner.stats.messages': 'Messages',
    'partner.quotas.title': 'Vos Quotas Partenaire',
    'partner.quotas.appointments': 'Rendez-vous',
    'partner.quotas.team_members': 'Membres équipe',
    'partner.quotas.media_files': 'Fichiers média',
    'partner.recent_activity': 'Activité Récente',
    'partner.ai_generation': 'Génération Profile IA',
    'partner.ai_description': 'Laissez notre IA créer automatiquement votre profil partenaire à partir de votre site web',
    'partner.ai_button': '🤖 Générer avec l\'IA',
    'partner.manual_management': 'Gestion Manuelle',
    'partner.edit_basic_info': '✏️ Modifier les informations de base',
    'partner.media_catalog': '📸 Catalogue média',
    'partner.appointments_management': 'Gestion des Rendez-vous',
    'partner.appointments_description': 'Suivez et gérez vos demandes de rendez-vous',
    'partner.confirmed_appointments': 'rendez-vous confirmés',
    'partner.pending': 'Demandes en attente',
    'partner.no_pending_requests': 'Aucune demande en attente',
    'partner.pending_requests_appear_here': 'Les nouvelles demandes apparaîtront ici',
    'partner.no_message': 'Aucun message',
    'partner.accept': 'Accepter',
    'partner.reject': 'Refuser',
    'partner.share_scheduling_link': 'Partager votre lien de planification',
    'partner.share_calendar_description': 'Partagez votre calendrier avec vos contacts',
    'partner.copy_virtual_booth_link': '🔗 Copier le lien de mon stand virtuel',
    'partner.analytics_titles.brand_visibility': 'Visibilité de marque (7 derniers jours)',
    'partner.analytics_titles.engagement_channels': 'Canaux d\'engagement',
    'partner.global_roi_performance': 'Performance ROI Globale',
    'partner.export_pdf_report': 'Exporter le rapport PDF',
    'partner.analytics_titles.metrics_distribution': 'Distribution des métriques',
    'partner.autofill_profile_ai': 'Remplir automatiquement avec IA',
    'partner.autofill_description': 'Laissez notre IA analyser votre site web et remplir votre profil',
    'partner.edit_profile_manually': 'Modifier le profil manuellement',
    'partner.update_company_info': 'Mettre à jour les informations de l\'entreprise',
    'chat.messages': 'Messages',
    'visitor.discover_exhibitors_desc': 'Explorez les stands et trouvez les solutions qui vous intéressent',
    'visitor.view_exhibitors': 'Voir les exposants',
    'visitor.confirmed_count': '{{count}} Confirmés',
    'visitor.pending_count': '{{count}} En attente',
    'visitor.tab_upcoming': 'À venir ({{count}})',
    'visitor.tab_past': 'Passés ({{count}})',
    'visitor.tab_cancelled': 'Annulés ({{count}})',
    'visitor.ics_downloaded': 'Fichier .ics téléchargé',
    'visitor.google_calendar_opened': 'Ouverture de Google Calendar',
    'visitor.outlook_opened': 'Ouverture d\'Outlook',
    'visitor.open_google_calendar': 'Ouvrir dans Google Calendar',
    'visitor.retry_appointment': 'Relancer',
    'visitor.choose_b2b_slot': 'Choisir un créneau B2B',
    'visitor.choose_b2b_slot_desc': 'Sélectionnez votre prochaine rencontre stratégique',
    'partner.dashboard': 'Mon espace partenaire',
    'partner.my_profile': 'Mon profil',
    'partner.my_events': 'Mes événements',
    'partner.my_booth': 'Mon stand',
    'partner.analytics': 'Mon rapport',
    'partner.contacts': 'Mes contacts',
    'exhibitor.dashboard': 'Mon espace exposant',
    'exhibitor.my_profile': 'Mon profil',
    'exhibitor.my_booth': 'Mon stand',
    'exhibitor.appointments': 'Mes rendez-vous',
    'exhibitor.messages': 'Mes messages',
    'exhibitor.analytics': 'Statistiques',
    'exhibitor.booth_size': 'Taille du stand',
    'exhibitor.booth_location': 'Localisation du stand',
    'exhibitor.error_load_appointments': 'Impossible de charger les rendez-vous',
    'exhibitor.error_load_dashboard': 'Impossible de charger le tableau de bord',
    'exhibitor.error_toggle_visibility': 'Impossible de modifier la visibilité',
    'exhibitor.error_unauthorized_confirm': 'Vous n\'êtes pas autorisé à confirmer ce rendez-vous',
    'exhibitor.error_accept_failed': 'Impossible d\'accepter le rendez-vous',
    'exhibitor.error_unauthorized_reject': 'Vous n\'êtes pas autorisé à rejeter ce rendez-vous',
    'exhibitor.confirm_reject': 'Êtes-vous sûr de vouloir refuser ce rendez-vous ? Cette action est irréversible.',
    'exhibitor.error_reject_failed': 'Impossible de refuser le rendez-vous',
    'exhibitor.toast_profile_visible': '✅ Votre profil est maintenant visible publiquement',
    'exhibitor.toast_profile_hidden': '🔒 Votre profil est maintenant masqué du public',
    'exhibitor.header.published_tooltip_hide': 'Masquer mon profil du public',
    'exhibitor.header.published_tooltip_show': 'Afficher mon profil au public',
    'exhibitor.header.changing': '⏳ Changement...',
    'exhibitor.header.published_status': '✓ Publié',
    'exhibitor.header.hidden_status': '🔒 Masqué',
    'exhibitor.header.virtual_badge': 'Badge Virtuel',
    'exhibitor.header.create_edit_minisite': 'Créer/Éditer Mini-Site',
    'exhibitor.status.confirmed': 'Confirmés',
    'exhibitor.status.pending': 'En attente',
    'exhibitor.status.completed': 'Terminés',
    'exhibitor.stats.mini_site_views': 'Vues Mini-Site',
    'exhibitor.stats.appointments': 'Rendez-vous',
    'exhibitor.stats.downloads': 'Téléchargements',
    'exhibitor.stats.messages': 'Messages',
    'exhibitor.modals.views_title': 'Vues de votre Mini-Site',
    'exhibitor.modals.views_chart_title': 'Évolution des vues',
    'exhibitor.modals.views_footer': 'Votre mini-site attire l\'attention !',
    'exhibitor.modals.appointments_title': 'Détails des Rendez-vous',
    'exhibitor.modals.appointments_chart_title': 'Répartition par statut',
    'exhibitor.modals.appointments_action': 'Gérer mes rendez-vous',
    'exhibitor.modals.downloads_title': 'Téléchargements de Catalogues',
    'exhibitor.modals.downloads_chart_title': 'Téléchargements par période',
    'exhibitor.modals.messages_title': 'Activité Messagerie',
    'exhibitor.modals.messages_chart_title': 'Messages reçus',
    'exhibitor.modals.messages_action': 'Voir mes messages',
    'exhibitor.chart_minisite_views': 'Vues Mini-Site',
    'exhibitor.chart_downloads': 'Téléchargements',
    'exhibitor.chart_messages': 'Messages',
    'exhibitor.chart_connections': 'Connexions',
    'exhibitor.qr_download_success': 'Téléchargement Réussi',
    'exhibitor.qr_download_success_text': 'Le QR code de votre stand a été téléchargé avec succès !',
    'exhibitor.qr_download_error': 'Erreur de Téléchargement',
    'exhibitor.qr_download_error_text': 'Une erreur s\'est produite',
    'exhibitor.quota_b2b': 'Rendez-vous B2B',
    'exhibitor.quota_team': 'Membres équipe',
    'exhibitor.quota_demo': 'Sessions démo',
    'exhibitor.quota_scans': 'Scans badges/jour',
    'exhibitor.quota_media': 'Fichiers média',
    'exhibitor.stats_views': 'Vues Mini-Site',
    'exhibitor.stats_requests': 'Demandes de RDV',
    'exhibitor.stats_downloads': 'Téléchargements',
    'exhibitor.stats_messages': 'Messages',
    'exhibitor.calendar_title': 'Gestion Calendaire',
    'exhibitor.calendar_hub': 'Hub',
    'exhibitor.calendar_subtitle': 'Centralisez vos disponibilités et gérez vos rendez-vous stratégiques dans un espace dédié haut de gamme.',
    'exhibitor.tab_availability': 'Mes Disponibilités',
    'exhibitor.tab_appointments': 'Agenda Personnel',
    'exhibitor.analytics_title': 'Performance & Analytics',
    'exhibitor.analytics_realtime': 'Données en temps réel',
    'exhibitor.analytics_visits': 'Visites',
    'exhibitor.analytics_interactions': 'Interactions',
    'exhibitor.analytics_appointment_status': 'Statut des Rendez-vous',
    'exhibitor.analytics_activity_breakdown': 'Répartition des Activités',
    'exhibitor.period_this_week': 'Cette semaine',
    'exhibitor.period_last_week': 'Semaine dernière',
    'exhibitor.period_current': 'Actuellement',
    'exhibitor.period_previous': 'Période précédente',
    'exhibitor.period_confirmed': 'Rendez-vous confirmés',
    'exhibitor.period_new_connections': 'Nouvelles connexions',
    'exhibitor.quick_actions_title': 'Actions Rapides',
    'exhibitor.quick_actions_subtitle': 'Accès direct à vos outils essentiels',
    'exhibitor.quick_actions.create_minisite_ai': 'Créer Mini-Site IA',
    'exhibitor.quick_actions.create_minisite_ai_desc': 'Générer votre mini-site avec l\'IA',
    'exhibitor.quick_actions.networking_ai': 'Networking IA',
    'exhibitor.quick_actions.networking_ai_desc': 'Trouvez des contacts pertinents avec l\'IA',
    'exhibitor.quick_actions.edit_minisite': 'Éditer Mini-Site',
    'exhibitor.quick_actions.edit_minisite_desc': 'Personnaliser votre page de présentation',
    'exhibitor.quick_actions.profile': 'Mon Profil',
    'exhibitor.quick_actions.profile_desc': 'Gérer vos informations et préférences',
    'exhibitor.quick_actions.qr_code': 'QR Code',
    'exhibitor.quick_actions.qr_code_desc': 'Afficher votre QR code pour faciliter les échanges',
    'exhibitor.appointments_received': 'Rendez-vous reçus',
    'exhibitor.appointments_received_subtitle': 'Gérez vos demandes et confirmations',
    'exhibitor.appointments_upcoming': 'À venir',
    'exhibitor.appointments_past': 'Passés',
    'exhibitor.appointments_cancelled': 'Annulés',
    'exhibitor.appointments_loading': 'Chargement des rendez-vous...',
    'exhibitor.appointments_no_pending': 'Aucune demande en attente',
    'exhibitor.appointments_no_pending_hint': 'Les nouvelles demandes apparaîtront ici',
    'exhibitor.appointments_badge_new': 'Nouveau',
    'exhibitor.appointments_request_from': 'Demande de',
    'exhibitor.appointments_no_message': 'Aucun message',
    'exhibitor.appointments_confirming': '⏳ Confirmation...',
    'exhibitor.appointments_accept': '✓ Accepter',
    'exhibitor.appointments_rejecting': '⏳ Refus...',
    'exhibitor.appointments_reject': '✕ Refuser',
    'exhibitor.appointments_confirmed_upcoming': 'Rendez-vous confirmés à venir',
    'exhibitor.appointments_with': 'Avec',
    'exhibitor.appointments_badge_confirmed': '✓ Confirmé',
    'exhibitor.appointments_no_past': 'Aucun rendez-vous passé',
    'exhibitor.appointments_no_past_hint': 'L\'historique apparaîtra ici',
    'exhibitor.appointments_badge_completed': 'Terminé',
    'exhibitor.appointments_no_cancelled': 'Aucun rendez-vous annulé',
    'exhibitor.appointments_no_cancelled_hint': 'Les annulations apparaîtront ici',
    'exhibitor.appointments_badge_cancelled': 'Annulé',
    'exhibitor.activity_recent_title': 'Activité Récente',
    'exhibitor.activity_none': 'Aucune activité récente',
    'exhibitor.activity_view_all': 'Voir toute l\'activité',
    'exhibitor.activity.view_all': 'Toutes les Activités',
    'exhibitor.activity.none': 'Aucune activité récente',
    'exhibitor.info_title': 'Informations Importantes',
    'exhibitor.info_subtitle': 'Détails essentiels du salon',
    'exhibitor.info_booth_opening': 'Stand Ouverture',
    'exhibitor.info_every_day': 'Tous les jours du salon',
    'exhibitor.info_objective': 'Objectif 2026',
    'exhibitor.info_expected_visitors': 'visiteurs attendus',
    'exhibitor.qr_modal_title': 'QR Code Stand Exposant',
    'exhibitor.qr_modal_subtitle': 'Scannez ce code pour accéder rapidement à votre stand',
    'exhibitor.qr_label_company': 'Entreprise :',
    'exhibitor.qr_label_contact': 'Contact :',
    'exhibitor.qr_label_email': 'Email :',
    'exhibitor.qr_label_stand': 'Stand :',
    'exhibitor.qr_not_assigned': 'Non attribué',
    'exhibitor.qr_valid_until': 'Valide jusqu\'à',
    'exhibitor.qr_downloading': '⏳ Téléchargement...',
    'exhibitor.qr_download': '📥 Télécharger',
    'exhibitor.ics_downloaded': 'Fichier .ics téléchargé',
    'exhibitor.google_calendar_opened': 'Ouverture de Google Calendar',
    'exhibitor.outlook_opened': 'Ouverture d\'Outlook',
    'exhibitor.error_generic': 'Une erreur est survenue',
    'admin.verified': 'Vérifié',
    'status.confirmed': 'Confirmé',
    'status.pending': 'En attente',
    'status.completed': 'Terminé',
    'status.cancelled': 'Annulé',
    'actions.accept': 'Accepter',
    'actions.reject': 'Refuser',
    'actions.view': 'Voir',
    'actions.manage': 'Gérer',
    'actions.refresh': 'Actualiser',
    'actions.access': 'Accéder',
    'errors.accept_appointment': 'Impossible d\'accepter le rendez-vous',
    'errors.reject_appointment': 'Impossible de refuser le rendez-vous',
    'errors.unregister_event': 'Impossible de se désinscrire de l\'événement',
    'common.close': 'Fermer',
    'common.premium': 'Premium',
    'common.events': 'Événements',
    'common.connections': 'Connexions',
    'common.impressions': 'Impressions',
    'common.interactions': 'Interactions',
    'common.download': 'Télécharger',
    'common.back_to_dashboard': 'Retour au Tableau de Bord',
    'common.days.mon': 'Lun',
    'common.days.tue': 'Mar',
    'common.days.wed': 'Mer',
    'common.days.thu': 'Jeu',
    'common.days.fri': 'Ven',
    'common.days.sat': 'Sam',
    'common.days.sun': 'Dim',
    'home.book_appointment': 'Réserver un rendez-vous',
    'home.verified': 'Vérifié',
    'home.featured_partners_title': 'Partenaires à la Une',
    'home.featured_partners_desc': 'Les organisations leaders qui soutiennent SIPORTS 2026',
    'home.discover_all': 'Découvrez tous les partenaires',
    'home.discover_all_exhibitors': 'Découvrez tous les exposants',
    'home.featured_exhibitors_title': 'Exposants à la Une',
    'home.featured_exhibitors_desc': 'Les meilleurs exposants du salon',
    'home.views': 'vues',
    'home.benefits': 'avantages',
    'home.see_profile': 'Voir le Profil',
    'home.contact_partner': 'Contacter',
    'home.products': 'produits',
    'home.make_appointment': 'Prendre RDV',
    'home.ai_assistant': 'Assistant IA',
    'home.ai_assistant_toast': 'SIPORTS AI Assistant v3.0 - Connectez-vous pour accéder à l\'assistant IA',
    'categories.institutional': 'Institutionnel',
    'categories.port-industry': 'Industrie Portuaire',
    'categories.port-operations': 'Exploitation & Gestion',
    'categories.academic': 'Académique & Formation',
    'home.networking_label': 'Réseautage Intelligent',
    'home.networking_title': 'Connectez-vous avec les Bons Partenaires',
    'home.networking_desc': 'Trouvez et connectez-vous avec des professionnels du secteur maritime',
    'home.feature_matching': 'Correspondance Intelligente',
    'home.feature_matching_desc': 'Notre IA analyse vos profils pour trouver les meilleures correspondances',
    'home.feature_chat': 'Messagerie en Temps Réel',
    'home.feature_chat_desc': 'Communiquez instantanément avec vos contacts',
    'home.feature_appointments': 'Rendez-vous Planifiés',
    'home.feature_appointments_desc': 'Organisez vos rencontres avec un calendrier intégré',
    'home.feature_global': 'Plateforme Mondiale',
    'home.feature_global_desc': 'Connectez-vous avec des professionnels du monde entier',
    'home.cta_networking': 'Explorer le Réseautage',
    'home.cta_member': 'Devenir Membre',
    'home.stats_professionals': 'Professionnels',
    'home.stats_countries': 'Pays',
    'home.stats_exhibitors': 'Exposants',
    'home.stats_satisfaction': 'Satisfaction',
    'home.trusted_by': 'Ils nous font confiance',
    'home.logo_showcase_title': 'Nos Partenaires & Exposants',
    'salon.exhibitors': 'Exposants',
    'salon.visitors': 'Visiteurs Professionnels',
    'salon.conferences': 'Conférences & Panels',
    'salon.countries': 'Pays Représentés',
    'hero.title': 'SIPORTS 2026',
    'hero.subtitle': 'Un carrefour stratégique pour les ports et leurs écosystèmes',
    'hero.countdown.title': 'Prochainement',
    'hero.countdown.subtitle': 'Rejoignez-nous au Parc d\'Exposition Mohammed VI à El Jadida',
    'hero.stats.location': 'Maroc',
    'hero.stats.participants': 'Participants Professionnels',
    'hero.stats.exhibitors': 'Exposants Internationaux',
    'hero.cta.exhibitor': 'Devenir Exposant',
    'hero.cta.discover': 'Découvrir l\'événement',
    'time.days': 'Jours',
    'time.hours': 'Heures',
    'time.minutes': 'Minutes',
    'time.seconds': 'Secondes',
    'time.day': 'Jour',
    'time.hour': 'Heure',
    'time.minute': 'Minute',
    'time.second': 'Seconde',
    'stats.exhibitors': 'Exposants',
    'stats.visitors': 'Visiteurs',
    'stats.countries': 'Pays',
    'stats.conferences': 'Conférences',
    'login.title': 'Connexion',
    'login.subtitle': 'Accédez à votre espace SIPORTS',
    'login.email': 'Adresse email',
    'login.password': 'Mot de passe',
    'login.remember_me': 'Se souvenir de moi',
    'login.forgot_password': 'Mot de passe oublié ?',
    'login.button': 'Se connecter',
    'login.connecting': 'Connexion',
    'login.demo_accounts': 'Connexion rapide - Comptes de démonstration',
    'login.demo_admin': 'Admin Principal',
    'login.demo_exhibitors': 'Exposants',
    'login.demo_partners': 'Partenaires',
    'login.demo_visitors': 'Visiteurs',
    'login.demo_free': 'Gratuit',
    'login.demo_vip': 'VIP',
    'actions.save': 'Sauvegarder',
    'actions.cancel': 'Annuler',
    'actions.edit': 'Modifier',
    'actions.delete': 'Supprimer',
    'actions.add': 'Ajouter',
    'actions.view_details': 'Fiche complète',
    'actions.schedule_meeting': 'Prendre rendez-vous',
    'actions.download': 'Télécharger',
    'actions.share': 'Partager',
    'actions.close': 'Fermer',
    'actions.back': 'Retour',
    'actions.next': 'Suivant',
    'actions.previous': 'Précédent',
    'actions.submit': 'Envoyer',
    'actions.loading': 'Chargement...',
    'actions.success': 'Succès',
    'actions.error': 'Erreur',
    'actions.copy': 'Copier',
    'messages.confirm_delete': 'Êtes-vous sûr de vouloir supprimer ?',
    'messages.confirm_action': 'Êtes-vous sûr ?',
    'messages.saved': 'Sauvegardé avec succès',
    'messages.deleted': 'Supprimé avec succès',
    'messages.error': 'Une erreur s\'est produite',
    'messages.no_data': 'Aucune donnée disponible',
    'profile.name': 'Nom',
    'profile.email': 'Email',
    'profile.phone': 'Téléphone',
    'profile.company': 'Entreprise',
    'profile.sector': 'Secteur',
    'profile.description': 'Description',
    'profile.website': 'Site web',
    'profile.location': 'Localisation',
    'profile.logo': 'Logo',
    'profile.about': 'À propos',
    'networking.title': 'Réseautage',
    'networking.ai_powered': 'Propulsé par l\'IA',
    'networking.hero_title': 'Réseautage',
    'networking.hero_subtitle': 'Intelligent',
    'networking.hero_desc': 'Connectez-vous avec les leaders de l\'industrie portuaire',
    'networking.login_required': 'Connexion requise',
    'networking.hub_restricted': 'Le Hub de Réseautage est réservé aux membres inscrits.',
    'networking.discover_recommendations': 'Connectez-vous pour découvrir vos recommandations personnalisées.',
    'networking.login_button': 'Se connecter',
    'networking.signup_button': 'S\'inscrire maintenant',
    'networking.precise_matching': 'Matching Précis',
    'networking.matching_interests': 'Basé sur vos intérêts',
    'networking.global_network': 'Réseau Global',
    'networking.countries_represented': '+50 pays représentés',
    'networking.secure_access': 'Accès Sécurisé',
    'networking.verified_profiles': 'Profils vérifiés',
    'networking.ecosystem_title': 'L\'écosystème SIPORTS',
    'networking.b2b_space': 'Espace B2B pré-programmé',
    'networking.b2b_desc': 'Rencontres ciblées avec des décideurs',
    'networking.afterworks': 'Afterworks & réceptions',
    'networking.afterworks_desc': 'Networking informel et convivial',
    'networking.roundtables': 'Tables rondes sectorielles',
    'networking.roundtables_desc': 'Échanges d\'experts sur les enjeux portuaires',
    'networking.lounge_zone': 'Zone Lounge Business & VIP',
    'networking.lounge_desc': 'Espaces de travail et de détente',
    'networking.find_contacts': 'Trouvez les bons contacts',
    'networking.smart_matching': 'Matching intelligent',
    'networking.send_message': 'Envoyer un message',
    'networking.request_meeting': 'Demander un rendez-vous',
    'networking.messages': 'Messages',
    'networking.meetings': 'Rendez-vous',
    'networking.recommendations': 'Recommandations',
    'dashboard.admin_title': 'Tableau de Bord Admin',
    'dashboard.admin_subtitle': 'Gérer tous les ressources SIPORTS 2026',
    'dashboard.restricted_access': 'Accès Restreint - Administrateurs Uniquement',
    'dashboard.restricted_message': 'Cette section est réservée aux administrateurs SIPORTS',
    'dashboard.back_to_dashboard': 'Retour au Tableau de Bord',
    'dashboard.welcome': 'Bienvenue dans',
    'dashboard.loading_metrics': 'Chargement des métriques...',
    'dashboard.metrics_error': 'Erreur de chargement des métriques',
    'dashboard.retry': 'Réessayer',
    'dashboard.total_users': 'Utilisateurs Totaux',
    'dashboard.active_users': 'Utilisateurs Actifs',
    'dashboard.total_exhibitors': 'Exposants Totaux',
    'dashboard.total_partners': 'Partenaires Totaux',
    'dashboard.total_visitors': 'Visiteurs Totaux',
    'dashboard.statistics': 'Statistiques',
    'dashboard.system_health': 'Santé Système',
    'dashboard.user_growth': 'Croissance Utilisateurs',
    'dashboard.activity_overview': 'Aperçu Activité',
    'dashboard.traffic_analytics': 'Analytique Trafic',
    'dashboard.recent_activity': 'Activité Récente',
    'dashboard.registration_requests': 'Demandes d\'inscription',
    'dashboard.pending_approvals': 'Approbations En Attente',
    'dashboard.content_moderation': 'Modération Contenu',
    'dashboard.settings': 'Paramètres',
    'dashboard.reports': 'Rapports',
    'dashboard.exports': 'Exports',
    'dashboard.quick_actions': 'Actions rapides',
    'dashboard.notifications': 'Notifications',
    'dashboard.logout': 'Déconnexion',
    'dashboard.your_quotas': 'Vos Quotas',
    'dashboard.exhibitor_quotas': 'Vos Quotas Exposant',
    'dashboard.visit_activity_7days': 'Activité de Visite (7 derniers jours)',
    'dashboard.appointment_status': 'Statut des Rendez-vous',
    'dashboard.interest_areas': 'Centres d\'intérêt',
    'dashboard.visitor_engagement_7days': 'Engagement Visiteurs (7 derniers jours)',
    'dashboard.brand_exposure_7days': 'Exposition de Marque (7 derniers jours)',
    'dashboard.engagement_channels': 'Canaux d\'engagement',
    'visitor.my_tickets': 'Mes Billets',
    'visitor.appointment_confirmed': 'Rendez-vous Confirmé',
    'visitor.appointment_declined': 'Rendez-vous Refusé',
    'visitor.no_appointments': 'Aucun Rendez-vous',
    'visitor.appointment_status': 'Statut des Rendez-vous',
    'visitor.appointment_scheduled': 'Rendez-vous Programmé',
    'visitor.loading_appointments': 'Chargement des Rendez-vous...',
    'visitor.error_loading': 'Impossible de charger les Rendez-vous. Veuillez réessayer.',
    'visitor.quota_remaining': 'Quota Restant',
    'partner.event_registration': 'Inscription Événement',
    'partner.attendees': 'Participants',
    'partner.contribution_level': 'Niveau de Contribution',
    'exhibitor.visitor_interactions': 'Interactions Visiteurs',
    'exhibitor.booth_analytics': 'Analytique du Stand',
    'exhibitor.my_products': 'Mes Produits',
    'contact.title': 'Nous Contacter',
    'contact.description': 'Entrez en contact avec notre équipe',
    'contact.form_title': 'Formulaire de Contact',
    'contact.first_name': 'Prénom',
    'contact.last_name': 'Nom',
    'contact.email': 'Adresse Email',
    'contact.company': 'Entreprise',
    'contact.subject': 'Sujet',
    'contact.message': 'Message',
    'contact.send': 'Envoyer',
    'contact.success': 'Message envoyé avec succès',
    'venue.title': 'Plan de l\'événement',
    'venue.description': 'Explorez la carte interactive pour localiser les stands',
    'venue.how_to_use': 'Comment utiliser la carte',
    'venue.step1_title': 'Parcourez la carte',
    'venue.step1_desc': 'Faites défiler la carte pour voir tous les stands disponibles',
    'venue.step2_title': 'Survolez un stand',
    'venue.step2_desc': 'Passez votre souris sur un stand pour voir un aperçu',
    'venue.step3_title': 'Cliquez pour plus',
    'venue.step3_desc': 'Cliquez sur un stand pour accéder à la fiche complète',
    'news.title': 'Actualités',
    'news.description': 'Restez informé sur les derniers événements',
    'news.search_placeholder': 'Chercher une actualité',
    'news.filter': 'Filtrer',
    'news.all_categories': 'Toutes les catégories',
    'news.featured': 'En vedette',
    'news.views': 'Vues',
    'news.category': 'Catégorie',
    'partnership.title': 'Partenariats SIPORTS 2026',
    'partnership.description': 'Rejoignez l\'aventure SIPORTS en tant que partenaire',
    'partnership.premium': 'Partenaire Premium',
    'partnership.gold': 'Partenaire Or',
    'partnership.silver': 'Partenaire Argent',
    'partnership.become': 'Devenir Partenaire',
    'partnership.contact': 'Nous Contacter',
    'marketing.dashboard_title': 'Tableau de Bord Marketing',
    'marketing.welcome': 'Bienvenue dans votre espace marketing',
    'marketing.overview': 'Aperçu',
    'marketing.campaigns': 'Campagnes',
    'marketing.analytics': 'Analytique',
    'marketing.reports': 'Rapports',
    'marketing.media_library': 'Bibliothèque Médias',
    'marketing.featured_badges': 'Badges Vedettes',
    'marketing.create_campaign': 'Créer une Campagne',
    'marketing.campaign_title': 'Titre de Campagne',
    'marketing.campaign_description': 'Description',
    'marketing.campaign_start_date': 'Date de Début',
    'marketing.campaign_end_date': 'Date de Fin',
    'marketing.campaign_budget': 'Budget',
    'marketing.campaign_status': 'Statut',
    'marketing.active': 'Actif',
    'marketing.inactive': 'Inactif',
    'marketing.draft': 'Brouillon',
    'marketing.published': 'Publié',
    'marketing.pending': 'En Attente',
    'marketing.statistics': 'Statistiques',
    'marketing.views': 'Vues',
    'marketing.clicks': 'Clics',
    'marketing.conversions': 'Conversions',
    'marketing.engagement': 'Engagement',
    'marketing.reach': 'Portée',
    'marketing.impressions': 'Impressions',
    'marketing.ctr': 'Taux de Clic',
    'marketing.cpc': 'Coût par Clic',
    'marketing.roi': 'ROI',
    'marketing.filter_status': 'Filtrer par Statut',
    'marketing.filter_date': 'Filtrer par Date',
    'marketing.sort': 'Trier',
    'marketing.sort_newest': 'Plus Récent',
    'marketing.sort_oldest': 'Plus Ancien',
    'marketing.action_edit': 'Modifier',
    'marketing.action_delete': 'Supprimer',
    'marketing.action_publish': 'Publier',
    'marketing.action_duplicate': 'Dupliquer',
    'marketing.badge': 'CENTRE DE CONTRÔLE MARKETING',
    'marketing.title': 'Content Strategy Hub',
    'marketing.subtitle': 'Gérez l\'ensemble de votre contenu marketing',
    'marketing.btn_new_content': 'Nouveau Contenu',
    'marketing.tabs.explore': 'Explorer',
    'marketing.tabs.media_library': 'Médiathèque',
    'marketing.tabs.articles_news': 'Articles & News',
    'marketing.stats.total_media': 'Total Médias',
    'marketing.stats.total': 'Total',
    'marketing.stats.webinars': 'Webinaires',
    'marketing.stats.podcasts': 'Podcasts',
    'marketing.stats.capsules': 'Capsules',
    'marketing.stats.online': 'En Ligne',
    'marketing.stats.drafts': 'Brouillons',
    'marketing.filters': 'Filtres',
    'marketing.filters.filter_by': 'Filtrer par :',
    'marketing.filters.status': 'Statut :',
    'marketing.filters.all': 'Tous',
    'marketing.filters.webinars': 'Webinaires',
    'marketing.filters.podcasts': 'Podcasts',
    'marketing.filters.capsules': 'Capsules',
    'marketing.filters.published': 'Publiés',
    'marketing.filters.drafts': 'Brouillons',
    'marketing.filters.best_moments': 'Moments Forts',
    'marketing.filters.capsule_inside': 'Capsule Inside',
    'marketing.filters.webinar': 'Webinaire',
    'marketing.filters.live_studio': 'Live Studio',
    'marketing.filters.podcast': 'Podcast',
    'marketing.filters.testimonial': 'Témoignage',
    'marketing.media.add_media': 'Ajouter un média',
    'marketing.media.no_media': 'Aucun média trouvé',
    'marketing.media.no_media_found': 'Aucun média trouvé',
    'marketing.media.no_media_desc': 'Ajoutez des photos, vidéos ou podcasts pour commencer',
    'marketing.media.start_adding': 'Ajoutez des photos, vidéos ou podcasts pour commencer',
    'marketing.media.publish': 'Publier',
    'marketing.media.unpublish': 'Dépublier',
    'marketing.media.copy': 'Copier',
    'marketing.media.copied': 'Shortcode copié !',
    'marketing.media.deleted': 'Média supprimé',
    'marketing.media.added': 'Média ajouté',
    'marketing.media.error_update': 'Erreur de mise à jour',
    'marketing.media.error_delete': 'Erreur de suppression',
    'marketing.media.title': 'Titre',
    'marketing.media.description': 'Description',
    'marketing.media.type': 'Type de média',
    'marketing.media.video_url': 'URL Vidéo / Audio',
    'marketing.media.shortcode_copied': 'Shortcode copié !',
    'marketing.status.published': 'Publié',
    'marketing.status.draft': 'Brouillon',
    'marketing.articles.title': 'Gestion des Articles',
    'marketing.articles.subtitle': 'Créez et gérez les articles pour siportevent.com',
    'marketing.articles.create_new': 'Créer un Nouvel Article',
    'marketing.articles.published_count': 'Publiés',
    'marketing.articles.drafts_count': 'Brouillons',
    'marketing.articles.shortcodes_info': 'Utilisation des shortcodes',
    'marketing.articles.shortcodes_desc': 'Copiez le shortcode d\'un article pour l\'intégrer',
    'marketing.articles.example': 'Exemple :',
    'marketing.articles.no_articles': 'Aucun article pour le moment',
    'marketing.articles.author': 'Auteur',
    'marketing.articles.category': 'Catégorie',
    'marketing.articles.edit': 'Éditer',
    'marketing.articles.publish': 'Publier',
    'marketing.articles.unpublish': 'Dépublier',
    'marketing.articles.delete': 'Supprimer',
    'marketing.articles.published_badge': 'Publié',
    'marketing.articles.draft_badge': 'Brouillon',
    'subscription.title': 'Plans d\'abonnement',
    'subscription.description': 'Choisissez votre plan',
    'subscription.visitor': 'Visiteur',
    'subscription.partner': 'Partenaire',
    'subscription.exhibitor': 'Exposant',
    'subscription.features': 'Caractéristiques',
    'subscription.included': 'Inclus',
    'subscription.not_included': 'Non inclus',
    'subscription.upgrade': 'Améliorer',
    'subscription.current_plan': 'Plan actuel',
    'legal.terms_title': 'Conditions d\'utilisation',
    'legal.privacy_title': 'Politique de Confidentialité',
    'legal.cookies_title': 'Politique de Cookies',
    'legal.last_update': 'Dernière mise à jour',
    'legal.acceptance': 'Acceptation',
    'legal.usage': 'Utilisation acceptable',
    'legal.data_collection': 'Collecte de données',
    'legal.contact': 'Nous Contacter',
    'support.title': 'Support et Aide',
    'support.description': 'Nous sommes là pour vous aider',
    'support.contact_form': 'Formulaire de Contact',
    'support.faq': 'Questions Fréquentes',
    'support.technicalTitle': 'Support Technique',
    'support.technicalDesc': 'Problèmes techniques, bugs, ou difficultés d\'utilisation de la plateforme',
    'support.contactTechnical': 'Contacter le Support',
    'support.commercialTitle': 'Support Commercial',
    'support.commercialDesc': 'Questions sur les tarifs, partenariats, ou informations sur l\'événement',
    'support.contactCommercial': 'Contact Commercial',
    'support.exhibitorTitle': 'Support Exposant',
    'support.exhibitorDesc': 'Aide pour la création de profil, gestion de stand, ou fonctionnalités exposant.',
    'support.contactExhibitor': 'Support Exposant',
    'support.faqTitle': 'Questions Fréquentes',
    'support.loginProblems': 'Problèmes de connexion',
    'support.forgotPassword': 'J\'ai oublié mon mot de passe',
    'support.forgotPasswordAnswer': 'Utilisez le lien "Mot de passe oublié" sur la page de connexion.',
    'support.accountNotActivated': 'Mon compte n\'est pas activé',
    'support.accountNotActivatedAnswer': 'Vérifiez vos emails ou contactez le support pour l\'activation manuelle',
    'support.platformFeatures': 'Fonctionnalités de la plateforme',
    'support.howToAppointment': 'Comment prendre un rendez-vous ?',
    'support.howToAppointmentAnswer': 'Accédez à la section "Networking" et sélectionnez un exposant.',
    'support.howToEditProfile': 'Comment modifier mon profil ?',
    'support.howToEditProfileAnswer': 'Allez dans "Mon Profil" dans le menu utilisateur.',
    'support.immediateHelp': 'Besoin d\'aide immédiate ?',
    'support.teamAvailable': 'Notre équipe de support est disponible pour répondre à toutes vos questions.',
    'support.emergencies': 'Urgences',
    'support.openTicket': 'Ouvrir un ticket',
    'support.sendEmail': 'Envoyer un email',
    'resetPassword.minLength': 'Le mot de passe doit contenir au moins 12 caractères',
    'resetPassword.maxLength': 'Le mot de passe ne doit pas dépasser 72 caractères',
    'resetPassword.uppercaseRequired': 'Doit contenir au moins une majuscule',
    'resetPassword.lowercaseRequired': 'Doit contenir au moins une minuscule',
    'resetPassword.digitRequired': 'Doit contenir au moins un chiffre',
    'resetPassword.specialRequired': 'Doit contenir au moins un caractère spécial',
    'resetPassword.confirmRequired': 'Veuillez confirmer votre mot de passe',
    'resetPassword.passwordsMismatch': 'Les mots de passe ne correspondent pas',
    'resetPassword.supabaseNotConfigured': 'Supabase non configuré.',
    'resetPassword.errorResetting': 'Erreur lors de la réinitialisation du mot de passe.',
    'resetPassword.success': '✅ Mot de passe défini avec succès. Vous pouvez maintenant vous connecter.',
    'resetPassword.title': 'Réinitialiser le mot de passe',
    'resetPassword.linkExpired': 'Le lien de réinitialisation semble incomplet ou expiré. Assurez-vous d\'avoir cliqué sur le lien complet dans l\'email.',
    'resetPassword.newPasswordLabel': 'Nouveau mot de passe',
    'resetPassword.newPasswordPlaceholder': 'Nouveau mot de passe (min. 12 caractères)',
    'resetPassword.confirmLabel': 'Confirmer le mot de passe',
    'resetPassword.confirmPlaceholder': 'Confirmer le mot de passe',
    'resetPassword.loading': 'En cours...',
    'resetPassword.submit': 'Changer le mot de passe',
    'signupSuccess.welcomeMessage': 'Bienvenue sur SIPORTS 2026 !',
    'signupSuccess.title': '🎉 Inscription Réussie !',
    'signupSuccess.visitorSuccess': 'Félicitations ! Votre compte visiteur a été créé avec succès.',
    'signupSuccess.registrationSuccess': 'Félicitations ! Votre demande d\'inscription a été soumise avec succès !',
    'signupSuccess.exhibitor': 'exposant',
    'signupSuccess.partner': 'partenaire',
    'signupSuccess.registrationEmail': 'Email d\'inscription',
    'signupSuccess.accessTo': '✅ Vous avez accès à :',
    'signupSuccess.nextSteps': '📋 Prochaines Étapes',
    'signupSuccess.catalogFeature': 'Parcourez les 300 exposants de SIPORTS 2026',
    'signupSuccess.catalogLabel': 'Catalogue complet :',
    'signupSuccess.programFeature': 'Découvrez les conférences et événements',
    'signupSuccess.programLabel': 'Programme :',
    'signupSuccess.networkingFeature': 'Planifiez vos rendez-vous avec les exposants',
    'signupSuccess.networkingLabel': 'Networking :',
    'signupSuccess.profileFeature': 'Complétez votre profil et explorez les opportunités',
    'signupSuccess.profileLabel': 'Profil :',
    'signupSuccess.confirmationEmail': 'Un email récapitulatif vous a été envoyé. Veuillez vérifier votre boîte de réception.',
    'signupSuccess.confirmationLabel': 'Email de confirmation :',
    'signupSuccess.validationStep': 'Notre équipe examinera votre demande sous 48 heures ouvrées.',
    'signupSuccess.validationLabel': 'Validation :',
    'signupSuccess.activationStep': 'Une fois validé, vous recevrez un email avec vos accès complets.',
    'signupSuccess.activationLabel': 'Activation :',
    'signupSuccess.goToDashboard': 'Aller au tableau de bord',
    'signupSuccess.autoRedirect': 'Redirection automatique dans {{countdown}}s...',
    'signupSuccess.login': 'Se connecter',
    'signupSuccess.questions': 'Questions ?',
    'signupSuccess.contactSupport': 'Contactez notre support',
    'payment.alreadyPremium': 'Vous êtes déjà abonné Premium VIP !',
    'payment.userNotConnected': 'Utilisateur non connecté',
    'payment.requestCreated': 'Demande de paiement créée',
    'payment.requestError': 'Erreur lors de la création de la demande',
    'payment.stripeError': 'Erreur lors du paiement Stripe',
    'payment.stripeErrorToast': 'Erreur de paiement Stripe',
    'payment.paypalSuccess': 'Paiement PayPal réussi !',
    'payment.paypalCaptureError': 'Erreur lors de la capture PayPal',
    'payment.paypalErrorToast': 'Erreur de paiement PayPal',
    'payment.cmiError': 'Erreur lors du paiement CMI',
    'payment.cmiErrorToast': 'Erreur de paiement CMI',
    'payment.selectImage': 'Veuillez sélectionner une image',
    'payment.photoMaxSize': 'La photo ne doit pas dépasser 5MB',
    'payment.authCreationError': 'Erreur lors de la création du compte sécurisé',
    'payment.profileCompleted': 'Profil VIP complété avec succès',
    'payment.profileUpdateError': 'Erreur lors de la mise à jour du profil',
    'payment.simulatedSuccess': '🎉 Paiement VIP simulé avec succès !',
    'payment.simulationError': 'Erreur lors de la simulation du paiement',
    'payment.preparing': 'Préparation du paiement...',
    'payment.redirecting': 'Redirection vers le paiement...',
    'payment.pleaseWait': 'Veuillez patienter, nous préparons votre demande de paiement par virement bancaire.',
    'login.paymentRequired': 'Paiement requis pour accéder au tableau de bord VIP.',
    'login.paymentRequiredFull': 'Paiement requis pour accéder au tableau de bord VIP. Veuillez finaliser votre paiement.',
    'login.connectionError': 'Erreur de connexion',
    'login.fillAllFields': 'Veuillez remplir tous les champs',
    'login.wrongCredentials': 'Email ou mot de passe incorrect',
    'login.googleError': 'Erreur lors de la connexion Google',
    'login.linkedinError': 'Erreur lors de la connexion LinkedIn',
    'login.demoMarketing': 'Marketing',
    'login.demoServiceClient': 'Service Clientèle',
    'login.demoAdmin': 'Administrateur',
    'login.demoConnect': 'Connexion',
    'login.demoBadgeConnect': 'Connexion Impression Badges',
    'login.demoAdminConnect': 'Connexion Admin',
    'login.demoPasswordNote': 'Mot de passe: Demo2026! (Service2026! pour service clientèle)',
    'login.quickAccess': 'Accès rapide - Démo',
    'login.testFeatures': 'Testez toutes les fonctionnalités',
    'login.viewAccounts': 'Voir les comptes',
    'login.noAccount': 'Pas encore de compte ?',
    'login.createAccount': 'Créer un compte',
    'sub.hero.badge': 'À la rencontre des ports du monde',
    'sub.hero.title1': 'Visiter le Salon International des',
    'sub.hero.titleHighlight1': 'Ports',
    'sub.hero.title2': 'et de leur',
    'sub.hero.titleHighlight2': 'Écosystème',
    'sub.hero.title3': 'et de leur Écosystème',
    'sub.hero.desc': 'Du 01 au 03 Avril 2026 au Parc d\'Exposition Mohammed VI à El Jadida Maroc, le Salon SIPORTS vous ouvre ses portes pour découvrir, rencontrer et collaborer avec les plus grands acteurs du secteur portuaire mondial. Que vous soyez professionnel, investisseur, industriel ou universitaire : ce rendez-vous est conçu pour vous.',
    'sub.hero.badgeBtn': 'Je demande mon badge visiteur',
    'sub.hero.vipBtn': 'Pass VIP',
    'sub.stat1.label': 'Exposants internationaux',
    'sub.stat2.label': 'Visiteurs professionnels',
    'sub.stat3.label': 'Pays représentés',
    'sub.stat4.label': 'Conférences et ateliers',
    'sub.whySection.label': 'Pourquoi visiter ?',
    'sub.whySection.title': 'Pourquoi visiter SIPORTS ?',
    'sub.whySection.title1': 'Pourquoi visiter',
    'sub.whySection.title2': '?',
    'sub.whySection.subtitle': 'Une expérience immersive au cœur de l\'industrie portuaire internationale',
    'sub.whySection.worldEvent': 'Un événement d\'envergure mondiale',
    'sub.whySection.worldEventDesc': 'Le plus grand salon portuaire d\'Afrique réunissant les leaders du secteur',
    'sub.why1': 'Explorez les dernières innovations en matière de port intelligent, connectivité maritime, infrastructures durables et automatisation logistique.',
    'sub.why2': 'Assistez à 30 conférences, panels et ateliers techniques animés par des experts de renommée mondiale.',
    'sub.why3': 'Bénéficiez de sessions de networking ciblé pour nouer des contacts de qualité.',
    'sub.why4': 'Découvrez les formations, métiers d\'avenir et opportunités de carrière',
    'sub.why5': 'Profitez d\'avantages exclusifs et de networking premium',
    'sub.pav1.title': 'Organismes Institutionnels',
    'sub.pav1.desc': 'Les stratégies globales et coopérations internationales',
    'sub.pav2.title': 'Industrie Portuaire',
    'sub.pav2.desc': 'Équipements, digitalisation, durabilité',
    'sub.pav3.title': 'Gestion et Exploitation',
    'sub.pav3.desc': 'Innovations, expertises et corridors',
    'sub.pav4.title': 'Académique & Formation',
    'sub.pav4.desc': 'Carrières, formations, simulateurs',
    'sub.pav5.title': 'Musée des Ports',
    'sub.pav5.desc': 'Patrimoine, art, mémoire et innovation culturelle',
    'sub.pavSection.label': 'Découvrez les 5 univers de SIPORTS',
    'sub.pavSection.title': 'Visiteurs, explorez nos pavillons',
    'sub.pavSection.title1': 'Découvrez les 5 univers de',
    'sub.pavSection.titleHighlight': 'SIPORTS',
    'sub.needInfo': 'Besoin d\'informations ?',
    'sub.contactUs': 'Contactez-nous',
    'sub.plans.label': 'Forfaits Visiteurs',
    'sub.plans.title': 'Choisissez le forfait qui correspond le mieux à vos besoins',
    'sub.plans.subtitle': 'Maximisez votre expérience au SIPORTS',
    'sub.plans.visitors': 'Visiteurs',
    'sub.plans.exhibitors': 'Exposants',
    'sub.plans.partners': 'Partenaires',
    'sub.plans.features': 'Fonctionnalités',
    'sub.plans.benefits': 'Avantages',
    'sub.plans.onQuote': 'Sur devis',
    'sub.plans.free': 'Gratuit',
    'sub.plans.customPlan': 'Besoin d\'un plan personnalisé ?',
    'sub.plans.customPlanDesc': 'Contactez-nous',
    'sub.how.title': 'Comment ça marche ?',
    'sub.how.step1Title': 'Choix de l\'offre',
    'sub.how.step1Desc': 'Sélectionnez l\'offre qui correspond à vos besoins',
    'sub.how.step2Title': 'Paiement sécurisé',
    'sub.how.step2Desc': 'Paiement en ligne ou via un commercial. Validation par administrateur automatique.',
    'sub.how.step3Title': 'Accès immédiat',
    'sub.how.step3Desc': 'Accès instantané à votre tableau de bord et à tous les avantages de votre offre.',
    'sub.info.label': 'Organisez votre visite !',
    'sub.info.title': 'Infos pratiques',
    'sub.info.venue': 'Lieu',
    'sub.info.venueAddr': 'Parc d\'Exposition Mohammed VI à El Jadida Maroc',
    'sub.info.dates': 'Dates',
    'sub.info.datesVal': '1-3 Avril 2026',
    'sub.info.hours': 'Horaires',
    'sub.info.hoursVal': '9h30 à 18h',
    'sub.info.entry': 'Entrée',
    'sub.info.entryVal': 'Sur badge nominatif',
    'sub.info.contact': 'Contact Organisation',
    'sub.info.contactOrg': 'LINECO EVENTS',
    'sub.info.contactAddr': '19, rue Badr Assayab – 1er étage n°2, Casablanca – Maroc',
    'sub.info.contactBtn': 'Nous contacter',
    'sub.faq.title': 'Questions fréquentes',
    'sub.faq.q1': 'Puis-je changer d\'offre après inscription ?',
    'sub.faq.a1': 'Oui, vous pouvez faire évoluer votre offre à tout moment. Un administrateur validera les changements.',
    'sub.faq.q2': 'Quel est le délai d\'activation de mon compte ?',
    'sub.faq.a2': 'Une fois le paiement validé, votre accès est activé dans les 24 heures.',
    'sub.faq.q3': 'Y a-t-il une facturation récurrente ?',
    'sub.faq.a3': 'Non, sauf mention contraire. Les offres sont forfaitaires pour le salon 2026.',
    'sub.faq.q4': 'Comment contacter le support ?',
    'sub.faq.a4': 'Contactez notre équipe via le formulaire du site ou par e-mail : contact@siportevent.com',
    'sub.visitorFree.name': 'Visiteur Gratuit',
    'sub.visitorFree.desc': 'Accès basique au salon',
    'sub.visitorFree.cta': 'S\'inscrire gratuitement',
    'sub.visitorFree.f1': 'Accès au site du salon',
    'sub.visitorFree.f2': 'Consultation des exposants',
    'sub.visitorFree.f3': 'Demandes de rendez-vous',
    'sub.visitorFree.f4': 'Messagerie directe',
    'sub.visitorFree.f5': 'Mini-sites des exposants',
    'sub.visitorFree.f6': 'Événements en direct',
    'sub.visitorFree.b1': 'Accès complet à l\'exposition',
    'sub.visitorFree.b2': 'Consultation des profils publics',
    'sub.visitorFree.b3': 'Voir les événements et conférences',
    'sub.visitorFree.b4': 'Badge visiteur gratuit',
    'sub.visitorPremium.name': 'Visiteur Premium',
    'sub.visitorPremium.desc': 'Accès étendu + 5 rendez-vous',
    'sub.visitorPremium.cta': 'Inscription Premium',
    'sub.visitorPremium.f1': 'Accès au site du salon',
    'sub.visitorPremium.f2': 'Consultation des exposants',
    'sub.visitorPremium.f3': 'Demandes de rendez-vous (5)',
    'sub.visitorPremium.f4': 'Messagerie directe',
    'sub.visitorPremium.f5': 'Mini-sites des exposants',
    'sub.visitorPremium.f6': 'Événements en direct',
    'sub.visitorPremium.b1': '5 demandes de rendez-vous actives',
    'sub.visitorPremium.b2': 'Messagerie directe avec les exposants',
    'sub.visitorPremium.b3': 'Badge Premium avec QR code',
    'sub.visitorPremium.b4': 'Accès aux conférences',
    'sub.visitorVip.name': 'Visiteur VIP',
    'sub.visitorVip.desc': 'Accès prioritaire + 10 rendez-vous',
    'sub.visitorVip.cta': 'Inscription Visiteur VIP',
    'sub.visitorVip.f1': 'Accès au site du salon',
    'sub.visitorVip.f2': 'Consultation des exposants',
    'sub.visitorVip.f3': 'Demandes de rendez-vous (10)',
    'sub.visitorVip.f4': 'Messagerie directe',
    'sub.visitorVip.f5': 'Mini-sites des exposants',
    'sub.visitorVip.f6': 'Événements en direct',
    'sub.visitorVip.f7': 'Badge VIP prioritaire',
    'sub.visitorVip.f8': 'Accès prioritaire aux nouveautés',
    'sub.visitorVip.b1': '10 demandes de rendez-vous actives',
    'sub.visitorVip.b2': 'Messagerie directe avec les exposants',
    'sub.visitorVip.b3': 'Badge VIP virtuel avec QR code',
    'sub.visitorVip.b4': 'Priorité dans les algorithmes de recommandation',
    'sub.visitorVip.b5': 'Accès exclusif aux webinaires',
    'sub.visitorVip.b6': 'Support prioritaire',
    'sub.exh9m.name': 'Exposant 9m² (Base)',
    'sub.exh9m.desc': 'Profil & présence de base',
    'sub.exh9m.cta': 'Inscription Exposant',
    'sub.exh9m.f1': 'Profil d\'entreprise détaillé',
    'sub.exh9m.f2': 'Logo sur le site',
    'sub.exh9m.f3': 'Présentation courte',
    'sub.exh9m.f4': 'Mini-site personnalisé',
    'sub.exh9m.f5': 'Gestion des rendez-vous',
    'sub.exh9m.f6': 'Store produits',
    'sub.exh9m.f7': 'Tableau de bord exposant',
    'sub.exh9m.f8': 'Formulaire de contact',
    'sub.exh9m.b1': 'Profil d\'entreprise sur la plateforme',
    'sub.exh9m.b2': 'Présence sur le site',
    'sub.exh9m.b3': 'Logo et description',
    'sub.exh9m.b4': 'Formulaire de contact basique',
    'sub.exh9m.b5': 'Accès tableau de bord',
    'sub.exh18m.name': 'Exposant 18m² (Standard)',
    'sub.exh18m.desc': 'Mini-site + 15 rendez-vous',
    'sub.exh18m.cta': 'Inscription Exposant',
    'sub.exh18m.f1': 'Profil d\'entreprise enrichi',
    'sub.exh18m.f2': 'Logo sur le site',
    'sub.exh18m.f3': 'Mini-site personnalisé',
    'sub.exh18m.f4': 'Gestion des rendez-vous (15)',
    'sub.exh18m.f5': 'Store produits & filtrage',
    'sub.exh18m.f6': 'URL personnalisée',
    'sub.exh18m.f7': 'Tableau de bord complet',
    'sub.exh18m.f8': 'Support standard',
    'sub.exh18m.b1': 'Mini-site dédié avec URL personnalisée',
    'sub.exh18m.b2': '15 créneaux de rendez-vous disponibles',
    'sub.exh18m.b3': 'Présentation complète de produits/services',
    'sub.exh18m.b4': 'Système de filtrage des visiteurs',
    'sub.exh18m.b5': 'Messagerie intégrée',
    'sub.exh18m.b6': 'Accès aux analytics basiques',
    'sub.exh36m.name': 'Exposant 36m² (Premium)',
    'sub.exh36m.desc': 'Mise en avant + 30 rendez-vous',
    'sub.exh36m.cta': 'Inscription Exposant',
    'sub.exh36m.f1': 'Profil d\'entreprise premium',
    'sub.exh36m.f2': 'Mini-site personnalisé',
    'sub.exh36m.f3': 'Mise en avant "À la Une"',
    'sub.exh36m.f4': 'Gestion des rendez-vous (30)',
    'sub.exh36m.f5': 'Store produits avancé',
    'sub.exh36m.f6': 'Accès API Supabase limité',
    'sub.exh36m.f7': 'Outils de réseautage avancés',
    'sub.exh36m.f8': 'Support prioritaire',
    'sub.exh36m.f9': 'Badge virtuel personnalisé',
    'sub.exh36m.b1': 'Mise en avant sur la page d\'accueil',
    'sub.exh36m.b2': '30 créneaux de rendez-vous',
    'sub.exh36m.b3': 'Mini-site premium avec médias illimités',
    'sub.exh36m.b4': 'Intégration API personnalisée',
    'sub.exh36m.b5': 'Messagerie directe et chat',
    'sub.exh36m.b6': 'Analytics détaillés',
    'sub.exh36m.b7': 'Support technique prioritaire',
    'sub.exh54m.name': 'Exposant 54m²+ (Elite)',
    'sub.exh54m.desc': 'Visibilité maximale + créneaux illimités',
    'sub.exh54m.cta': 'Inscription Exposant',
    'sub.exh54m.f1': 'Profil d\'entreprise VIP',
    'sub.exh54m.f2': 'Mini-site Premium',
    'sub.exh54m.f3': 'Mise en avant permanente',
    'sub.exh54m.f4': 'Rendez-vous illimités',
    'sub.exh54m.f5': 'Store produits complet',
    'sub.exh54m.f6': 'Accès API Supabase complet',
    'sub.exh54m.f7': 'Outils de réseautage illimités',
    'sub.exh54m.f8': 'Support VIP 24/7',
    'sub.exh54m.f9': 'Personnalisation avancée',
    'sub.exh54m.b1': 'Mise en avant permanente et prioritaire',
    'sub.exh54m.b2': 'Créneaux de rendez-vous illimités',
    'sub.exh54m.b3': 'Mini-site avec scripts personnalisés',
    'sub.exh54m.b4': 'Accès API complet pour intégrations',
    'sub.exh54m.b5': 'Stockage médias illimité',
    'sub.exh54m.b6': 'Chat et messagerie illimitée',
    'sub.exh54m.b7': 'Support technique VIP dédié',
    'sub.exh54m.b8': 'Priorité algorithmique',
    'sub.partMuseum.name': 'Partenaire Musée (20k$)',
    'sub.partMuseum.desc': 'Présence & mini-site',
    'sub.partMuseum.cta': 'Inscription Partenaire',
    'sub.partMuseum.f1': 'Logo sur le site',
    'sub.partMuseum.f2': 'Mini-site dédié',
    'sub.partMuseum.f3': 'Bannière rotative',
    'sub.partMuseum.f4': 'Présence newsletter',
    'sub.partMuseum.f5': 'Vidéos "Inside SIPORT"',
    'sub.partMuseum.f6': 'Interview Live Studio',
    'sub.partMuseum.f7': 'Inclusion podcast',
    'sub.partMuseum.f8': 'Priorité algorithmique',
    'sub.partMuseum.b1': 'Logo en 4ème ligne sur le site',
    'sub.partMuseum.b2': 'Mini-site Premium Exposure',
    'sub.partMuseum.b3': 'Bannière Web rotative',
    'sub.partMuseum.b4': 'Présence dans e-mailings',
    'sub.partMuseum.b5': 'Capsules vidéo marquées',
    'sub.partMuseum.b6': 'Interview "Meet The Leaders"',
    'sub.partMuseum.b7': 'Mention "Best Moments"',
    'sub.partSilver.name': 'Partenaire Silver (48k$)',
    'sub.partSilver.desc': 'Visibilité renforcée 3ème ligne',
    'sub.partSilver.cta': 'Inscription Partenaire',
    'sub.partSilver.f1': 'Logo en 3ème ligne',
    'sub.partSilver.f2': 'Mini-site dédié',
    'sub.partSilver.f3': 'Bannière rotative',
    'sub.partSilver.f4': 'Section "Top Innovations"',
    'sub.partSilver.f5': 'Présence newsletters',
    'sub.partSilver.f6': 'Capsules vidéo sponsorisées',
    'sub.partSilver.f7': 'Podcast SIPORT Talks',
    'sub.partSilver.f8': 'Interview Live Studio',
    'sub.partSilver.f9': 'Testimonial vidéo (1 min)',
    'sub.partSilver.b1': 'Logo visible en 3ème ligne prioritaire',
    'sub.partSilver.b2': 'Présence dans toutes les newsletters',
    'sub.partSilver.b3': 'Mini-site avec actualités complètes',
    'sub.partSilver.b4': 'Capsules vidéo "Inside SIPORT"',
    'sub.partSilver.b5': 'Interview audio dans le Podcast',
    'sub.partSilver.b6': 'Interview Live Studio "Meet The Leaders"',
    'sub.partSilver.b7': 'Vidéo testimonial diffusée',
    'sub.partSilver.b8': '50 rendez-vous mensuels',
    'sub.partGold.name': 'Partenaire Gold (68k$)',
    'sub.partGold.desc': 'Visibilité premium 2ème ligne',
    'sub.partGold.cta': 'Inscription Partenaire',
    'sub.partGold.f1': 'Logo en 2ème ligne',
    'sub.partGold.f2': 'Mini-site premium',
    'sub.partGold.f3': 'Bannière Web rotative',
    'sub.partGold.f4': 'Section "Top Innovations"',
    'sub.partGold.f5': 'Newsletter en 2ème ligne',
    'sub.partGold.f6': 'Capsules vidéo sponsorisées',
    'sub.partGold.f7': 'Podcast SIPORT Talks',
    'sub.partGold.f8': 'Interview Live Studio',
    'sub.partGold.f9': 'Testimonial vidéo (2 min)',
    'sub.partGold.f10': 'Support prioritaire',
    'sub.partGold.b1': 'Logo visible en 2ème ligne prioritaire',
    'sub.partGold.b2': 'Tous les canaux web & email',
    'sub.partGold.b3': 'Mini-site "SIPORT Premium Exposure"',
    'sub.partGold.b4': 'Capsules vidéo & brand awareness',
    'sub.partGold.b5': 'Interview audio Podcast',
    'sub.partGold.b6': 'Interview Live Studio prioritaire',
    'sub.partGold.b7': 'Vidéo testimonial 2 min diffusée',
    'sub.partGold.b8': '100 rendez-vous mensuels',
    'sub.partGold.b9': 'Support technique prioritaire',
    'sub.partPlatinum.name': 'Partenaire Platinium (98k$)',
    'sub.partPlatinum.desc': 'Visibilité maximale 1ère ligne + illimité',
    'sub.partPlatinum.cta': 'Inscription Partenaire',
    'sub.partPlatinum.f1': 'Logo en 1ère ligne partout',
    'sub.partPlatinum.f2': 'Mini-site premium',
    'sub.partPlatinum.f3': 'Bannière Web rotative',
    'sub.partPlatinum.f4': 'Section "Top Innovations"',
    'sub.partPlatinum.f5': 'Newsletters en 1ère ligne',
    'sub.partPlatinum.f6': 'Webinaires sponsorisés',
    'sub.partPlatinum.f7': 'Capsules vidéo "Inside SIPORT"',
    'sub.partPlatinum.f8': 'Podcast SIPORT Talks',
    'sub.partPlatinum.f9': 'Interview Live Studio prioritaire',
    'sub.partPlatinum.f10': 'Testimonial vidéo (3 min)',
    'sub.partPlatinum.f11': 'Support VIP 24/7',
    'sub.partPlatinum.b1': 'Logo en 1ère ligne sur tous les canaux',
    'sub.partPlatinum.b2': 'Mini-site "Premium Exposure" complet',
    'sub.partPlatinum.b3': 'Webinaires sponsorisés avec replay',
    'sub.partPlatinum.b4': 'Capsules vidéo exclusives marquées',
    'sub.partPlatinum.b5': 'Inclusion podcast prioritaire',
    'sub.partPlatinum.b6': 'Interview Live Studio "Meet The Leaders"',
    'sub.partPlatinum.b7': 'Vidéo testimonial 3 min premium',
    'sub.partPlatinum.b8': 'Rendez-vous illimités',
    'sub.partPlatinum.b9': 'Support VIP dédié',
    'sub.partPlatinum.b10': 'Priorité algorithmique maximale',
    'partSupport.pageTitle': 'Support Partenaire',
    'partSupport.pageSubtitle': 'Assistance technique, formation et support commercial dédiés',
    'partSupport.backToDashboard': 'Retour au tableau de bord',
    'partSupport.premiumSupport': 'Support Premium 24/7',
    'partSupport.responseTime': 'Temps de réponse: 2h 15m',
    'partSupport.activeTickets': 'Tickets actifs',
    'partSupport.resolvedThisMonth': 'Résolus ce mois',
    'partSupport.avgResponseTime': 'Temps de réponse moyen',
    'partSupport.clientSatisfaction': 'Satisfaction client',
    'partSupport.quickActions': 'Actions Rapides',
    'partSupport.createTicket': 'Créer un ticket',
    'partSupport.createTicketDesc': 'Signaler un problème ou faire une demande',
    'partSupport.contactSupport': 'Contacter le support',
    'partSupport.contactSupportDesc': 'Parler directement avec un conseiller',
    'partSupport.knowledgeBase': 'Base de connaissances',
    'partSupport.knowledgeBaseDesc': 'Trouver des réponses aux questions fréquentes',
    'partSupport.scheduleTraining': 'Planifier une formation',
    'partSupport.scheduleTrainingDesc': 'Réserver une session de formation personnalisée',
    'partSupport.recentTickets': 'Tickets Récents',
    'partSupport.ticket': 'Ticket',
    'partSupport.statusInProgress': 'En cours',
    'partSupport.statusResolved': 'Résolu',
    'partSupport.statusPending': 'En attente',
    'partSupport.statusClosed': 'Fermé',
    'partSupport.priorityHigh': 'Haute',
    'partSupport.priorityMedium': 'Moyenne',
    'partSupport.priorityLow': 'Basse',
    'partSupport.category': 'Catégorie:',
    'partSupport.createdAt': 'Créé le:',
    'partSupport.lastUpdate': 'Dernière MAJ:',
    'partSupport.assignedTo': 'Assigné à:',
    'partSupport.reply': 'Répondre',
    'partSupport.markResolved': 'Marquer résolu',
    'partSupport.supportCategories': 'Catégories de Support',
    'partSupport.technicalSupport': 'Support Technique',
    'partSupport.technicalSupportDesc': 'Problèmes techniques, bugs, intégrations',
    'partSupport.trainingOnboarding': 'Formation & Onboarding',
    'partSupport.trainingOnboardingDesc': 'Sessions de formation, guides d\'utilisation et support dédié',
    'partSupport.commercial': 'Commercial',
    'partSupport.commercialDesc': 'Questions commerciales, contrats, facturation',
    'partSupport.administrative': 'Administratif',
    'partSupport.administrativeDesc': 'Mises à jour profil, documents, accès',
    'partSupport.activeTicketsLabel': 'Tickets actifs:',
    'partSupport.avgResolution': 'Résolution moyenne:',
    'partSupport.contactSupportTitle': 'Contact Support',
    'partSupport.phoneSupport': 'Support Téléphonique',
    'partSupport.phoneAvailability': '24/7 - Disponible immédiatement',
    'partSupport.emailSupport': 'Support Email',
    'partSupport.emailResponseTime': 'Réponse sous 2h',
    'partSupport.liveChat': 'Chat en Ligne',
    'partSupport.liveChatAvailability': 'Disponible 8h-18h',
    'partSupport.liveChatLocation': 'Chat en bas à droite',
    'partSupport.ticket1Title': 'Problème d\'accès au tableau de bord',
    'partSupport.ticket1Desc': 'Impossible d\'accéder à mon espace partenaire',
    'partSupport.ticket1Category': 'Technique',
    'partSupport.ticket2Title': 'Demande de formation équipe commerciale',
    'partSupport.ticket2Desc': 'Besoin de formation sur les nouveaux outils de prospection.',
    'partSupport.ticket2Category': 'Formation',
    'partSupport.ticket3Title': 'Mise à jour des informations société',
    'partSupport.ticket3Desc': 'Changement d\'offre vers plan supérieur',
    'partSupport.ticket3Category': 'Administratif',
    'detail.overview': 'Aperçu',
    'detail.contact': 'Nous Contacter',
    'detail.book_appointment': 'Réserver un Rendez-vous',
    'detail.add_favorite': 'Ajouter aux Favoris',
    'detail.share': 'Partager',
    'detail.products': 'Produits',
    'detail.services': 'Services',
    'detail.team': 'Équipe',
    'networking.description': 'Connexions intelligentes basées sur votre profil',
    'networking.connections': 'Mes Connexions',
    'networking.favorites': 'Mes Favoris',
    'networking.find_matches': 'Trouver des correspondances',
    'networking.compatibility': 'Compatibilité',
    'api.title': 'API SIPORTS',
    'api.description': 'Intégrez SIPORTS dans vos applications',
    'api.documentation': 'Documentation API',
    'api.authentication': 'Authentification',
    'api.endpoints': 'Points de Terminaison',
    'api.rate_limiting': 'Limitation de Débit',
    'api.webhook': 'Webhooks',
    'api.get_started': 'Commencer',
    'badge.title': 'Mon Badge',
    'badge.badge_info': 'Informations du Badge',
    'badge.access_level': 'Niveau d\'accès',
    'badge.qr_code': 'Code QR',
    'badge.download': 'Télécharger',
    'badge.print': 'Imprimer',
    'badge.share': 'Partager',
    'enhanced_networking.title': 'Réseautage Avancé',
    'enhanced_networking.ai_matching': 'Appariement IA',
    'enhanced_networking.analytics': 'Analytique',
    'enhanced_networking.compatibility_score': 'Score de Compatibilité',
    'enhanced_networking.mutual_connections': 'Connexions Mutuelles',
    'upgrade.partner_title': 'Plans d\'abonnement Partenaire',
    'upgrade.partner_description': 'Élevez votre visibilité au SIPORTS 2026',
    'upgrade.visitor_title': 'Mises à Jour de Visiteur',
    'upgrade.visitor_description': 'Accédez aux fonctionnalités premium',
    'upgrade.payment_method': 'Méthode de Paiement',
    'upgrade.card': 'Carte de Crédit',
    'upgrade.paypal': 'PayPal',
    'upgrade.bank_transfer': 'Virement Bancaire',
    'upgrade.amount': 'Montant',
    'upgrade.total': 'Total',
    'payment.error.missingReference': 'Veuillez renseigner la référence du virement',
    'payment.success.proofSubmitted': 'Justificatif enregistré ! Votre paiement sera validé sous 24-48h.',
    'payment.error.generic': 'Erreur: {{message}}',
    'common.copiedToClipboard': 'Copié dans le presse-papier',
    'payment.error.notFound': 'Utilisateur ou demande de paiement introuvable.',
    'payment.instructions.title': 'Instructions de Paiement',
    'payment.instructions.subtitle': 'Pass Premium VIP - ',
    'payment.status.pendingTitle': 'Demande en attente de validation',
    'payment.status.pendingDescription': 'Votre demande a bien été reçue. Veuillez procéder au virement pour finaliser votre inscription.',
    'payment.status.approvedTitle': 'Paiement approuvé !',
    'payment.status.approvedDescription': 'Vous avez maintenant accès au Pass Premium VIP.',
    'payment.status.rejectedTitle': 'Paiement refusé',
    'payment.status.rejectedReason': 'Raison: ',
    'payment.bank.title': 'Informations Bancaires',
    'payment.bank.bankName': 'Banque',
    'payment.bank.accountHolder': 'Titulaire du compte',
    'payment.bank.iban': 'IBAN',
    'payment.bank.bic': 'BIC/SWIFT',
    'payment.bank.mandatoryReference': 'Référence obligatoire',
    'payment.bank.referenceNote': 'À indiquer impérativement dans le libellé du virement',
    'payment.instructions.stepsTitle': 'Instructions',
    'payment.instructions.step1': 'Effectuez un virement de <strong>{{amount}} EUR</strong> sur le compte indiqué.',
    'payment.instructions.step2': 'Indiquez la référence <strong>{{reference}}</strong> dans le libellé.',
    'payment.instructions.step3': 'Conservez votre preuve de virement.',
    'payment.instructions.step4': 'Renseignez la référence ci-dessous pour validation.',
    'payment.proof.title': 'Soumettre votre justificatif',
    'payment.proof.referenceLabel': 'Référence du virement',
    'payment.proof.referenceHint': 'Numéro de transaction ou référence bancaire',
    'payment.proof.urlLabel': 'URL du justificatif (optionnel)',
    'payment.proof.urlHint': 'Lien vers votre justificatif (Google Drive, Dropbox, etc.)',
    'payment.proof.submitting': 'Envoi en cours...',
    'payment.proof.submit': 'Soumettre le justificatif',
    'payment.proof.submittedTitle': 'Justificatif soumis',
    'payment.proof.submittedDate': 'Soumis le {{date}}',
    'payment.proof.processingNote': 'Votre demande est en cours de traitement. Vous serez notifié dès validation.',
    'payment.support.needHelp': 'Besoin d\'aide ?',
    'payment.success.confirmed': 'Paiement confirmé ! Vous êtes maintenant VIP.',
    'payment.success.validated': 'Paiement validé ! Vous êtes maintenant VIP.',
    'payment.success.welcomeVip': 'Bienvenue dans le Club VIP !',
    'payment.error.verificationFailed': 'Impossible de vérifier le paiement. Contactez le support.',
    'payment.error.verificationError': 'Erreur lors de la vérification du paiement',
    'payment.verification.loading': 'Vérification du paiement...',
    'payment.verification.pleaseWait': 'Veuillez patienter quelques instants',
    'payment.error.title': 'Erreur de paiement',
    'payment.error.retry': 'Réessayer le paiement',
    'payment.error.contactSupport': 'Contacter le support',
    'payment.success.title': 'Paiement réussi !',
    'payment.success.welcomeClub': 'Bienvenue dans le Club VIP',
    'payment.success.description': 'Votre Pass Premium VIP est maintenant actif ! Vous avez désormais accès à toutes les fonctionnalités exclusives de SIPORT 2026.',
    'payment.success.emailSent': 'Un email de confirmation a été envoyé à <strong>{{email}}</strong>',
    'payment.success.nextSteps': 'Prochaines étapes',
    'payment.success.step1Title': 'Téléchargez votre badge VIP',
    'payment.success.step1Desc': 'Badge premium avec photo et QR code sécurisé',
    'payment.success.step2Title': 'Accédez à votre tableau de bord VIP',
    'payment.success.step2Desc': 'Toutes les fonctionnalités premium sont maintenant débloquées',
    'payment.success.step3Title': 'Planifiez vos rendez-vous B2B',
    'payment.success.step3Desc': 'Rendez-vous B2B ILLIMITÉS disponibles immédiatement',
    'payment.success.downloadBadge': 'Télécharger mon badge VIP',
    'payment.success.goToDashboard': 'Accéder à mon tableau de bord VIP',
    'payment.success.benefit1Title': 'Networking Illimité',
    'payment.success.benefit1Desc': 'Rencontrez tous les décideurs',
    'payment.success.benefit2Title': 'RDV B2B Illimités',
    'payment.success.benefit2Desc': 'Planifiez vos rendez-vous stratégiques',
    'payment.success.benefit3Title': 'Événements Exclusifs',
    'payment.success.benefit3Desc': 'Gala, ateliers, conférences VIP',
    'upgrade.free.badge': 'Badge numérique basique',
    'upgrade.free.exhibition': 'Accès zone exposition',
    'upgrade.free.publicConferences': 'Conférences publiques',
    'upgrade.free.b2bMeetings': 'Rendez-vous B2B',
    'upgrade.free.unlimitedNetworking': 'Networking illimité',
    'upgrade.free.exclusiveEvents': 'Événements exclusifs',
    'upgrade.free.workshops': 'Ateliers spécialisés',
    'upgrade.free.gala': 'Soirée gala',
    'upgrade.vip.premiumBadge': 'Badge Premium avec photo',
    'upgrade.vip.fullAccess': 'Accès complet 3 jours',
    'upgrade.vip.b2bRequests': '10 demandes de RDV B2B actives',
    'upgrade.vip.unlimitedNetworking': 'Networking illimité',
    'upgrade.vip.inauguration': 'Invitation inauguration',
    'upgrade.vip.workshops': 'Ateliers spécialisés',
    'upgrade.vip.exclusiveGala': 'Soirée gala exclusive',
    'upgrade.vip.networkingLunches': 'Déjeuners networking',
    'upgrade.vip.vipConferences': 'Conférences VIP',
    'upgrade.vip.privateLounge': 'Accès lounge privé',
    'upgrade.testimonial1.content': 'Le Pass VIP a transformé ma participation. J\'ai pu rencontrer les décideurs clés du secteur.',
    'upgrade.testimonial2.content': 'Les événements exclusifs VIP m\'ont permis de créer des partenariats stratégiques.',
    'upgrade.testimonial3.content': 'L\'accès prioritaire et les services personnalisés valent largement l\'investissement.',
    'upgrade.hero.title': 'Passez au Pass Premium VIP',
    'upgrade.hero.subtitle': 'Débloquez toutes les fonctionnalités et maximisez votre retour sur investissement au SIPORT 2026',
    'upgrade.hero.launchOffer': 'Offre de lancement : 700€ au lieu de 950€',
    'upgrade.freeCard.title': 'Pass Gratuit',
    'upgrade.freeCard.subtitle': 'Accès limité',
    'upgrade.freeCard.currentPass': 'Votre pass actuel',
    'upgrade.vipCard.recommended': '⭐ RECOMMANDÉ',
    'upgrade.vipCard.title': 'Pass Premium VIP',
    'upgrade.vipCard.subtitle': 'Accès complet 3 jours',
    'upgrade.vipCard.cta': 'Passer au Premium VIP',
    'upgrade.benefits.title': 'Pourquoi passer Premium ?',
    'upgrade.benefits.b2bTitle': 'RDV B2B Stratégiques',
    'upgrade.benefits.b2bDesc': '10 demandes actives pour rencontrer les décideurs clés. Libération automatique après réponse.',
    'upgrade.benefits.networkTitle': 'Networking Premium',
    'upgrade.benefits.networkDesc': 'Accès illimité aux événements exclusifs : gala, déjeuners, lounge privé avec 500+ décideurs.',
    'upgrade.benefits.badgeTitle': 'Badge Ultra-Sécurisé',
    'upgrade.benefits.badgeDesc': 'Badge premium avec photo et QR code crypté. Accès prioritaire à toutes les zones VIP.',
    'upgrade.testimonials.title': 'Ce que disent nos membres VIP',
    'upgrade.roi.title': 'ROI Garanti',
    'upgrade.roi.description': 'Nos membres VIP génèrent en moyenne <span class="font-bold text-yellow-300">15 000€</span> de nouvelles opportunités commerciales lors du salon. Investissez 700€, récoltez des milliers.',
    'upgrade.roi.cta': 'Devenir VIP Maintenant',
    'upgrade.faq.title': 'Questions fréquentes',
    'upgrade.faq.q1': 'Quels moyens de paiement acceptez-vous ?',
    'upgrade.faq.a1': 'Cartes bancaires (Visa, Mastercard), PayPal, et cartes marocaines (CMI).',
    'upgrade.faq.q2': 'L\'upgrade est-il immédiat ?',
    'upgrade.faq.a2': 'Oui ! Votre compte est activé instantanément et vous recevez votre badge VIP par email.',
    'upgrade.faq.q3': 'Puis-je annuler après paiement ?',
    'upgrade.faq.a3': 'Remboursement complet possible jusqu\'à 30 jours avant l\'événement.',
    'users.title': 'Gestion des Utilisateurs',
    'users.total': 'Total des Utilisateurs',
    'users.active': 'Utilisateurs Actifs',
    'users.search': 'Rechercher des utilisateurs',
    'users.filter': 'Filtrer par type',
    'users.status': 'Statut',
    'users.action': 'Actions',
    'users.delete': 'Supprimer',
    'partner_detail.about': 'À Propos',
    'partner_detail.projects': 'Projets',
    'partner_detail.contact_info': 'Informations de Contact',
    'partner_detail.request_meeting': 'Demander une Réunion',
    'partner_detail.back': 'Retour',
    'product_detail.specifications': 'Spécifications',
    'product_detail.price': 'Prix',
    'product_detail.availability': 'Disponibilité',
    'product_detail.request_demo': 'Demander une Démo',
    'product_detail.contact_supplier': 'Contacter le Fournisseur',
    'password.reset_title': 'Réinitialiser le Mot de Passe',
    'password.reset_description': 'Entrez votre nouveau mot de passe',
    'password.new_password': 'Nouveau Mot de Passe',
    'password.confirm': 'Confirmer',
    'password.error': 'Erreur lors de la réinitialisation',
    'auth.forgotten_password': 'Mot de passe oublié',
    'auth.forgotten_password_desc': 'Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
    'auth.email': 'Email',
    'auth.email_placeholder': 'votre@email.com',
    'auth.send_reset_link': 'Envoyer le lien',
    'auth.go_login': 'Aller à la page de connexion',
    'common.error_401': '401 - Accès non autorisé',
    'common.error_401_desc': 'Veuillez vous connecter pour accéder à cette page.',
    'common.error_403': '403 - Accès interdit',
    'common.error_403_desc': 'Vous n\'avez pas l\'autorisation d\'accéder à cette page.',
    'common.back_dashboard': 'Retour au tableau de bord',
    'common.sending': 'Envoi...',
    'common.view': 'Voir détails',
    'common.edit': 'Modifier',
    'common.delete': 'Supprimer',
    'ui.sync_official': 'Synchroniser avec le site officiel',
    'ui.share_article': 'Partager cet article',
    'ui.back_to_top': 'Retour en haut',
    'ui.search_by': 'Rechercher par...',
    'admin_media.create_title_example': 'Ex: Interview Innovation Portuaire',
    'admin_media.create_description_placeholder': 'Décrivez le contenu du média...',
    'admin_media.duration_example': '120',
    'admin_media.tags_example': 'Ex: Innovation, Tech, Interview',
    'admin_media.manager_title': 'Gestionnaire de Médias',
    'accommodation.badge': 'Hébergement Partenaires',
    'accommodation.title': 'Hébergement à El Jadida',
    'accommodation.subtitle': 'Profitez de tarifs préférentiels dans nos hôtels partenaires',
    'accommodation.hotels_partners': 'Hôtels partenaires',
    'accommodation.vip_discount': 'Réduction VIP',
    'accommodation.april_dates': 'Avril 2026',
    'accommodation.vip_advantage_title': '🌟 Avantage Visiteurs VIP',
    'accommodation.vip_advantage_desc': 'En tant que visiteur VIP, bénéficiez de tarifs préférentiels exclusifs sur tous nos hôtels partenaires',
    'accommodation.vip_benefit_1': 'Jusqu\'à 30% de réduction sur les hôtels partenaires',
    'accommodation.vip_benefit_2': 'Réservation prioritaire garantie',
    'accommodation.vip_benefit_3': 'Surclassement gratuit selon disponibilité',
    'accommodation.featured_partner': '⭐ Partenaire Premium',
    'accommodation.standard_rate': 'Tarif Standard',
    'accommodation.vip_rate': 'Tarif VIP',
    'accommodation.per_night': 'par nuit',
    'accommodation.view_details': 'Voir les détails',
    'accommodation.amenity_wifi': 'WiFi Gratuit',
    'accommodation.amenity_parking': 'Parking',
    'accommodation.amenity_pool': 'Piscine',
    'accommodation.amenity_spa': 'Spa',
    'accommodation.amenity_restaurant': 'Restaurant',
    'accommodation.amenity_gym': 'Salle de sport',
    'accommodation.amenity_casino': 'Casino',
    'accommodation.amenity_beach': 'Accès plage',
    'accommodation.amenity_golf': 'Golf',
    'accommodation.amenity_bar': 'Bar',
    'accommodation.amenity_terrace': 'Terrasse',
    'accommodation.how_to_book': 'Comment réserver ?',
    'accommodation.step1_title': 'Choisissez votre hôtel',
    'accommodation.step1_desc': 'Sélectionnez l\'hébergement qui vous convient',
    'accommodation.step2_title': 'Contactez l\'hôtel',
    'accommodation.step2_desc': 'Appelez directement ou envoyez un email',
    'accommodation.step3_title': 'Mentionnez SIPORTS',
    'accommodation.step3_desc': 'Indiquez le code "SIPORTS2026" pour le tarif préférentiel',
    'accommodation.step4_title': 'Confirmez votre réservation',
    'accommodation.step4_desc': 'Recevez votre confirmation par email',
    'accommodation.need_help': 'Besoin d\'aide pour votre hébergement ?',
    'accommodation.contact_desc': 'Notre équipe est disponible pour vous assister',
    'security.title': 'Sécurité',
    'security.two_factor': 'Authentification à deux facteurs',
    'security.enable_2fa': 'Activer 2FA',
    'security.disable_2fa': 'Désactiver 2FA',
    'security.totp': 'Application d\'authentification (TOTP)',
    'security.sms': 'SMS',
    'security.email': 'Email',
    'security.backup_codes': 'Codes de secours',
    'security.password': 'Mot de passe',
    'security.change_password': 'Changer le mot de passe',
    'security.change_password_desc': 'Modifiez votre mot de passe temporaire pour sécuriser votre compte.',
    'security.current_password': 'Mot de passe actuel',
    'security.new_password': 'Nouveau mot de passe',
    'security.confirm_password': 'Confirmer le nouveau mot de passe',
    'security.new_password_placeholder': 'Minimum 8 caractères',
    'security.confirm_password_placeholder': 'Retapez le nouveau mot de passe',
    'security.password_requirements': 'Minimum 8 caractères. Utilisez des lettres, chiffres et symboles.',
    'security.change_password_btn': 'Mettre à jour le mot de passe',
    'security.password_changed': 'Mot de passe modifié avec succès !',
    'security.passwords_mismatch': 'Les mots de passe ne correspondent pas.',
    'security.password_too_short': 'Le mot de passe doit contenir au moins 8 caractères.',
    'security.current_password_wrong': 'Le mot de passe actuel est incorrect.',
    'security.fields_required': 'Tous les champs sont obligatoires.',
    'security.sessions': 'Sessions actives',
    'security.api_keys': 'Clés API',
    'security.audit_logs': 'Journaux d\'audit et activité',
    'notifications.title': 'Notifications',
    'notifications.mark_all_read': 'Tout marquer comme lu',
    'notifications.no_notifications': 'Aucune notification',
    'notifications.new': 'Nouveau',
    'notifications.unread': 'Non lu',
    'notifications.settings': 'Paramètres de notification',
    'notifications.email_notifications': 'Notifications par email',
    'notifications.push_notifications': 'Notifications push',
    'notifications.sms_notifications': 'Notifications SMS',
    'notifications.preferences': 'Préférences',
    'analytics.title': 'Analyses',
    'analytics.overview': 'Vue d\'ensemble',
    'analytics.visitors': 'Visiteurs',
    'analytics.pageviews': 'Pages vues',
    'analytics.conversions': 'Conversions',
    'analytics.revenue': 'Revenus',
    'analytics.export': 'Exporter',
    'analytics.period': 'Période',
    'analytics.today': 'Aujourd\'hui',
    'analytics.week': 'Cette semaine',
    'analytics.month': 'Ce mois',
    'analytics.year': 'Cette année',
    'analytics.custom': 'Personnalisé',
    'payments.title': 'Paiements',
    'payments.methods': 'Méthodes de paiement',
    'payments.history': 'Historique',
    'payments.invoices': 'Factures',
    'payments.refunds': 'Remboursements',
    'payments.pending': 'En attente',
    'payments.completed': 'Complété',
    'payments.failed': 'Échoué',
    'payments.amount': 'Montant',
    'payments.date': 'Date',
    'payments.status': 'Statut',
    'payments.download_invoice': 'Télécharger la facture',
    'partner.activity.title': 'Activité du Partenaire',
    'partner.activity.connection_established': 'Connexion établie',
    'partner.activity.connected_with': 'Connecté avec',
    'partner.activity.new_message': 'Nouveau message',
    'partner.activity.event_participation': 'Participation à un événement',
    'partner.activity.stand_visit': 'Visite de stand',
    'partner.activity.product_inquiry': 'Enquête produit',
    'partner.activity.meeting_scheduled': 'Réunion programmée',
    'partner.activity.meeting_confirmed': 'Réunion confirmée',
    'partner.activity.meeting_completed': 'Réunion complétée',
    'partner.activity.meeting_cancelled': 'Réunion annulée',
    'partner.activity.lead_generated': 'Prospect généré',
    'partner.activity.download': 'Télécharger les ressources',
    'partner.activity.brochure_request': 'Demande de brochure',
    'partner.activity.contact_request': 'Demande de contact',
    'partner.activity.quote_request': 'Demande de devis',
    'partner.activity.demo_request': 'Demande de démo',
    'partner.activity.partnership_interest': 'Intérêt pour partenariat',
    'partner.activity.event_interest': 'Intérêt pour événement',
    'partner.activity.network_join': 'Rejoindre le réseau',
    'partner.activity.filter_all': 'Tous',
    'partner.activity.filter_connections': 'Connexions',
    'partner.activity.filter_messages': 'Messages',
    'partner.activity.filter_meetings': 'Réunions',
    'partner.activity.filter_inquiries': 'Demandes',
    'partner.activity.timestamp_today': 'Aujourd\'hui',
    'partner.activity.timestamp_yesterday': 'Hier',
    'partner.activity.timestamp_this_week': 'Cette semaine',
    'partner.activity.timestamp_this_month': 'Ce mois',
    'partner.activity.total_connections': 'Connexions totales',
    'partner.activity.total_messages': 'Messages totaux',
    'partner.activity.total_meetings': 'Réunions totales',
    'partner.leads.title': 'Gestion des Prospects',
    'partner.leads.overview': 'Vue d\'ensemble',
    'partner.leads.total_leads': 'Prospects totaux',
    'partner.leads.new_leads': 'Nouveaux prospects',
    'partner.leads.qualified_leads': 'Prospects qualifiés',
    'partner.leads.contacted': 'Contactés',
    'partner.leads.converted': 'Convertis',
    'partner.leads.source_event': 'Source: Événement',
    'partner.leads.source_website': 'Source: Site web',
    'partner.leads.source_email': 'Source: Email',
    'partner.leads.source_referral': 'Source: Recommandation',
    'partner.leads.source_other': 'Source: Autre',
    'partner.leads.stage_new': 'Étape: Nouveau',
    'partner.leads.stage_contacted': 'Étape: Contacté',
    'partner.leads.stage_qualified': 'Étape: Qualifié',
    'partner.leads.stage_proposal': 'Étape: Proposition',
    'partner.leads.stage_negotiation': 'Étape: Négociation',
    'partner.leads.stage_won': 'Étape: Gagné',
    'partner.leads.stage_lost': 'Étape: Perdu',
    'partner.leads.quality_high': 'Qualité: Haute',
    'partner.leads.quality_medium': 'Qualité: Moyenne',
    'partner.leads.quality_low': 'Qualité: Basse',
    'partner.leads.tip_follow_up': 'Conseil: Effectuez un suivi 48h après le contact initial',
    'partner.leads.tip_personalize': 'Conseil: Personnalisez chaque approche de prospect',
    'partner.leads.tip_document': 'Conseil: Documentez toutes les interactions',
    'partner.leads.tip_timing': 'Conseil: Le timing est clé pour la conversion',
    'partner.leads.tip_interests': 'Conseil: Identifiez les intérêts spécifiques du prospect',
    'partner.events.title': 'Gestion des Événements',
    'partner.events.overview': 'Vue d\'ensemble',
    'partner.events.upcoming': 'Événements à venir',
    'partner.events.past': 'Événements passés',
    'partner.events.registered': 'Événements inscrits',
    'partner.events.status_scheduled': 'Statut: Programmé',
    'partner.events.status_ongoing': 'Statut: En cours',
    'partner.events.status_completed': 'Statut: Complété',
    'partner.events.status_cancelled': 'Statut: Annulé',
    'partner.events.registration_open': 'Inscription ouverte',
    'partner.events.registration_closed': 'Inscription fermée',
    'partner.events.capacity': 'Capacité',
    'partner.events.attendees': 'Participants',
    'partner.events.program': 'Programme',
    'partner.events.speakers': 'Conférenciers',
    'partner.events.location': 'Localisation',
    'partner.events.date_time': 'Date et Heure',
    'networking.matchmaking_title': 'Appariement de Réseau',
    'networking.compatibility_level_excellent': 'Excellent',
    'networking.compatibility_level_good': 'Bon',
    'networking.compatibility_level_fair': 'Acceptable',
    'networking.compatibility_level_poor': 'Faible',
    'partner.activity.message_from': '{name} vous a envoyé un message',
    'partner.activity.participated_in': 'Vous avez participé à {event}',
    'partner.activity.sponsoring_activated': 'Sponsoring activé',
    'partner.activity.logo_displayed': 'Votre logo est maintenant affiché sur {page}',
    'partner.activity.profile_viewed': 'Profil consulté',
    'partner.activity.views_today': 'Votre profil a été consulté {count} fois aujourd\'hui',
    'partner.activity.content_shared': 'Contenu partagé',
    'partner.activity.article_shared': 'Votre article "{title}" a été partagé',
    'partner.activity.system_alert': 'Alerte système',
    'partner.activity.metrics_update': 'Mise à jour de vos métriques de performance disponible',
    'partner.activity.just_now': 'À l\'instant',
    'partner.activity.hours_ago': 'Il y a {n}h',
    'partner.activity.days_ago': 'Il y a {n}j',
    'partner.activity.type.connection': 'Connexion',
    'partner.activity.type.message': 'Message',
    'partner.activity.type.event': 'Événement',
    'partner.activity.type.sponsorship': 'Sponsoring',
    'partner.activity.type.consultation': 'Consultation',
    'partner.activity.type.content': 'Contenu',
    'partner.activity.type.alert': 'Alerte',
    'partner.activity.type.meeting': 'Rendez-vous',
    'partner.activity.filter.all': 'Toutes les activités',
    'partner.activity.filter.networking': 'Réseautage',
    'partner.activity.filter.communication': 'Communication',
    'partner.activity.filter.events': 'Événements',
    'partner.activity.filter.sponsorship': 'Sponsoring',
    'partner.activity.filter.engagement': 'Engagement',
    'partner.activity.filter.content': 'Contenu',
    'partner.activity.filter.meetings': 'Rendez-vous',
    'partner.activity.filter.system': 'Système',
    'partner.activity.full_history': 'Historique Complet des Activités',
    'partner.activity.realtime': 'Temps Réel',
    'partner.activity.stats.total': 'Activités totales',
    'partner.activity.stats.today': 'Aujourd\'hui',
    'partner.activity.stats.this_week': 'Cette semaine',
    'partner.activity.history': 'Historique des Activités',
    'partner.activity.no_activity': 'Aucune activité trouvée',
    'partner.activity.try_filters': 'Essayez de modifier vos filtres de recherche',
    'partner.leads.exhibitor': 'Exposant',
    'partner.leads.visitor': 'Visiteur',
    'partner.leads.other': 'Autre',
    'partner.leads.connected': 'Connecté',
    'partner.leads.pending': 'En attente',
    'partner.leads.rejected': 'Rejeté',
    'partner.leads.active_followup': 'Suivi actif',
    'partner.leads.awaiting_response': 'En attente de réponse',
    'partner.leads.sources.events': 'Événements SIPORTS',
    'partner.leads.sources.networking': 'Networking Partenaires',
    'partner.leads.sources.referrals': 'Références Clients',
    'partner.leads.sources.marketing': 'Campagnes Marketing',
    'partner.leads.funnel.generated': 'Leads Générés',
    'partner.leads.funnel.qualified': 'Qualifiés',
    'partner.leads.funnel.proposal': 'Proposition',
    'partner.leads.funnel.negotiation': 'Négociation',
    'partner.leads.funnel.conversion': 'Conversion',
    'partner.leads.subtitle': 'Gérez vos leads qualifiés et suivez leur progression dans le pipeline commercial',
    'partner.leads.premium_program': 'Programme Leads Premium',
    'partner.leads.conversion_rate': '12% Taux de Conversion',
    'partner.leads.generated': 'Leads générés',
    'partner.leads.qualified': 'Leads qualifiés',
    'partner.leads.conversion': 'Taux de conversion',
    'partner.leads.estimated_value': 'Valeur estimée',
    'partner.leads.recent': 'Leads Récents',
    'partner.leads.tips.title': 'Conseils de Gestion des Leads',
    'partner.leads.tips.qualification': 'Qualification Rapide',
    'partner.leads.tips.qualification_desc': 'Contactez les leads chauds dans les 24h pour maximiser vos chances de conversion',
    'partner.leads.tips.followup': 'Suivi Régulier',
    'partner.leads.tips.followup_desc': 'Planifiez des points de suivi hebdomadaires pour maintenir l\'engagement',
    'partner.leads.tips.personalization': 'Personnalisation',
    'partner.leads.tips.personalization_desc': 'Adaptez vos propositions aux besoins spécifiques de chaque prospect',
    'partner.leads.tips.measure': 'Mesure des Résultats',
    'partner.leads.tips.measure_desc': 'Analysez régulièrement vos taux de conversion pour optimiser votre approche',
    'partner.status.upcoming': 'À venir',
    'partner.status.draft': 'Brouillon',
    'partner.events.available': 'Événements disponibles',
    'partner.events.loading': 'Chargement des événements...',
    'partner.events.none': 'Aucun événement disponible pour le moment.',
    'partner.priority': 'Prioritaire',
    'partner.details': 'Détails',
    'visitor.premium_feature': 'Fonctionnalité Premium',
    'networking.ai_reserved_premium': 'Réservé aux comptes Premium/VIP',
    'visitor.upgrade_level': 'Améliorer mon niveau',
    'common.back': 'Retour',
    'networking.excellent_match': 'Excellent',
    'networking.good_match': 'Bon',
    'networking.potential_match': 'Potentiel',
    'networking.low_match': 'Faible',
    'nav.my_account': 'Mon compte',
    'nav.my_profile': 'Mon Profil',
    'nav.admin_profile': 'Mon Profil Admin',
    'nav.admin_dashboard': 'Tableau de Bord Admin',
    'nav.payment_validation': 'Validation Paiements',
    'nav.metrics': 'Métriques & Performance',
    'nav.qr_scanner': 'Scanner QR (Sécurité)',
    'nav.badge_print': 'Impression Badges (Service Clientèle)',
    'nav.digital_badge': 'Mon Badge Digital',
    'nav.admin_zone': 'Zone Administrateur',
    'nav.exhibitor_dashboard': 'Tableau de Bord Exposant',
    'nav.b2b_networking': 'Réseautage B2B',
    'nav.minisite_editor': 'Éditeur de Mini-Site',
    'nav.my_slots': 'Mes Créneaux RDV',
    'nav.messages': 'Messages & Contact',
    'nav.partner_dashboard': 'Tableau de Bord Partenaire',
    'nav.vip_networking': 'Networking VIP',
    'nav.partner_subscription': 'Abonnement Partenaire',
    'nav.visitor_dashboard': 'Tableau de Bord Visiteur',
    'nav.visitor_settings': 'Paramètres Visiteur',
    'nav.my_appointments': 'Mes Rendez-vous',
    'footer.tagline': 'Redéfinir l\'avenir du secteur portuaire',
    'footer.navigation': 'Navigation',
    'footer.nav_home': 'Accueil',
    'footer.nav_exhibitors_catalog': 'Catalogue Exposants',
    'footer.nav_networking': 'Réseautage B2B',
    'footer.nav_conferences': 'Conférences',
    'footer.nav_news': 'Actualités',
    'footer.media_platform': 'Plateforme Média',
    'footer.strategic_contact': 'Contact Stratégique',
    'footer.privacy': 'Confidentialité',
    'footer.legal': 'Mentions Légales',
    'footer.all_rights': 'Tous droits réservés',
    'exhibitors.catalog_label': 'SIPORT 2026 • Catalogue Exposants',
    'exhibitors.leaders_count': 'leaders de l\'industrie',
    'exhibitors.filters': 'Filtres',
    'exhibitors.all_sectors': 'Tous les secteurs',
    'exhibitors.no_results_desc': 'Aucun exposant ne correspond à vos critères actuels. Essayez d\'ajuster vos filtres.',
    'exhibitors.reset_search': 'Réinitialiser la recherche',
    'home.about_siports': 'À propos de SIPORTS',
    'home.about_subtitle': 'Le rendez-vous incontournable du monde portuaire',
    'home.discover_exhibitors_btn': 'Découvrir les Exposants',
    'home.see_partners_btn': 'Voir les Partenaires',
    'home.discover_all_partners_subtitle': 'Découvrez tous les partenaires officiels du salon',
    'home.no_partners_available': 'Aucun partenaire disponible pour le moment',
    'home.discover_all_exhibitors_subtitle': 'Découvrez tous les exposants participants au salon',
    'contact.select_subject': 'Sélectionnez un sujet',
    'contact.subject_exhibitor': 'Devenir exposant',
    'contact.subject_visitor': 'S\'inscrire en tant que visiteur',
    'contact.subject_partnership': 'Partenariat',
    'contact.subject_support': 'Support technique',
    'contact.subject_other': 'Autre',
    'contact.sending': 'Envoi en cours...',
    'contact.address': 'Adresse',
    'contact.phone': 'Téléphone',
    'contact.weekdays': 'Lundi - Vendredi',
    'contact.saturday': 'Samedi',
    'contact.sunday': 'Dimanche',
    'contact.closed': 'Fermé',
    'contact.contact_info': 'Informations de contact',
    'contact.opening_hours': 'Horaires d\'ouverture',
    'contact.follow_us': 'Suivez-nous',
    'contact.follow_us_desc': 'Restez informé des dernières actualités de SIPORTS 2026',
    'contact.characters': 'caractères',
    'contact.required_fields': 'Veuillez remplir tous les champs obligatoires',
    'contact.invalid_email': 'Veuillez entrer une adresse email valide',
    'contact.message_too_short': 'Le message doit contenir au moins 10 caractères',
    'contact.error': 'Une erreur est survenue. Veuillez réessayer plus tard.',
    'about.excellence': 'Excellence Portuaire',
    'about.excellence_desc': 'Le plus grand événement portuaire d\'Afrique',
    'about.international': 'Rayonnement International',
    'about.international_desc': '42+ pays représentés sur 5 continents',
    'about.networking': 'Networking B2B & B2G',
    'about.networking_desc': '6 000 professionnels réunis',
    'about.innovation': 'Innovation & Smart Ports',
    'about.innovation_desc': 'Technologies portuaires de pointe',
    'about.exhibitors_stat': 'Exposants',
    'about.countries_stat': 'Pays',
    'about.visitors_stat': 'Visiteurs',
    'about.days_stat': 'Jours',
    'about.badge': 'À propos de SIPORTS',
    'about.title': 'SIPORTS 2026 — <highlight>Le rendez-vous incontournable</highlight> du monde portuaire',
    'about.desc1': 'Le <strong>Salon International des Ports et de leur Écosystème (SIPORTS)</strong> est le rendez-vous incontournable des professionnels du secteur portuaire, logistique et maritime en Afrique et dans le monde.',
    'about.desc2': 'Du <strong>1er au 3 avril 2026</strong>, le <strong>Parc d\'Exposition Mohammed VI à El Jadida</strong> ouvrira ses portes.',
    'about.desc3': '<strong>Sous l\'égide du Ministère de l\'Equipement et de l\'Eau.</strong>',
    'about.card_title': 'Salon International des Ports',
    'about.card_desc': 'Le plus grand événement portuaire d\'Afrique',
    'about.cta_title': 'Prêt à rejoindre SIPORTS 2026 ?',
    'about.cta_desc': 'Réservez votre place dès maintenant et découvrez les opportunités du plus grand salon portuaire international d\'Afrique.',
    'about.cta_button': 'S\'inscrire maintenant',
    'about.dates': '1-3 Avril',
    'about.location_city': 'El Jadida',
    'about.location_country': 'Maroc 🇲🇦',
    'services.need_help': 'Besoin d\'aide ?',
    'services.help_desc': 'Nos équipes commerciales sont disponibles pour vous aider',
    'services.send_message': 'Envoyer un message',
    'services.whatsapp_desc': 'Contactez-nous directement par message',
    'services.send_email': 'Envoyer un email',
    'services.email_desc': 'Envoyez un email à notre équipe',
    'services.phone': 'Téléphone',
    'services.phone_desc': 'Appelez-nous directement',
    'services.call_now': 'Appeler maintenant',
    'services.hours': 'Horaires',
    'services.hours_desc': 'Nous sommes disponibles:<br />Lundi - Vendredi: 9h-18h',
    'services.timezone': 'Fuseau horaire: GMT+1',
    'services.ready_to_chat': 'Prêt à discuter avec notre équipe ?',
    'services.whatsapp_cta': 'Démarrer une conversation WhatsApp',
    'services.whatsapp_fast': 'Utilisez WhatsApp pour une réponse rapide et instantanée',
    'media.gallery_badge': 'Galerie SIPORTS',
    'media.gallery_title': 'SIPORTS en Images',
    'media.gallery_desc': 'Découvrez l\'événement en images',
    'media.view_gallery': 'Voir toute la galerie',
    'partners.catalog_label': 'SIPORT 2026 \\u2022 Catalogue Partenaires',
    'partners.page_title': 'Partenaires',
    'partners.page_subtitle': 'Découvrez les organisations et institutions qui soutiennent l\'événement',
    'partners.leaders_count': 'partenaires stratégiques \\u00e0 découvrir.',
    'partners.search_placeholder': 'Chercher un partenaire',
    'partners.filters': 'Filtres',
    'partners.sort_by': 'Trier par:',
    'partners.sort_name': 'Nom',
    'partners.sort_sector': 'Secteur',
    'partners.sort_type': 'Type',
    'partners.sort_country': 'Pays',
    'partners.export': 'Exporter',
    'partners.no_results': 'Aucun partenaire trouvé pour votre recherche',
    'partners.clear_filters': 'Effacer les filtres',
    'partners.total': 'Total Partenaires',
    'partners.type': 'Type de partenaire',
    'partners.institutional': 'Institutionnel',
    'partners.verified_only': 'Vérifiés uniquement',
    'partners.featured_only': 'En vedette uniquement',
    'partners.export_limit': 'Limite d\'exportation atteinte',
    'partners.export_error': 'Erreur lors de l\'exportation',
    'partners.country': 'Pays',
    'accommodation.dist.2km': 'À 2 km',
    'accommodation.dist.2.5km': 'À 2,5 km',
    'accommodation.dist.3km': 'À 3 km',
    'accommodation.dist.4km': 'À 4 km',
    'accommodation.dist.5km': 'À 5 km',
    'accommodation.dist.6km': 'À 6 km',
    'accommodation.hotel.ibis.desc': 'Hôtel Ibis - Hôtel économique avec excellent service',
    'accommodation.hotel.mazagan.desc': 'Resort Mazagan Beach - Resort de luxe 5 étoiles',
    'accommodation.hotel.provence.desc': 'Hôtel Provence - Hôtel 4 étoiles près du centre des congrès',
    'accommodation.hotel.pullman.desc': 'Hôtel Pullman - Hôtel international 4 étoiles',
    'accommodation.hotel.royal.desc': 'Hôtel Royal - Hôtel 3 étoiles avec bonnes installations',
    'accommodation.hotel.suisse.desc': 'Hôtel Suisse - Hôtel 4 étoiles en centre-ville',
    'accommodation.room.deluxe_double': 'Chambre Deluxe Double',
    'accommodation.room.deluxe_single': 'Chambre Deluxe Simple',
    'accommodation.room.garden_pool_double': 'Chambre Double Vue Jardin et Piscine',
    'accommodation.room.garden_pool_single': 'Chambre Simple Vue Jardin et Piscine',
    'accommodation.room.suite_full_ocean': 'Suite Vue Complète Océan',
    'accommodation.room.suite_junior_double': 'Junior Suite Double',
    'accommodation.room.suite_junior_single': 'Junior Suite Simple',
    'accommodation.room.suite_partial_ocean': 'Suite Vue Partielle Océan',
    'badge.active': 'Activé',
    'badge.badge_downloaded': 'Badge téléchargé',
    'badge.badge_generated_success': 'Badge généré avec succès',
    'badge.comment': 'Commentaire',
    'badge.download_error': 'Erreur de téléchargement',
    'badge.download_print_info': 'Téléchargez ou imprimez votre badge d\'accès',
    'badge.download_png': 'Télécharger PNG',
    'badge.error_generating': 'Erreur lors de la génération du badge',
    'badge.error_loading': 'Erreur lors du chargement du badge',
    'badge.generate_badge_info': 'Générez votre badge d\'accès',
    'badge.generate_my_badge': 'Générer mon badge',
    'badge.generating': 'Génération du badge en cours...',
    'badge.instruction_1': 'Cliquez ci-dessous pour générer votre badge',
    'badge.instruction_1_desc': 'Votre badge d\'accès est personnel',
    'badge.instruction_2': 'Téléchargez ou imprimez votre badge',
    'badge.instruction_2_desc': 'Vous pouvez télécharger en PNG ou imprimer directement',
    'badge.instruction_3': 'Montrez votre badge à l\'entrée',
    'badge.instruction_3_desc': 'Présentez votre badge pour accéder à l\'événement',
    'badge.instruction_4': 'Gardez votre badge avec vous',
    'badge.instruction_4_desc': 'Montrez votre badge aux agents de sécurité ou aux stands partenaires',
    'badge.last_scan': 'Dernier scan',
    'badge.login_required': 'Connexion requise',
    'badge.must_login_badge': 'Vous devez être connecté pour générer votre badge',
    'badge.my_access_badge': 'Mon badge d\'accès',
    'badge.print.camera_activated': 'Caméra activée',
    'badge.print.error_camera': 'Erreur caméra - veuillez autoriser l\'accès',
    'badge.print.error_printing': 'Erreur lors de l\'impression',
    'badge.print.generated': 'Badge imprimé',
    'badge.print.sent': 'Badge envoyé à l\'imprimante',
    'badge.regenerate': 'Régénérer',
    'badge.regenerating': 'Régénération du badge en cours...',
    'badge.scanner.activated': 'Scanner activé',
    'badge.scanner.deactivated': 'Scanner désactivé',
    'badge.scanner.error_camera': 'Erreur caméra',
    'badge.scanner.error_lead': 'Erreur de capture de lead',
    'badge.scanner.error_processing': 'Erreur lors du traitement du scan',
    'badge.scanner.error_start': 'Erreur au démarrage du scanner',
    'badge.scanner.error_stats': 'Erreur lors du chargement des statistiques',
    'badge.scanner.error_stop': 'Erreur à l\'arrêt du scanner',
    'badge.scanner.error_validate': 'Erreur de validation',
    'badge.scanner.error_validation': 'Erreur de validation du badge',
    'badge.scanner.expired': 'Badge expiré',
    'badge.scanner.inactive': 'Badge inactif',
    'badge.scanner.invalid': 'Badge invalide',
    'badge.scans_done': 'Scans terminés',
    'badge.stand_number': 'Numéro de stand',
    'badge.statistics': 'Statistiques',
    'badge.status': 'État',
    'badge.usage_instructions': 'Comment utiliser votre badge',
    'badge.valid_from': 'Valide à partir de',
    'badge.vip_advantage_1': 'Entrée prioritaire à l\'événement',
    'badge.vip_advantage_2': 'Accès au salon VIP et aux zones spéciales',
    'badge.vip_advantage_3': 'Opportunités de réseautage exclusives',
    'badge.vip_advantages': 'Avantages VIP',
    'common.bookmarked_add': 'Ajouter aux favoris',
    'common.bookmarked_remove': 'Retirer des favoris',
    'common.comment': 'Commentaire',
    'common.comments': 'Commentaires',
    'common.generating_pdf': 'Génération du PDF...',
    'common.like': 'Aimer',
    'common.loading_article': 'Chargement de l\'article...',
    'common.newsletter_placeholder': 'Entrez votre adresse e-mail',
    'common.newsletter_subscribe': 'S\'abonner à la newsletter',
    'common.newsletter_subtitle': 'Recevez les dernières nouvelles et mises à jour sur SIPORT',
    'common.newsletter_title': 'Abonnement à la newsletter',
    'common.read_more': 'Lire la suite',
    'common.related_articles': 'Articles connexes',
    'common.share': 'Partager',
    'common.share_link_copied': 'Lien copié dans le presse-papiers',
    'common.share_link_error': 'Erreur lors de la copie du lien',
    'common.source': 'Source',
    'common.tags': 'Étiquettes',
    'common.views': 'Vues',
    'exhibitors.count': 'exposants',
    'minisite.list.subtitle': 'Explorez les mini-sites de nos exposants et partenaires',
    'minisite.list.title': 'Mini-sites',
    'minisite.search.no_match': 'Aucun mini-site ne correspond à votre recherche',
    'minisite.search.no_sites_yet': 'Aucun mini-site disponible pour le moment',
    'minisite.search.not_found': 'Mini-site non trouvé',
    'minisite.search.placeholder': 'Chercher des mini-sites...',
    'navigation.news': 'Actualités',
    'payment.paypalCaptureErrorToast': 'Erreur de paiement PayPal. Veuillez réessayer.',
    'actions.open': 'Ouvrir',
    'admin.all_categories': 'Toutes les catégories',
    'admin.create_first_article': 'Créer votre premier article',
    'admin.featured': 'À l\'affiche',
    'admin.no_articles_criteria': 'Aucun article ne correspond aux critères sélectionnés',
    'admin.no_articles_found': 'Aucun article trouvé',
    'admin.platform_statistics': 'Statistiques de la plateforme',
    'appointments.no_appointments_date': 'Aucun rendez-vous prévu pour cette date',
    'auth.bio': 'Biographie',
    'auth.bio_placeholder': 'Parlez-nous de vous',
    'auth.company': 'Entreprise',
    'auth.company_placeholder': 'Nom de votre entreprise',
    'auth.country': 'Pays',
    'auth.login': 'Connexion',
    'auth.login_required': 'Connexion requise',
    'auth.phone': 'Téléphone',
    'auth.please_login': 'Veuillez vous connecter pour continuer',
    'auth.premium_required': 'Accès Premium requis',
    'badge.access_badge': 'Accéder à votre badge',
    'badge.authorized_zones': 'Zones autorisées',
    'badge.automatic_rotation': 'Rotation automatique',
    'badge.loading_badge': 'Chargement de votre badge...',
    'badge.max_security': 'Sécurité maximale',
    'badge.regenerate_qr': 'Régénérer le code QR',
    'badge.secure_qr_jwt': 'Jeton JWT sécurisé',
    'badge.security_info': 'Informations de sécurité',
    'badge.total_access': 'Accès complet',
    'badge.unknown_level': 'Niveau d\'accès inconnu',
    'calendar.add_new_slot': 'Ajouter un créneau',
    'calendar.available_spots': 'Places disponibles',
    'calendar.create_first_slot': 'Créer votre premier créneau',
    'calendar.default_location': 'Lieu par défaut',
    'calendar.event_days_description': 'Consultez la disponibilité sur tous les jours de l\'événement',
    'calendar.grid_view': 'Vue grille',
    'calendar.list_view': 'Vue liste',
    'calendar.no_availability_message': 'Aucune disponibilité programmée',
    'calendar.no_slots': 'Aucun créneau disponible',
    'calendar.no_slots_configured': 'Aucun créneau configuré',
    'calendar.plan_availability': 'Planifiez votre disponibilité',
    'calendar.this_week': 'Cette semaine',
    'calendar.title': 'Calendrier de disponibilité',
    'calendar.total_slots': 'Nombre total de créneaux',
    'common.all': 'Tous',
    'common.appointments': 'Rendez-vous',
    'common.b2b_meetings': 'Réunions B2B',
    'common.back_home': 'Retour à l\'accueil',
    'common.cancel': 'Annuler',
    'common.categories': 'Catégories',
    'common.close_error': 'Fermer l\'alerte',
    'common.complete_dashboard': 'Tableau de bord complet',
    'common.dashboard': 'Tableau de bord',
    'common.delete_error': 'Erreur de suppression',
    'common.delete_success': 'Suppression effectuée avec succès',
    'common.error': 'Erreur',
    'common.load_more': 'Charger plus',
    'common.loading': 'Chargement...',
    'common.networking': 'Networking',
    'common.new': 'Nouveau',
    'common.not_verified': 'Non vérifié',
    'common.public_conferences': 'Conférences publiques',
    'common.published': 'Publié',
    'common.save': 'Enregistrer',
    'common.saving': 'Enregistrement...',
    'common.total': 'Total',
    'common.unlimited': 'Illimité',
    'common.update_success': 'Mise à jour effectuée avec succès',
    'common.updated': 'Mis à jour',
    'common.upgrade': 'Passer à une version supérieure',
    'common.verified': 'Vérifié',
    'common.view_all': 'Voir tous',
    'common.vip_zones': 'Zones VIP',
    'common.warning': 'Attention',
    'countdown.add_to_calendar': 'Ajouter au calendrier',
    'countdown.address': 'Adresse',
    'countdown.calendar_added': 'Ajouté à votre calendrier',
    'countdown.calendar_description': 'Rappel d\'événement',
    'countdown.conferences': 'Conférences',
    'countdown.contact_hours': 'Heures de contact',
    'countdown.contact_org': 'Organisation à contacter',
    'countdown.copied_clipboard': 'Copié dans le presse-papiers',
    'countdown.copy_failed': 'Copie échouée',
    'countdown.countries': 'Pays',
    'countdown.day': 'Jour',
    'countdown.day1_networking': 'Networking d\'ouverture',
    'countdown.day1_opening': 'Ouverture officielle',
    'countdown.day1_plenary': 'Séance plénière',
    'countdown.day1_title': 'Jour 1 : Ouverture et networking',
    'countdown.day2_b2b': 'Réunions B2B',
    'countdown.day2_demos': 'Démonstrations en direct',
    'countdown.day2_title': 'Jour 2 : B2B et ateliers',
    'countdown.day2_workshops': 'Ateliers',
    'countdown.day3_awards': 'Cérémonie des prix',
    'countdown.day3_closing': 'Séance de clôture',
    'countdown.day3_roundtables': 'Tables rondes',
    'countdown.day3_title': 'Jour 3 : Clôture et prix',
    'countdown.days': 'Jours',
    'countdown.days_plural': 'Jours',
    'countdown.event_address': 'Adresse de l\'événement',
    'countdown.event_started': 'L\'événement a commencé !',
    'countdown.event_welcome': 'Bienvenue à SIPORTS 2026',
    'countdown.exhibitors': 'Exposants',
    'countdown.hour': 'Heure',
    'countdown.hours': 'Heures',
    'countdown.info_catering': 'Informations de restauration',
    'countdown.info_parking': 'Informations de stationnement',
    'countdown.info_registration': 'Détails de l\'inscription',
    'countdown.info_shuttles': 'Services de navette',
    'countdown.info_wifi': 'Accès WiFi',
    'countdown.key_figures': 'Chiffres clés',
    'countdown.location_access': 'Lieu et accès',
    'countdown.minute': 'Minute',
    'countdown.minutes': 'Minutes',
    'countdown.months': 'Mois',
    'countdown.opening_in': 'Ouverture dans',
    'countdown.practical_info': 'Informations pratiques',
    'countdown.program_3days': 'Programme sur 3 jours',
    'countdown.reminder_set': 'Rappel défini',
    'countdown.schedule': 'Calendrier',
    'countdown.second': 'Seconde',
    'countdown.seconds': 'Secondes',
    'countdown.set_reminder': 'Définir un rappel',
    'countdown.share_countdown': 'Partager le décompte',
    'countdown.share_title': 'Partager SIPORTS 2026',
    'countdown.venue': 'Lieu',
    'countdown.visitors': 'Visiteurs',
    'countdown.weeks': 'Semaines',
    'dashboard.appointments': 'Rendez-vous',
    'dashboard.bio_help': 'Aide sur la biographie',
    'dashboard.complete_profile': 'Complétez votre profil',
    'dashboard.completion_help': 'Aide sur la complétude du profil',
    'dashboard.completion_score': 'Score de complétude du profil',
    'dashboard.contacts': 'Contacts',
    'dashboard.event_goals': 'Objectifs d\'événement',
    'dashboard.login_to_see_stats': 'Connectez-vous pour voir vos statistiques',
    'dashboard.minisite_views': 'Vues du minisite',
    'dashboard.partnership_types': 'Types de partenariat',
    'dashboard.products': 'Produits',
    'dashboard.profile_tips': 'Conseils pour le profil',
    'dashboard.profile_views': 'Vues du profil',
    'dashboard.visibility': 'Visibilité',
    'dashboard.why_complete': 'Pourquoi compléter votre profil ?',
    'error.auto_generation': 'Erreur de génération automatique',
    'error.generic': 'Une erreur s\'est produite',
    'error.recommendation': 'Erreur de recommandation',
    'errors.back_to_home': 'Retour à l\'accueil',
    'errors.error_message': 'Message d\'erreur',
    'errors.oops': 'Oups !',
    'errors.reload_page': 'Recharger la page',
    'errors.unexpected_error': 'Une erreur inattendue s\'est produite',
    'errors.view_stack_trace': 'Voir les détails',
    'exhibitors.company_info': 'Informations sur l\'entreprise',
    'exhibitors.company_size': 'Taille de l\'entreprise',
    'form.activity_sector': 'Secteur d\'activité',
    'form.confirm_and_send': 'Confirmer et envoyer',
    'form.contact_information': 'Coordonnées',
    'form.country': 'Pays',
    'form.description': 'Description',
    'form.edit_information': 'Modifier les informations',
    'form.email': 'Email',
    'form.ensure_correct_before_submit': 'Veuillez vérifier que toutes les informations sont correctes avant de soumettre',
    'form.error.generic': 'Erreur lors de la soumission du formulaire',
    'form.full_name': 'Nom complet',
    'form.organization_information': 'Informations sur l\'organisation',
    'form.organization_name': 'Nom de l\'organisation',
    'form.partnership_type': 'Type de partenariat',
    'form.phone': 'Téléphone',
    'form.position': 'Poste',
    'form.request_review_warning': 'Votre soumission sera examinée par notre équipe',
    'form.required': 'Champ obligatoire',
    'form.sending': 'Envoi en cours...',
    'form.status.saving': 'Enregistrement de vos modifications...',
    'form.success.updated': 'Vos informations ont été mises à jour',
    'form.verify_information': 'Vérifiez vos informations',
    'form.website': 'Site web',
    'matching.form.collaboration_types': 'Types de collaboration',
    'matching.form.goals': 'Vos objectifs',
    'matching.form.interests': 'Vos intérêts',
    'matching.form.save': 'Enregistrer les préférences',
    'matching.form.sectors': 'Vos secteurs',
    'matching.results.contact': 'Contacter cette personne',
    'matching.subtitle': 'Recommandations de networking IA',
    'matching.title': 'Matching de networking',
    'media.action.listen_now': 'Écouter maintenant',
    'media.capsule.added_to_favorites': 'Ajouté aux favoris',
    'media.capsule.link_copied': 'Lien copié',
    'media.capsule.not_found': 'Contenu multimédia non trouvé',
    'media.capsule.save': 'Enregistrer',
    'media.capsule.saved': 'Enregistré',
    'media.detail.views': 'vues',
    'media.error.loading_capsule': 'Erreur lors du chargement du contenu multimédia',
    'media.filter.all_categories': 'Toutes les catégories',
    'media.info.audio_unavailable': 'Audio actuellement indisponible',
    'media.info.try_filter': 'Essayez d\'ajuster les filtres',
    'media.podcast.featured_episode': 'Épisode en vedette',
    'media.podcast.no_results': 'Aucun podcast trouvé',
    'media.podcast.page_subtitle': 'Écoutez les perspectives d\'experts du secteur',
    'media.podcast.page_title': 'Podcasts',
    'media.podcast.search_placeholder': 'Rechercher des podcasts...',
    'media.share': 'Partager',
    'media.stats.hours': 'heures',
    'media.stats.listening': 'Temps d\'écoute',
    'media.stats.listens': 'Écoutes',
    'media.stats.total_episodes': 'Nombre total d\'épisodes',
    'media.testimonial.no_results': 'Aucun témoignage trouvé',
    'media.testimonial.no_results_desc': 'Soyez le premier à partager votre expérience',
    'media.testimonial.satisfaction': 'Taux de satisfaction',
    'media.testimonial.search_placeholder': 'Rechercher des témoignages...',
    'media.testimonial.subtitle': 'Entendez des visiteurs et des exposants',
    'media.testimonial.title': 'Témoignages',
    'minisite.ai_info': 'Laissez l\'IA créer votre mini-site',
    'minisite.ai_unavailable': 'La génération IA est temporairement indisponible',
    'minisite.auto_creation_title': 'Générer votre minisite automatiquement',
    'minisite.auto_generate_button': 'Générer avec IA',
    'minisite.back_to_dashboard': 'Retour au tableau de bord',
    'minisite.button_next': 'Suivant',
    'minisite.button_previous': 'Précédent',
    'minisite.create.title': 'Créer votre minisite',
    'minisite.creation_error': 'Erreur lors de la création du minisite',
    'minisite.default_company': 'Nom de l\'entreprise',
    'minisite.delete_image': 'Supprimer l\'image',
    'minisite.editor.add_section': 'Ajouter une section',
    'minisite.editor.click_to_edit': 'Cliquez pour modifier',
    'minisite.editor.customize': 'Personnalisez votre minisite',
    'minisite.editor.empty_state': 'Aucun contenu ajouté',
    'minisite.error_title': 'Erreur de création du minisite',
    'minisite.generate_button': 'Générer un minisite',
    'minisite.generating': 'Génération de votre minisite...',
    'minisite.generating_auto': 'Génération avec IA...',
    'minisite.hero.cta_placeholder': 'Texte du bouton d\'action',
    'minisite.hero.tips.cta': 'Utilisez un appel à l\'action clair',
    'minisite.hero.tips.image': 'Utilisez une image de haute qualité qui représente votre entreprise',
    'minisite.invalid_url': 'Format d\'URL invalide',
    'minisite.login_required': 'Connexion requise pour créer un minisite',
    'minisite.manual_alternative': 'Ou créer manuellement',
    'minisite.page.create_subtitle': 'Choisissez comment vous souhaitez créer votre minisite',
    'minisite.page.create_title': 'Créer votre minisite',
    'minisite.page.scratch_desc': 'Construire à partir de zéro avec personnalisation complète',
    'minisite.page.scratch_option': 'Commencer à partir de zéro',
    'minisite.page.template_desc': 'Laissez l\'IA optimiser votre contenu',
    'minisite.page.template_option': 'Génération IA',
    'minisite.placeholder_company': 'Entrez le nom de votre entreprise',
    'minisite.placeholder_description': 'Décrivez votre entreprise et vos offres',
    'minisite.placeholder_products': 'Listez vos principaux produits ou services',
    'minisite.placeholder_socials': 'Ajoutez les liens de vos réseaux sociaux',
    'minisite.placeholder_url': 'Entrez l\'URL',
    'minisite.preview.create': 'Créer',
    'minisite.preview.edit': 'Modifier',
    'minisite.preview.products_found': 'produits trouvés',
    'minisite.preview.verify': 'Vérifier et publier',
    'minisite.section.gallery_desc': 'Mettez en valeur vos produits et services',
    'minisite.section.gallery_empty': 'Ajoutez des images à votre galerie',
    'minisite.section.gallery_order': 'Faites glisser pour réorganiser votre galerie',
    'minisite.section.gallery_title': 'Galerie d\'images',
    'minisite.section.products': 'Produits',
    'minisite.section.products_title': 'Produits en vedette',
    'minisite.step_company': 'Informations sur l\'entreprise',
    'minisite.step_description': 'Description de l\'entreprise',
    'minisite.step_documents': 'Documents',
    'minisite.step_logo': 'Logo de l\'entreprise',
    'minisite.step_products': 'Produits',
    'minisite.step_socials': 'Réseaux sociaux',
    'minisite.success_emoji': '🎉',
    'minisite.success_message': 'Votre minisite a été créé avec succès',
    'minisite.success_title': 'Minisite créé !',
    'minisite.unknown_error': 'Une erreur inconnue s\'est produite',
    'minisite.view_my_minisite': 'Voir mon minisite',
    'minisite.wizard_title': 'Assistant de création de minisite',
    'months.april': 'Avril',
    'networking.confirm.cancel': 'Annuler le rendez-vous',
    'networking.error.acceptance': 'Erreur lors de l\'acceptation',
    'networking.error.cancellation': 'Erreur lors de l\'annulation',
    'networking.error.duplicate_appointment': 'Ce rendez-vous existe déjà',
    'networking.error.duplicate_slot': 'Ce créneau est déjà pris',
    'networking.error.generation': 'Erreur lors de la génération des recommandations',
    'networking.error.invalid_dates': 'Plage de dates invalide',
    'networking.error.loading_data': 'Erreur lors du chargement des données',
    'networking.error.login_required': 'Connexion requise',
    'networking.error.must_be_logged': 'Vous devez être connecté',
    'networking.error.no_exhibitor': 'Exposant non trouvé',
    'networking.error.no_slot': 'Créneau non trouvé',
    'networking.error.past_slot': 'Ce créneau est dans le passé',
    'networking.error.profile_not_found': 'Profil non trouvé',
    'networking.error.quota_reached_free': 'Quota gratuit atteint',
    'networking.error.recommendations': 'Erreur lors du chargement des recommandations',
    'networking.error.refusal': 'Erreur lors du refus du rendez-vous',
    'networking.error.search': 'Erreur de recherche',
    'networking.error.slot_taken': 'Ce créneau est déjà pris',
    'networking.generation.loading': 'Génération des recommandations...',
    'networking.restricted': 'Cette fonctionnalité est restreinte',
    'networking.search.no_results': 'Aucun résultat trouvé',
    'networking.search_room': 'Rechercher des salles de networking',
    'networking.success.appointment_cancelled': 'Rendez-vous annulé',
    'networking.success.generated': 'Recommandations générées avec succès',
    'networking.success.recommendations': 'Recommandations chargées',
    'payment.pending_description': 'Votre paiement est en cours de traitement',
    'payment.pending_title': 'Paiement en attente',
    'payment.see_bank_details': 'Détails du virement bancaire',
    'products.error_saving_images': 'Erreur lors de l\'enregistrement des images',
    'products.min_one_image': 'Veuillez ajouter au moins une image de produit',
    'products.product_images': 'Images de produit',
    'products.upload_images_desc': 'Téléchargez jusqu\'à 5 images',
    'profile.about_placeholder': 'Parlez-nous de vous et de vos intérêts',
    'profile.change_photo': 'Changer la photo',
    'profile.country': 'Pays',
    'profile.first_name': 'Prénom',
    'profile.last_name': 'Nom de famille',
    'profile.not_found': 'Profil non trouvé',
    'profile.position': 'Poste',
    'quota.remaining_unlimited': 'Rendez-vous illimités',
    'quota.unlimited': 'Illimité',
    'quota.upgrade_for_more': 'Passer à une version supérieure pour plus de rendez-vous',
    'status.available': 'Disponible',
    'status.full': 'Complet',
    'status.no_spots': 'Aucune place disponible',
    'status.spots_available': 'Places disponibles',
    'sub.info.title1': 'Informations sur',
    'sub.info.titleHighlight': 'l\'événement',
    'ui.add_remove_favorite': 'Ajouter aux favoris',
    'ui.backward_10s': 'Reculer de 10 s',
    'ui.book_appointment': 'Réserver un rendez-vous',
    'ui.contact_directly': 'Contacter directement',
    'ui.contact_info': 'Informations de contact',
    'ui.forward_10s': 'Avancer de 10 s',
    'ui.search': 'Rechercher',
    'upload.max_size': 'La taille maximale du fichier est de 5 Mo',
    'upload.must_be_image': 'Le fichier doit être une image',
    'upload.upload_error': 'Erreur d\'upload',
    'visitor.action_required': 'Action requise',
    'visitor.appointment_with': 'Rendez-vous avec',
    'visitor.b2b_reserved_message': 'Les rendez-vous B2B sont réservés aux visiteurs Premium et VIP',
    'visitor.browse_program': 'Parcourir le programme',
    'visitor.my_schedule': 'Mon planning',
    'visitor.networking_hub': 'Hub de networking',
    'visitor.networking_hub_desc': 'Votre espace personnel de networking et de gestion de contacts',
    'visitor.new_invitations': 'Nouvelles invitations',
    'visitor.no_message': 'Aucun message',
    'visitor.no_registered_events': 'Aucun événement inscrit',
    'visitor.personal': 'Mon',
    'visitor.view_full_program': 'Voir le programme complet',
    'whatsapp.available_24_7': 'Disponible 24h/24 et 7j/7',
    'whatsapp.chat_team': 'Discutez avec notre équipe',
    'whatsapp.contact_whatsapp': 'Contacter via WhatsApp',
    'whatsapp.need_help': 'Besoin d\'aide ?',
    'pages.webinars.title': 'Webinaires SIPORT',
    'pages.webinars.description': 'Découvrez nos webinaires sponsorisés en replay. Sessions exclusives avec les experts de l\'industrie portuaire.',
    'pages.webinars.loading': 'Chargement des webinaires...',
    'pages.webinars.total_webinars': 'Webinaires au total',
    'pages.webinars.hours_content': 'heures de contenu',
    'pages.webinars.expert_speakers': 'experts de l\'industrie',
    'pages.webinars.filter_all': 'Tous',
    'pages.webinars.filter_recent': 'Récents',
    'pages.webinars.filter_popular': 'Populaires',
    'pages.webinars.search_webinars': 'Rechercher des webinaires...',
    'pages.webinars.no_results': 'Aucun webinaire trouvé',
    'pages.webinars.no_category': 'Non catégorisé',
    'pages.webinars.duration': 'Durée',
    'pages.webinars.participants': 'Participants',
    'pages.capsules.title': 'Capsules Vidéo SIPORT',
    'pages.capsules.description': 'Contenus courts et impactants sur l\'actualité portuaire',
    'pages.capsules.loading': 'Chargement des capsules...',
    'pages.capsules.total_capsules': 'Capsules disponibles',
    'pages.capsules.total_views': 'vues au total',
    'pages.capsules.trending_now': 'Tendance maintenant',
    'pages.capsules.filter_all': 'Tous',
    'pages.capsules.filter_recent': 'Récentes',
    'pages.capsules.filter_popular': 'Populaires',
    'pages.capsules.search_capsules': 'Rechercher des capsules...',
    'pages.capsules.no_results': 'Aucune capsule trouvée',
    'pages.capsules.add_to_favorites': 'Ajouter aux favoris',
    'pages.capsules.remove_from_favorites': 'Retirer des favoris',
    'pages.live.title': 'Studio en Direct SIPORT',
    'pages.live.description': 'Participez à nos émissions en direct. Interviews, débats et nouveautés du secteur maritime en temps réel.',
    'pages.live.loading': 'Chargement des émissions...',
    'pages.live.coming_soon': 'À venir',
    'pages.live.past_streams': 'Émissions précédentes',
    'pages.live.total_viewers': 'spectateurs',
    'pages.live.scheduled_broadcasts': 'Émissions programmées',
    'pages.live.average_duration': 'Durée moyenne',
    'pages.live.filter_all': 'Tous',
    'pages.live.filter_upcoming': 'À venir',
    'pages.live.filter_past': 'Passées',
    'pages.live.search_streams': 'Rechercher des émissions...',
    'pages.live.no_results': 'Aucune émission trouvée',
    'pages.moments.title': 'Meilleurs Moments SIPORT',
    'pages.moments.description': 'Revivez les plus beaux moments de SIPORT. Interviews, annonces marquantes et instants mémorables de l\'événement.',
    'pages.moments.loading': 'Chargement des moments...',
    'pages.moments.featured_moments': 'Moments en vedette',
    'pages.moments.total_moments': 'Moments disponibles',
    'pages.moments.event_highlights': 'Temps forts de l\'événement',
    'pages.moments.curated_by': 'Curé par l\'équipe SIPORTS',
    'pages.moments.filter_all': 'Tous',
    'pages.moments.filter_recent': 'Récents',
    'pages.moments.filter_popular': 'Populaires',
    'pages.moments.search_moments': 'Rechercher des moments...',
    'pages.moments.no_results': 'Aucun moment trouvé',
    'pages.moments.share_moment': 'Partager ce moment',
    'media.back_to_home': 'Retour à l\'accueil',
    'media.loading_content': 'Chargement du contenu...',
    'media.error_loading': 'Erreur lors du chargement du contenu',
    'media.retry': 'Réessayer',
    'common.featured': 'À la une',
    'common.speakers': 'Intervenants',
    'common.watch_replay': 'Voir le replay',
    'common.results': 'Résultats',
    'common.all_items': 'Tous les éléments',
    'common.modify_filters': 'Essayez de modifier vos filtres de recherche',
    'common.coming_soon': 'Les contenus seront bientôt disponibles',

    // Calendar & Availability
    'calendar.error_loading_slots': 'Erreur lors du chargement des créneaux',
    'calendar.error_fill_all_fields': 'Veuillez remplir tous les champs requis',
    'calendar.error_end_after_start': "L'heure de fin doit être après l'heure de début",
    'calendar.error_past_date': 'Impossible de créer un créneau pour une date passée',
    'calendar.error_slot_exists': 'Ce créneau existe déjà à cette date et heure',
    'calendar.error_adding_slot': "Erreur lors de l'ajout du créneau",
    'calendar.error_overlapping_slot': 'Ce créneau chevauche un créneau existant',
    'calendar.error_status_update': 'Erreur lors de la mise à jour du statut',
    'calendar.error_deletion': 'Erreur lors de la suppression',
    'calendar.error_deleting_slot': 'Erreur lors de la suppression du créneau',
    'calendar.success_added': 'Créneau ajouté avec succès',
    'calendar.success_modified': 'Créneau modifié avec succès',
    'calendar.success_deleted': 'Créneau supprimé avec succès',
    'calendar.success_reopened': 'Créneau réouvert',
    'calendar.success_closed': 'Créneau fermé temporairement',
    'calendar.success_period_blocked': 'créneau(x) supprimé(s) — période bloquée de',
    'calendar.confirm_reopen_slot': 'Le créneau est complet. Voulez-vous augmenter la capacité pour le réouvrir ?',
    'calendar.confirm_close_slot': 'Voulez-vous fermer ce créneau ?',
    'calendar.confirm_delete': 'Êtes-vous sûr de vouloir supprimer ce créneau ?',
    'calendar.confirm_block_with_bookings': 'créneau(x) seront supprimés dont {{count}} RDV déjà réservés. Les visiteurs concernés devront être notifiés. Continuer ?',
    'calendar.confirm_block_no_bookings': 'créneau(x) seront supprimés. Continuer ?',
    'calendar.info_no_slots_to_block': 'Aucun créneau à bloquer sur cette période',
    'calendar.block_period': 'Bloquer une période',
    'calendar.block_period_subtitle': 'Supprime tous les créneaux sur la plage horaire',
    'calendar.block_this_period': 'Bloquer cette période',
    'calendar.deleting': 'Suppression...',
    'calendar.auto_generation': 'Génération Automatique',
    'calendar.management_title': 'Gestion des Disponibilités',
    'calendar.management_subtitle': 'Créez et gérez vos créneaux de rendez-vous pour SIPORT 2026',
    'calendar.exclusive_event': 'Événement Exclusif',
    'calendar.no_availability_configured': 'Aucune disponibilité configurée',
    'calendar.empty_state_message': 'Commencez par ajouter vos créneaux de disponibilité pour permettre aux visiteurs de prendre rendez-vous avec vous pendant SIPORT 2026.',
    'calendar.generate_all_schedule': 'Générer tout mon planning',
    'calendar.create_manual_slot': 'Créer un créneau manuel',
    'calendar.slot_generator': 'Générateur de créneaux',
    'calendar.edit_slot': 'Modifier le créneau',
    'calendar.single_slot': 'Créneau unique',
    'calendar.bulk_generator': 'Générateur (Masse)',
    'calendar.block_start': 'Début',
    'calendar.block_end': 'Fin',
    'calendar.slots_affected': 'créneau(x) concerné(s)',
    'calendar.no_appointments': 'Aucun RDV',
    'calendar.appointments_warning': 'Attention : {{count}} RDV déjà réservé(s) seront annulé(s)',
    'calendar.appointments_booked': 'RDV réservés',
    'calendar.slot_date_label': 'Date du créneau',
    'calendar.meeting_type_label': 'Type de rencontre',
    'calendar.start_time': 'Heure de début',
    'calendar.end_time': 'Heure de fin',
    'calendar.max_participants': 'Participants max',
    'calendar.location_label': 'Lieu / Lien visioconférence',
    'calendar.location_placeholder': 'Stand A12, Salle B, https://meet.google.com/...',
    'calendar.location_hint': 'Pour les RDV virtuels, indiquez le lien de visioconférence',
    'calendar.description_label': 'Description (optionnel)',
    'calendar.description_placeholder': 'Sujet du rendez-vous, agenda, préparation nécessaire...',
    'calendar.saving': 'Enregistrement...',
    'calendar.create_slot': 'Créer le créneau',
    'calendar.modify': 'Modifier',
    'calendar.cancel': 'Annuler',
    'calendar.date': 'Date',
    'calendar.mandatory_management': 'Gestion des créneaux obligatoire',
    'calendar.mandatory_management_desc_exhibitor': "En tant qu'exposant, vous devez définir vos créneaux de disponibilité pour permettre aux autres participants de prendre rendez-vous. Ces créneaux apparaîtront dans votre profil et seront visibles lors des recommandations IA.",
    'calendar.mandatory_management_desc_partner': 'En tant que partenaire, vous devez définir vos créneaux de disponibilité pour permettre aux autres participants de prendre rendez-vous. Ces créneaux apparaîtront dans votre profil et seront visibles lors des recommandations IA.',

    // Slot types
    'slot_type.in_person': 'Présentiel',
    'slot_type.virtual': 'Virtuel',
    'slot_type.hybrid': 'Hybride',

    // Actions
    'actions.reopen': 'Réouvrir',
    'actions.close_slot': 'Fermer le créneau',
    'actions.remove': 'Retirer',

    // Appointment notifications
    'appointment.notification_confirmed': 'Rendez-vous confirmé',
    'appointment.notification_rejected': 'Rendez-vous refusé',
    'appointment.notification_cancelled': 'Rendez-vous annulé',
    'appointment.toast_confirmed': 'Rendez-vous confirmé !',
    'appointment.toast_confirmed_desc': 'Les participants ont été notifiés.',
    'appointment.toast_rejected': 'Rendez-vous refusé',
    'appointment.toast_rejected_desc': 'Le visiteur a été notifié.',
    'appointment.error_booking_in_progress': 'Une réservation est déjà en cours. Veuillez patienter.',
    'appointment.error_not_authenticated': 'Vous devez être connecté pour réserver un rendez-vous.',
    'appointment.error_booking': 'Erreur lors de la réservation',
    'appointment.error_cancel_not_authenticated': 'Vous devez être connecté pour annuler un rendez-vous.',
    'appointment.error_already_booked': 'Vous avez déjà réservé ce créneau',
    'appointment.error_already_booked_exhibitor': 'Vous avez déjà un rendez-vous avec cet exposant/partenaire',
    'appointment.error_slot_not_found': 'Créneau non trouvé. Veuillez actualiser la page.',
    'appointment.error_no_owner': "Ce créneau n'a pas de propriétaire valide. Veuillez contacter le support.",
    'appointment.error_past_slot': 'Ce créneau est dans le passé. Veuillez choisir un créneau futur.',
    'appointment.error_outside_dates': 'Ce créneau est en dehors des dates du salon (1-3 Avril 2026)',
    'appointment.error_slot_full': 'Ce créneau est complet. Veuillez en choisir un autre.',
    'appointment.error_no_valid_date': "Ce créneau n'a pas de date valide",

    // Email templates
    'email.subject_appointment_confirmed': 'Rendez-vous confirmé',
    'email.subject_appointment_confirmed_prefix': 'Confirmation',
    'email.subject_appointment_rejected': 'Rendez-vous refusé',
    'email.subject_appointment_cancelled': 'Rendez-vous annulé avec',
    'email.subject_new_request': 'Nouvelle demande de RDV de',
    'email.subject_welcome': 'Bienvenue au SIPORT 2026',
    'email.subject_welcome_suffix': 'Inscription',
    'email.subject_payment_confirmed': 'Paiement confirmé - SIPORT 2026',
    'email.label_date': 'Date',
    'email.label_time': 'Heure',
    'email.label_type': 'Type',
    'email.label_location': 'Lieu',
    'email.label_name': 'Nom',
    'email.label_email': 'Email',
    'email.label_position': 'Fonction',
    'email.label_company': 'Entreprise',
    'email.label_amount': 'Montant',
    'email.label_receipt': 'N° de reçu',
    'email.label_level': 'Niveau',
    'email.label_status': 'Statut',
    'email.label_with': 'Avec',
    'email.confirmed_title': 'Rendez-vous confirmé',
    'email.confirmed_body_visitor': 'Votre rendez-vous avec {{name}} a été confirmé.',
    'email.confirmed_body_exhibitor': 'Vous avez confirmé le rendez-vous avec {{name}}.',
    'email.rejected_title': 'Rendez-vous refusé',
    'email.rejected_body': 'Malheureusement, votre demande de rendez-vous avec {{name}} a été refusée.',
    'email.rejected_action': "Vous pouvez proposer un autre créneau auprès de cet exposant ou consulter d'autres exposants disponibles.",
    'email.cancelled_title': 'Rendez-vous annulé',
    'email.cancelled_body': 'Le rendez-vous avec {{name}} prévu le {{date}} à {{time}} a été annulé par {{cancelledBy}}.',
    'email.cancelled_by_visitor': 'le visiteur',
    'email.cancelled_by_exhibitor': "l'exposant",
    'email.cancelled_reschedule': "N'hésitez pas à prendre un nouveau rendez-vous si nécessaire.",
    'email.new_request_title': 'Nouvelle demande de rendez-vous',
    'email.new_request_body': '{{name}} souhaite prendre rendez-vous avec vous.',
    'email.new_request_action': 'Vous pouvez confirmer ou refuser cette demande depuis votre tableau de bord.',
    'email.visitor_information': 'Informations du visiteur',
    'email.requested_slot': 'Créneau demandé',
    'email.visitor_message': 'Message du visiteur',
    'email.welcome_title': 'Bienvenue au SIPORT 2026 !',
    'email.welcome_body': 'Votre inscription en tant que Visiteur {{level}} a été confirmée avec succès !',
    'email.summary': 'Récapitulatif',
    'email.status_confirmed': 'Confirmé',
    'email.payment_instructions_title': 'Instructions de paiement',
    'email.payment_instructions_body': 'Pour activer votre badge {{level}}, veuillez procéder au paiement par virement bancaire depuis votre tableau de bord.',
    'email.event_information': 'Informations du salon',
    'email.event_dates': 'Dates : 1 - 3 Avril 2026',
    'email.event_location': "Lieu : Parc d'Exposition Mohammed VI, El Jadida, Maroc",
    'email.event_hours': 'Horaires : 09h00 - 18h00',
    'email.payment_confirmed_title': 'Paiement confirmé',
    'email.payment_confirmed_body': 'Nous avons bien reçu votre paiement. Votre badge {{level}} est maintenant actif !',
    'email.payment_confirmed_access': 'Vous avez désormais accès à toutes les fonctionnalités {{level}}.',
    'email.keep_for_confirmation': 'Conservez cet email comme confirmation de votre inscription.',
    'email.keep_for_payment': 'Conservez cet email comme preuve de paiement.',
    'email.subject_payment_approved': 'Paiement approuvé - SIPORT 2026',
    'email.payment_approved_title': 'Paiement approuvé',
    'email.payment_approved_body': 'Votre paiement a été validé par notre équipe. Votre badge {{level}} est maintenant actif !',
    'email.payment_approved_badge_active': 'Badge actif',
    'email.subject_payment_rejected': 'Paiement refusé - SIPORT 2026',
    'email.payment_rejected_title': 'Paiement refusé',
    'email.payment_rejected_body': 'Votre demande de paiement n\'a malheureusement pas pu être validée.',
    'email.payment_rejected_reason': 'Motif',
    'email.payment_rejected_action': 'Vous pouvez soumettre un nouveau paiement ou contacter notre support pour plus d\'informations.',
    'email.payment_rejected_retry': 'Réessayer',
    'email.contact_support': 'Contacter le support',
    'email.subject_level_changed': 'Changement de niveau - SIPORT 2026',
    'email.level_changed_title': 'Votre niveau a été modifié',
    'email.level_changed_body_upgrade': 'Bonne nouvelle ! Votre niveau d\'accès a été mis à jour.',
    'email.level_changed_body_downgrade': 'Votre niveau d\'accès a été modifié.',
    'email.level_changed_old_level': 'Ancien niveau',
    'email.level_changed_new_level': 'Nouveau niveau',
    'email.level_changed_new_features': 'Découvrez les nouvelles fonctionnalités disponibles dans votre tableau de bord.',
    'email.reminder_24h': 'Nous vous rappelons ce rendez-vous 24h avant la date prévue.',
    'email.view_my_appointments': 'Voir mes rendez-vous',
    'email.view_available_exhibitors': 'Voir les exposants disponibles',
    'email.manage_requests': 'Gérer mes demandes',
    'email.access_dashboard': 'Accéder à mon tableau de bord',
    'email.sign_off_soon': 'À bientôt,',
    'email.sign_off_regards': 'Cordialement,',
    'email.sign_off_thanks': 'Merci de votre confiance,',
    'email.team_signature': "L'équipe SIPORT 2026",
    'email.greeting': 'Bonjour',
    'email.header_subtitle': 'Salon International des Ports',
    'email.footer_title': 'SIPORTS 2026 - Salon International Portuaire',
    'email.footer_location': "1-3 Avril 2026, Parc d'Exposition Mohammed VI, El Jadida, Maroc",
    'email.footer_unsubscribe': 'Vous recevez cet email car vous êtes inscrit sur siportevent.com',
    'email.label_requested_date': 'Date demandée',
    'email.label_requested_time': 'Heure demandée',
    'email.label_exhibitor': 'Exposant',

    // Visitor levels
    'visitor.level_free': 'Gratuit',
    'visitor.level_premium': 'Premium',
    'visitor.level_vip': 'VIP',
  },

  en: {
    'nav.home': 'Home',
    'nav.exhibitors': 'Exhibitors',
    'nav.partners': 'Partners',
    'nav.networking': 'Networking',
    'nav.event': 'Event',
    'nav.participate': 'Participate',
    'nav.contact': 'Contact',
    'nav.pavilions': 'Pavilions',
    'nav.events': 'Events',
    'nav.news': 'News',
    'nav.information': 'Information',
    'nav.accommodation': 'Accommodation',
    'nav.subscriptions': 'Subscriptions',
    'nav.dashboard': 'Dashboard',
    'nav.appointments': 'Appointments',
    'nav.chat': 'Messaging',
    'nav.profile': 'My Profile',
    'nav.login': 'Login',
    'nav.register': 'Register',
    'nav.logout': 'Logout',
    'menu.pavilions_desc': 'Explore the exhibition pavilions',
    'menu.events_desc': 'Conferences and workshops',
    'menu.news_desc': 'Latest event news',
    'menu.subscriptions_desc': 'Available subscription plans',
    'menu.accommodation_desc': 'Partner hotels & preferential rates',
    'event.about': 'About SIPORTS',
    'event.about_desc': 'Discover the international show',
    'event.program': 'Program',
    'event.program_desc': 'Conferences & speakers',
    'event.pavilions': 'Pavilions',
    'event.pavilions_desc': 'Thematic zones & exhibitors',
    'event.news': 'News',
    'event.news_desc': 'Latest updates',
    'event.prepare_visit': 'Prepare your visit',
    'event.prepare_desc': 'Accommodation, access & map',
    'participate.visitors': 'Visitors',
    'participate.visitors_desc': 'Free registration or VIP Pass',
    'participate.become_exhibitor': 'Become exhibitor',
    'participate.exhibitor_desc': 'Exhibitor pricing & packages',
    'participate.become_partner': 'Become partner',
    'participate.partner_desc': 'Sponsorship opportunities',
    'media.menu_title': 'Media',
    'media.webinars': 'Webinars',
    'media.webinars_desc': 'Sponsored webinars replay',
    'media.podcasts': 'Podcasts',
    'media.podcasts_desc': 'SIPORT Talks - Audio episodes',
    'media.capsules': 'Inside Capsules',
    'media.capsules_desc': 'Inside SIPORT Video Capsules',
    'media.live_studio': 'Live Studio',
    'media.live_studio_desc': 'Meet The Leaders - Live Interviews',
    'media.best_moments': 'Best Moments',
    'media.best_moments_desc': 'Best moments of the show',
    'media.testimonials': 'Testimonials',
    'media.testimonials_desc': 'Video testimonials',
    'media.library': 'Media Library',
    'media.library_desc': 'All media content',
    'home.views': 'views',
    'home.benefits': 'benefits',
    'home.see_profile': 'View Profile',
    'home.contact_partner': 'Contact',
    'home.products': 'products',
    'home.make_appointment': 'Make Appointment',
    'home.ai_assistant': 'AI Assistant',
    'home.ai_assistant_toast': 'SIPORTS AI Assistant v3.0 - Log in to access full AI features with smart recommendations, sector matching, and agenda optimization!',
    'categories.institutional': 'Institutional',
    'categories.port-industry': 'Port Industry',
    'categories.port-operations': 'Port Operations',
    'categories.academic': 'Academic & Training',
    'pages.exhibitors.title': 'Exhibitors',
    'pages.exhibitors.description': 'Discover the companies and organizations in the port industry',
    'pages.exhibitors.search': 'Search for an exhibitor',
    'pages.exhibitors.filter_category': 'Category',
    'pages.exhibitors.all_categories': 'All categories',
    'pages.exhibitors.category_institutional': 'Institutional',
    'pages.exhibitors.category_port_industry': 'Port Industry',
    'pages.exhibitors.category_operations': 'Operations & Management',
    'pages.exhibitors.category_academic': 'Academic & Training',
    'pages.exhibitors.category_technology': 'Technology',
    'pages.exhibitors.category_automation': 'Automation',
    'pages.exhibitors.category_equipment': 'Equipment',
    'pages.exhibitors.featured': 'Featured',
    'sector.technology': 'Technology',
    'sector.port_industry': 'Port Industry',
    'sector.automation': 'Automation',
    'sector.equipment': 'Equipment',
    'sector.operations_management': 'Operations & Management',
    'pages.exhibitors.verified': 'Verified',
    'pages.exhibitors.contact': 'Contact',
    'pages.exhibitors.view_profile': 'View Profile',
    'pages.exhibitors.no_results': 'No exhibitors found',
    'exhibitor_levels.basic_9': '9m² Basic',
    'exhibitor_levels.standard_18': '18m² Standard',
    'exhibitor_levels.premium_36': '36m² Premium',
    'exhibitor_levels.elite_54plus': '54m²+ Elite',
    'pages.partners.title': 'Partners & Sponsors',
    'pages.partners.description': 'Organizations supporting SIPORTS 2026',
    'pages.partners.search': 'Search for a partner',
    'pages.partners.filter_tier': 'Partnership Type',
    'pages.partners.tier_museum': 'Museum',
    'pages.partners.tier_silver': 'Silver',
    'pages.partners.tier_gold': 'Gold',
    'pages.partners.tier_platinum': 'Platinum',
    'pages.partners.view_details': 'View Details',
    'pages.partners.no_results': 'No partners found',
    'pages.partners.category_education': 'Education & Training',
    'pages.partners.category_institutional': 'Institutional',
    'pages.partners.category_logistics': 'Logistics',
    'pages.partners.category_technology': 'Technology',
    'pages.partners.category_media': 'Media',
    'pages.partners.try_modify': 'Try modifying your filters',
    'pages.partners.reset_filters': 'Reset filters',
    'pages.events.title': 'Events',
    'pages.events.description': 'Conferences, workshops and exhibition activities',
    'pages.events.search': 'Search for an event',
    'pages.events.filter_date': 'Date',
    'pages.events.date': 'Date',
    'pages.events.time': 'Time',
    'pages.events.location': 'Location',
    'pages.events.capacity': 'Available Spots',
    'pages.events.register': 'Register',
    'pages.events.registered': 'Registered',
    'pages.events.no_results': 'No events found',
    'pages.events.scientific_programme': 'Scientific Programme',
    'pages.events.type_officiel': 'Official',
    'pages.events.type_panel': 'Panel',
    'pages.events.type_table_ronde': 'Round Table',
    'pages.events.type_ted_talk': 'Ted Talk',
    'pages.events.type_atelier': 'Workshop',
    'pages.events.type_pause': 'Break',
    'pages.events.type_concours': 'Competition',
    'pages.events.type_cloture': 'Closing',
    'pages.events.strategic_reflection': 'A strategic reflection space bringing together institutional decision-makers and major players in the port ecosystem.',
    'pages.events.info_dates_location': '{dates} · {location}',
    'pages.news.title': 'News',
    'pages.news.description': 'Latest news from the exhibition and industry',
    'pages.news.search': 'Search for news',
    'pages.news.read_more': 'Read More',
    'pages.news.published': 'Published on',
    'pages.news.no_results': 'No news found',
    'pages.news.min_read': 'min read',
    'pages.news.categories': 'Categories',
    'pages.news.all_categories': 'All Categories',
    'pages.news.featured': 'Featured',
    'pages.news.trending': 'Trending',
    'article.siports_2026': 'SIPORTS 2026: International Exhibition of Ports and Logistics',
    'article.siports_excerpt': 'Discover the largest port event in North Africa planned for 2026. A unique opportunity for networking and discoveries.',
    'article.siports_content': 'SIPORTS 2026 is the essential meeting point for professionals in the port and logistics sector. This major event will bring together key players in the maritime industry to exchange ideas on innovations, challenges and opportunities in the sector.',
    'article.innovation_title': 'Port Innovation: Technologies That Transform Our Ports',
    'article.innovation_excerpt': 'Artificial intelligence, automation, IoT: modern ports adopt cutting-edge technologies to improve their efficiency.',
    'article.innovation_content': 'Ports around the world are heavily investing in new technologies. From crane automation to artificial intelligence for optimizing flows, discover the innovations shaping the future of the maritime sector.',
    'article.durability_title': 'Sustainable Development: Ports Commit to the Environment',
    'article.durability_excerpt': 'Ecological initiatives are multiplying in ports to reduce the carbon footprint of maritime transport.',
    'article.durability_content': 'Facing climate challenges, ports are adopting ambitious strategies to reduce their environmental impact. Renewable energies, quay electrification, waste management: an overview of best practices.',
    'article.mediterranean_title': 'Maritime Trade in the Mediterranean: 2026 Perspectives',
    'article.mediterranean_excerpt': 'Analysis of trends in Mediterranean maritime trade and opportunities for industry players.',
    'article.mediterranean_content': 'The Mediterranean remains a strategic hub for world trade. With the evolution of trade routes and new agreements, the Mediterranean basin offers many growth opportunities.',
    'article.careers_title': 'Training and Employment: Port Jobs of Tomorrow',
    'article.careers_excerpt': 'The port sector is hiring! Discover training programs and career opportunities in the maritime industry.',
    'article.careers_content': 'The port sector is undergoing major changes and seeking new talent. From traditional occupations to new specialties related to digitalization, opportunities are numerous for those wishing to build a career in this field.',
    'article.security_title': 'Port Security: New International Standards',
    'article.security_excerpt': 'Security standards are evolving to meet new challenges in global maritime transport.',
    'article.security_content': 'Safety remains a top priority in port facilities. Cybersecurity, access control, risk prevention: discover the latest regulations and innovations in port security.',
    'admin.title': 'Administration',
    'admin.dashboard': 'Dashboard',
    'admin.dashboard_title': 'Admin Dashboard',
    'admin.welcome': 'Welcome, {{name}}',
    'admin.system_operational': 'System Operational',
    'admin.system_uptime': 'System Uptime',
    'admin.api_calls_per_day': 'API Calls / Day',
    'admin.storage_used': 'Storage Used',
    'admin.required_actions': 'Required Actions',
    'admin.items_need_attention': '{{count}} items need your attention',
    'admin.registration_requests': 'Registration Requests',
    'admin.click_to_process': 'Click to process',
    'admin.payment_validation': 'Payment Validation',
    'admin.manage_proofs': 'Manage Proofs',
    'admin.exhibitors': 'Exhibitors',
    'admin.partners': 'Partners',
    'admin.visitors': 'Visitors',
    'admin.visits': 'Visits',
    'admin.list_and_subscriptions': 'List & Subscriptions',
    'admin.list_and_packs': 'List & Packs',
    'admin.vip_visitors_management': 'VIP Visitors Management',
    'admin.view_list': 'View List',
    'admin.content_moderation': 'Content to Moderate',
    'admin.active_contracts': 'Active Contracts',
    'admin.create_partner': 'Create Partner',
    'admin.manage_partners_action': 'Manage Partners',
    'admin.create_exhibitor': 'Create Exhibitor',
    'admin.manage_exhibitors_action': 'Manage Exhibitors',
    'admin.create_event': 'Create Event',
    'admin.manage_events_action': 'Manage Events',
    'admin.create_article': 'Create Article',
    'admin.manage_articles_action': 'Manage Articles',
    'admin.create_pavilion_action': 'Create Pavilion',
    'admin.manage_pavilions_action': 'Manage Pavilions',
    'admin.manage_media_action': 'Manage Media',
    'admin.validate_media': 'Validate Media',
    'admin.sync_articles': 'Sync Articles',
    'admin.syncing': 'Syncing...',
    'admin.publication_control': 'Publication Control',
    'admin.publication_warning': 'Enable/Disable GLOBAL visibility',
    'admin.total_control': 'TOTAL CONTROL',
    'admin.quick_actions': 'Quick Actions & Navigation',
    'admin.participant_management': 'Participant Management',
    'admin.content_management': 'Content Management',
    'admin.media_management_section': 'Media Management',
    'admin.nav_and_stats': 'Navigation & Statistics',
    'admin.analytics_trends': 'Analytics & Trends',
    'admin.realtime_data': 'Real-time Data',
    'admin.user_growth': 'User Growth (Last 6 months)',
    'admin.total_users_chart': 'Total Users',
    'admin.user_distribution': 'User Distribution',
    'admin.platform_activity': 'Platform Activity (This week)',
    'admin.weekly_traffic': 'Weekly Traffic',
    'admin.chart_visits': 'Visits',
    'admin.chart_pageviews': 'Page views',
    'admin.metrics_label': 'Metrics',
    'admin.performance_label': 'Performance',
    'admin.users_label': 'Users',
    'admin.pavilions_label': 'Pavilions',
    'admin.events_label': 'Events',
    'admin.system_health': 'System Health',
    'admin.api_calls_24h': 'API Calls (24h)',
    'admin.avg_response_time': 'Avg Response Time',
    'admin.recent_activity': 'Recent System Activity',
    'admin.view_all': 'View All',
    'admin.active_exhibitors': 'Active Exhibitors',
    'admin.registered_visitors': 'Registered Visitors',
    'admin.official_partners': 'Official Partners',
    'admin.conferences_workshops': 'Conferences & Workshops',
    'admin.detailed_metrics': 'Detailed Metrics & Performance',
    'admin.detailed_metrics_desc': 'Access full performance analytics for SIPORTS 2026',
    'admin.full_metrics': 'View Full Metrics',
    'admin.admin_access_only': 'Admin Access Only',
    'admin.online': 'online',
    'admin.sync_label': 'Synchronization',
    'admin.events_section': 'Events',
    'admin.articles_section': 'Articles',
    'admin.pavilions_section': 'Thematic Pavilions',
    'admin.medias_section': 'Media',
    'admin.users_management': 'User Management',
    'admin.exhibitors_management': 'Exhibitors Management',
    'admin.partners_management': 'Partners Management',
    'admin.events_management': 'Events Management',
    'admin.news_management': 'News Management',
    'admin.pavilions_management': 'Pavilions Management',
    'admin.vip_visitors': 'VIP Visitors Management',
    'admin.live_studio_management': 'Live Studio Management',
    'admin.media_manager': 'Media Manager',
    'admin.analytics': 'Analytics',
    'admin.settings': 'Settings',
    'admin.total_users': 'Total Users',
    'admin.active_users_count': '{{count}} active users',
    'admin.total_exhibitors': 'Total Exhibitors',
    'admin.total_partners': 'Total Partners',
    'admin.pending_approval': 'Pending Approval',
    'admin.approve': 'Approve',
    'admin.reject': 'Reject',
    'admin.edit': 'Edit',
    'admin.delete': 'Delete',
    'admin.edit_profile': 'Edit Profile',
    'admin.media_management': 'Media Management',
    'admin.new_exhibitor': 'New Exhibitor',
    'admin.new_partner': 'New Partner',
    'admin.new_event': 'New Event',
    'admin.new_article': 'New Article',
    'admin.manage_exhibitors_desc': 'Manage all exhibitors on the platform',
    'admin.manage_partners_desc': 'Manage all partners on the platform',
    'admin.manage_events_desc': 'Manage all events on the platform',
    'admin.manage_users_desc': 'Manage all users on the platform',
    'admin.edit_user': 'Edit user',
    'admin.change_status': 'Status',
    'admin.change_level': 'Level',
    'admin.change_role': 'Role',
    'admin.save_changes': 'Save changes',
    'admin.cancel': 'Cancel',
    'admin.user_updated': 'User updated successfully',
    'admin.user_update_error': 'Error updating user',
    'admin.manage_news_desc': 'Manage all articles and news on the platform',
    'admin.back_to_media': 'Back to media management',
    'admin.total_events': 'Total Events',
    'admin.upcoming': 'Upcoming',
    'admin.types': 'Types',
    'admin.this_month': 'This Month',
    'admin.total_articles': 'Total Articles',
    'admin.published': 'Published',
    'admin.loading_events': 'Loading events...',
    'admin.loading_articles': 'Loading articles...',
    'admin.search_event': 'Search event...',
    'admin.search_article': 'Search article...',
    'admin.all_types': 'All types',
    'admin.media_management_title': 'Media Management',
    'admin.media_management_desc': 'Validate, moderate and manage all media content',
    'admin.new_media': 'Create New Media',
    'admin.total_media': 'Total Media',
    'admin.pending': 'Pending',
    'admin.approved': 'Approved',
    'admin.rejected': 'Rejected',
    'admin.pavilions_management_title': 'Pavilions Management',
    'admin.pavilions_management_desc': 'Administration and organization of SIPORTS 2026 pavilions',
    'admin.create_pavilion': 'Create Pavilion',
    'admin.total_pavilions': 'Total Pavilions',
    'admin.active_pavilions': 'Active',
    'admin.total_exhibitors_in_pavilions': 'Exhibitors',
    'admin.status_published': 'Published',
    'admin.status_pending': 'Pending',
    'admin.status_rejected': 'Rejected',
    'admin.loading': 'Loading...',
    'admin.no_media_found': 'No media found',
    'admin.confirm_delete_media': 'Are you sure you want to delete this media?',
    'visitor.registration.free.title': 'Free Visitor Registration',
    'visitor.registration.free.subtitle': 'Standard access to SIPORTS 2026',
    'visitor.registration.free.badge_access': 'Show Access',
    'visitor.registration.free.badge_qr': 'QR Badge',
    'visitor.registration.free.badge_free': 'Free',
    'visitor.form.firstname': 'First Name',
    'visitor.form.lastname': 'Last Name',
    'visitor.form.email': 'Professional Email',
    'visitor.form.phone': 'Phone',
    'visitor.form.country': 'Country',
    'visitor.form.sector': 'Business Sector',
    'visitor.form.position': 'Job Title',
    'visitor.form.company': 'Company / Organization',
    'visitor.form.password': 'Password',
    'visitor.form.confirm_password': 'Confirm Password',
    'visitor.form.submit': 'Complete Registration',
    'visitor.form.submitting': 'Processing...',
    'visitor.validation.firstname_required': 'First name is required',
    'visitor.validation.lastname_required': 'Last name is required',
    'visitor.validation.email_invalid': 'Invalid email address',
    'visitor.validation.phone_invalid': 'Invalid phone number',
    'visitor.validation.country_required': 'Country is required',
    'visitor.validation.sector_required': 'Business sector is required',
    'visitor.validation.password_length': 'Password must be at least 12 characters',
    'visitor.validation.password_requirements': 'Password must contain uppercase, lowercase, number and special character',
    'visitor.validation.password_match': 'Passwords do not match',
    'visitor.validation.phone_required': 'Phone number is required',
    'visitor.validation.position_required': 'Job title is required',
    'visitor.validation.company_required': 'Company is required',
    'visitor.validation.check_errors': 'Please correct the highlighted errors',
    'visitor.sector.authority': 'Port Authority',
    'visitor.sector.transport': 'Maritime Transport',
    'visitor.sector.logistics': 'Logistics',
    'visitor.sector.consulting': 'Consulting',
    'visitor.sector.technology': 'Technology',
    'visitor.sector.student': 'Student',
    'visitor.sector.media': 'Media/Press',
    'visitor.sector.institutional': 'Institutional',
    'visitor.sector.other': 'Other',
    'visitor.free.features.title': 'Included with your free account:',
    'visitor.free.features.list.1': 'Access to public show areas',
    'visitor.free.features.list.2': 'Standard digital badge',
    'visitor.free.features.list.3': 'SIPORTS Newsletter',
    'visitor.free.features.list.4': 'Access to standard mobile app',
    'visitor.upsell.vip.title': 'Looking for more benefits?',
    'visitor.upsell.vip.button': 'Discover VIP Offer',
    'visitor.message.email_check_error': 'Error checking email. Please try again.',
    'visitor.message.account_exists': 'An account already exists with this email',
    'visitor.message.account_exists_desc': 'Please log in directly.',
    'visitor.message.email_sent': 'Welcome email sent!',
    'visitor.message.success_title': 'Registration Successful!',
    'visitor.message.success_desc': 'Your free visitor account has been created successfully.',
    'visitor.message.redirect': 'Redirecting to your space...',
    'visitor.dashboard': 'My Space',
    'visitor.my_profile': 'My Profile',
    'visitor.my_appointments': 'My Appointments',
    'visitor.my_favorites': 'My Favorites',
    'visitor.upgrade': 'Upgrade Account',
    'visitor.subscription_level': 'Subscription Level',
    'visitor.member_since': 'Member Since',
    'visitor.my_badge': 'My Digital Badge',
    'visitor.discover_exhibitors': 'Discover Exhibitors',
    'visitor.registrations_title': 'Registrations',
    'visitor.event_past': 'Past',
    'visitor.b2b_management_title': 'B2B Appointments Management',
    'visitor.b2b_management_subtitle': 'Organize your meetings with exhibitors',
    'visitor.confirmed_agenda': 'Confirmed Agenda',
    'visitor.no_upcoming_confirmed': 'No upcoming confirmed appointments',
    'visitor.past_appointments': 'Past Appointments',
    'visitor.no_past_appointments': 'No past appointments',
    'visitor.cancelled_appointments': 'Cancelled Appointments',
    'visitor.no_cancelled_appointments': 'No cancelled appointments',
    'visitor.appointment_cancelled': 'Cancelled',
    'visitor.select_next_meeting': 'Select your next strategic meeting',
    'visitor.error_loading_appointments': 'Unable to load appointments. Please try again.',
    'visitor.unauthorized_access': 'Unauthorized Access',
    'visitor.please_login': 'Please log in to access this page',
    'visitor.visitor_area': 'Visitor Area',
    'visitor.my_virtual_badge': 'My Virtual Badge',
    'visitor.connected': 'Connected',
    'visitor.appointments_remaining': 'Appointments Remaining',
    'visitor.b2b_appointments': 'B2B Appointments',
    'visitor.refused': 'Refused',
    'visitor.exhibitors_visited': 'Exhibitors Visited',
    'visitor.favorites': 'Favorites',
    'visitor.connections': 'Connections',
    'visitor.messages': 'Messages',
    'visitor.appointments_booked': 'Appointments Booked',
    'visitor.level_label': 'Level',
    'visitor.events_registered': 'Events Registered',
    'visitor.vip_benefits_title': 'VIP Benefits',
    'visitor.vip_benefits_subtitle': 'Enjoy all premium privileges',
    'visitor.vip_appointments': '10 B2B Appointments',
    'visitor.vip_appointments_desc': 'Enjoy 10 appointments to maximize your contacts',
    'visitor.vip_messaging': 'Unlimited Messaging',
    'visitor.vip_messaging_desc': 'Contact all exhibitors without limit',
    'visitor.vip_badge': 'Visible VIP Badge',
    'visitor.vip_badge_desc': 'Be identified as a premium visitor',
    'visitor.vip_ai_matching': 'Priority AI Matching',
    'visitor.vip_ai_matching_desc': 'Priority algorithm to find the best contacts',
    'visitor.vip_webinars': 'Exclusive Webinar Access',
    'visitor.vip_webinars_desc': 'Content reserved for VIPs',
    'visitor.vip_support_priority': 'Priority Support',
    'visitor.vip_support_desc': 'Dedicated 24/7 assistance',
    'visitor.vip_news_priority': 'News Preview',
    'visitor.vip_news_desc': 'Receive news first',
    'visitor.ai_networking': 'AI Networking',
    'visitor.ai_networking_desc': 'Discover relevant contacts with our AI',
    'visitor.explore_network': 'Explore Network',
    'visitor.configure_matching': 'Configure Matching',
    'visitor.schedule_appointment': 'Schedule Appointment',
    'visitor.schedule_appointment_desc': 'Book a slot with an exhibitor',
    'visitor.program_appointment': 'Schedule Appointment',
    'visitor.your_activity': 'Your Activity',
    'visitor.your_activity_desc': 'Track your real-time statistics',
    'visitor.live': 'LIVE',
    'visitor.visits': 'Visits',
    'visitor.interactions': 'Interactions',
    'visitor.currently': 'Currently',
    'visitor.previous_period': 'Previous Period',
    'visitor.confirmed_appointments': 'Confirmed Appointments',
    'visitor.connections_established': 'Connections Established',
    'visitor.messaging': 'Messaging',
    'visitor.messaging_desc': 'Communicate directly with exhibitors',
    'visitor.open_messaging': 'Open Messaging',
    'events.unregister': 'Unregister',
    'appointments.calendar': 'Calendar',
    'partner.activation_required': 'Activation Required',
    'partner.payment_validation_needed': 'To access your partner space, please finalize payment of your partnership pack.',
    'partner.finalize_payment': 'Finalize Payment',
    'partner.access_denied': 'Access Denied',
    'partner.reserved_partners': 'This section is reserved for official SIPORTS partners',
    'partner.hero_subtitle': 'Partner Dashboard',
    'partner.virtual_badge': 'Virtual Partner Badge',
    'partner.roi_performance': 'ROI Performance',
    'partner.dashboard_live': 'LIVE Dashboard',
    'partner.tabs.overview': 'Overview',
    'partner.tabs.profile': 'Profile',
    'partner.tabs.networking': 'Networking',
    'partner.tabs.analytics': 'Analytics',
    'partner.payment_validation_required': 'Payment Validation Required',
    'partner.payment_activation_message': 'Your partner profile will be activated after payment validation by our team.',
    'partner.make_payment': 'Make Payment',
    'partner.stats.profile_views': 'Profile Views',
    'partner.stats.connections': 'Connections',
    'partner.stats.appointments': 'Appointments',
    'partner.stats.messages': 'Messages',
    'partner.quotas.title': 'Your Partner Quotas',
    'partner.quotas.appointments': 'Appointments',
    'partner.quotas.team_members': 'Team Members',
    'partner.quotas.media_files': 'Media Files',
    'partner.recent_activity': 'Recent Activity',
    'partner.ai_generation': 'AI Profile Generation',
    'partner.ai_description': 'Let our AI automatically create your partner profile from your website',
    'partner.ai_button': '🤖 Generate with AI',
    'partner.manual_management': 'Manual Management',
    'partner.edit_basic_info': '✏️ Edit Basic Info',
    'partner.media_catalog': '📸 Media Catalog',
    'partner.appointments_management': 'Appointment Management',
    'partner.appointments_description': 'Track and manage your appointment requests',
    'partner.confirmed_appointments': 'confirmed appointments',
    'partner.pending': 'Pending Requests',
    'partner.no_pending_requests': 'No pending requests',
    'partner.pending_requests_appear_here': 'New requests will appear here',
    'partner.no_message': 'No message',
    'partner.accept': 'Accept',
    'partner.reject': 'Reject',
    'partner.share_scheduling_link': 'Share Your Scheduling Link',
    'partner.share_calendar_description': 'Share your calendar with your contacts',
    'partner.copy_virtual_booth_link': '🔗 Copy My Virtual Booth Link',
    'partner.analytics_titles.brand_visibility': 'Brand Visibility (Last 7 days)',
    'partner.analytics_titles.engagement_channels': 'Engagement Channels',
    'partner.global_roi_performance': 'Global ROI Performance',
    'partner.export_pdf_report': 'Export PDF Report',
    'partner.analytics_titles.metrics_distribution': 'Metrics Distribution',
    'partner.autofill_profile_ai': 'Auto-fill with AI',
    'partner.autofill_description': 'Let our AI analyze your website and fill your profile',
    'partner.edit_profile_manually': 'Edit Profile Manually',
    'partner.update_company_info': 'Update Company Information',
    'chat.messages': 'Messages',
    'visitor.discover_exhibitors_desc': 'Explore booths and find solutions that interest you',
    'visitor.view_exhibitors': 'View Exhibitors',
    'visitor.confirmed_count': '{{count}} Confirmed',
    'visitor.pending_count': '{{count}} Pending',
    'visitor.tab_upcoming': 'Upcoming ({{count}})',
    'visitor.tab_past': 'Past ({{count}})',
    'visitor.tab_cancelled': 'Cancelled ({{count}})',
    'visitor.ics_downloaded': '.ics file downloaded',
    'visitor.google_calendar_opened': 'Opening Google Calendar',
    'visitor.outlook_opened': 'Opening Outlook',
    'visitor.open_google_calendar': 'Open in Google Calendar',
    'visitor.retry_appointment': 'Retry',
    'visitor.choose_b2b_slot': 'Choose a B2B slot',
    'visitor.choose_b2b_slot_desc': 'Select your next strategic meeting',
    'partner.dashboard': 'Partner Space',
    'partner.my_profile': 'My Profile',
    'partner.my_events': 'My Events',
    'partner.my_booth': 'My Booth',
    'partner.analytics': 'My Report',
    'partner.contacts': 'My Contacts',
    'exhibitor.dashboard': 'Exhibitor Space',
    'exhibitor.my_profile': 'My Profile',
    'exhibitor.my_booth': 'My Booth',
    'exhibitor.appointments': 'My Appointments',
    'exhibitor.messages': 'My Messages',
    'exhibitor.analytics': 'Statistics',
    'exhibitor.booth_size': 'Booth Size',
    'exhibitor.booth_location': 'Booth Location',
    'exhibitor.error_load_appointments': 'Unable to load appointments',
    'exhibitor.error_load_dashboard': 'Unable to load dashboard',
    'exhibitor.error_toggle_visibility': 'Unable to change visibility',
    'exhibitor.error_unauthorized_confirm': 'You are not authorized to confirm this appointment',
    'exhibitor.error_accept_failed': 'Unable to accept the appointment',
    'exhibitor.error_unauthorized_reject': 'You are not authorized to reject this appointment',
    'exhibitor.confirm_reject': 'Are you sure you want to reject this appointment? This action is irreversible.',
    'exhibitor.error_reject_failed': 'Unable to reject the appointment',
    'exhibitor.toast_profile_visible': '✅ Your profile is now publicly visible',
    'exhibitor.toast_profile_hidden': '🔒 Your profile is now hidden from the public',
    'exhibitor.header.published_tooltip_hide': 'Hide my profile from the public',
    'exhibitor.header.published_tooltip_show': 'Show my profile to the public',
    'exhibitor.header.changing': '⏳ Changing...',
    'exhibitor.header.published_status': '✓ Published',
    'exhibitor.header.hidden_status': '🔒 Hidden',
    'exhibitor.header.virtual_badge': 'Virtual Badge',
    'exhibitor.header.create_edit_minisite': 'Create/Edit Mini-Site',
    'exhibitor.status.confirmed': 'Confirmed',
    'exhibitor.status.pending': 'Pending',
    'exhibitor.status.completed': 'Completed',
    'exhibitor.stats.mini_site_views': 'Mini-Site Views',
    'exhibitor.stats.appointments': 'Appointments',
    'exhibitor.stats.downloads': 'Downloads',
    'exhibitor.stats.messages': 'Messages',
    'exhibitor.modals.views_title': 'Your Mini-Site Views',
    'exhibitor.modals.views_chart_title': 'Views Evolution',
    'exhibitor.modals.views_footer': 'Your mini-site is attracting attention! Keep it updated.',
    'exhibitor.modals.appointments_title': 'Appointment Details',
    'exhibitor.modals.appointments_chart_title': 'Breakdown by status',
    'exhibitor.modals.appointments_action': 'Manage my appointments',
    'exhibitor.modals.downloads_title': 'Catalog Downloads',
    'exhibitor.modals.downloads_chart_title': 'Downloads by period',
    'exhibitor.modals.messages_title': 'Messaging Activity',
    'exhibitor.modals.messages_chart_title': 'Messages received',
    'exhibitor.modals.messages_action': 'View my messages',
    'exhibitor.chart_minisite_views': 'Mini-Site Views',
    'exhibitor.chart_downloads': 'Downloads',
    'exhibitor.chart_messages': 'Messages',
    'exhibitor.chart_connections': 'Connections',
    'exhibitor.qr_download_success': 'Download Successful',
    'exhibitor.qr_download_success_text': 'Your booth QR code has been downloaded successfully!',
    'exhibitor.qr_download_error': 'Download Error',
    'exhibitor.qr_download_error_text': 'An error occurred while downloading the QR code.',
    'exhibitor.quota_b2b': 'B2B Appointments',
    'exhibitor.quota_team': 'Team Members',
    'exhibitor.quota_demo': 'Demo Sessions',
    'exhibitor.quota_scans': 'Badge Scans/Day',
    'exhibitor.quota_media': 'Media Files',
    'exhibitor.stats_views': 'Mini-Site Views',
    'exhibitor.stats_requests': 'Appointment Requests',
    'exhibitor.stats_downloads': 'Downloads',
    'exhibitor.stats_messages': 'Messages',
    'exhibitor.calendar_title': 'Calendar Management',
    'exhibitor.calendar_hub': 'Hub',
    'exhibitor.calendar_subtitle': 'Centralize your availability and manage your strategic meetings in a premium dedicated space.',
    'exhibitor.tab_availability': 'My Availability',
    'exhibitor.tab_appointments': 'Personal Agenda',
    'exhibitor.analytics_title': 'Performance & Analytics',
    'exhibitor.analytics_realtime': 'Real-time Data',
    'exhibitor.analytics_visits': 'Visits',
    'exhibitor.analytics_interactions': 'Interactions',
    'exhibitor.analytics_appointment_status': 'Appointment Status',
    'exhibitor.analytics_activity_breakdown': 'Activity Breakdown',
    'exhibitor.period_this_week': 'This Week',
    'exhibitor.period_last_week': 'Last Week',
    'exhibitor.period_current': 'Currently',
    'exhibitor.period_previous': 'Previous Period',
    'exhibitor.period_confirmed': 'Confirmed Appointments',
    'exhibitor.period_new_connections': 'New Connections',
    'exhibitor.quick_actions_title': 'Quick Actions',
    'exhibitor.quick_actions_subtitle': 'Direct access to your essential tools',
    'exhibitor.quick_actions.create_minisite_ai': 'Create AI Mini-Site',
    'exhibitor.quick_actions.create_minisite_ai_desc': 'Generate your mini-site with artificial intelligence',
    'exhibitor.quick_actions.networking_ai': 'AI Networking',
    'exhibitor.quick_actions.networking_ai_desc': 'Find relevant contacts with AI',
    'exhibitor.quick_actions.edit_minisite': 'Edit Mini-Site',
    'exhibitor.quick_actions.edit_minisite_desc': 'Customize your presentation page',
    'exhibitor.quick_actions.profile': 'My Profile',
    'exhibitor.quick_actions.profile_desc': 'Manage your information and preferences',
    'exhibitor.quick_actions.qr_code': 'QR Code',
    'exhibitor.quick_actions.qr_code_desc': 'Display your QR code for easy exchanges',
    'exhibitor.appointments_received': 'Received Appointments',
    'exhibitor.appointments_received_subtitle': 'Manage your requests and confirmations',
    'exhibitor.appointments_upcoming': 'Upcoming',
    'exhibitor.appointments_past': 'Past',
    'exhibitor.appointments_cancelled': 'Cancelled',
    'exhibitor.appointments_loading': 'Loading appointments...',
    'exhibitor.appointments_no_pending': 'No pending requests',
    'exhibitor.appointments_no_pending_hint': 'New requests will appear here',
    'exhibitor.appointments_badge_new': 'New',
    'exhibitor.appointments_request_from': 'Request from',
    'exhibitor.appointments_no_message': 'No message',
    'exhibitor.appointments_confirming': '⏳ Confirming...',
    'exhibitor.appointments_accept': '✓ Accept',
    'exhibitor.appointments_rejecting': '⏳ Rejecting...',
    'exhibitor.appointments_reject': '✕ Reject',
    'exhibitor.appointments_confirmed_upcoming': 'Upcoming Confirmed Appointments',
    'exhibitor.appointments_with': 'With',
    'exhibitor.appointments_badge_confirmed': '✓ Confirmed',
    'exhibitor.appointments_no_past': 'No past appointments',
    'exhibitor.appointments_no_past_hint': 'History will appear here',
    'exhibitor.appointments_badge_completed': 'Completed',
    'exhibitor.appointments_no_cancelled': 'No cancelled appointments',
    'exhibitor.appointments_no_cancelled_hint': 'Cancellations will appear here',
    'exhibitor.appointments_badge_cancelled': 'Cancelled',
    'exhibitor.activity_recent_title': 'Recent Activity',
    'exhibitor.activity_none': 'No recent activity',
    'exhibitor.activity_view_all': 'View All Activity',
    'exhibitor.activity.view_all': 'All Activities',
    'exhibitor.activity.none': 'No recent activity',
    'exhibitor.info_title': 'Important Information',
    'exhibitor.info_subtitle': 'Essential exhibition details',
    'exhibitor.info_booth_opening': 'Booth Opening',
    'exhibitor.info_every_day': 'Every day of the exhibition',
    'exhibitor.info_objective': 'Objective 2026',
    'exhibitor.info_expected_visitors': 'expected visitors',
    'exhibitor.qr_modal_title': 'Exhibitor Booth QR Code',
    'exhibitor.qr_modal_subtitle': 'Scan this code to quickly access your booth',
    'exhibitor.qr_label_company': 'Company:',
    'exhibitor.qr_label_contact': 'Contact:',
    'exhibitor.qr_label_email': 'Email:',
    'exhibitor.qr_label_stand': 'Booth:',
    'exhibitor.qr_not_assigned': 'Not Assigned',
    'exhibitor.qr_valid_until': 'Valid Until:',
    'exhibitor.qr_downloading': '⏳ Downloading...',
    'exhibitor.qr_download': '📥 Download',
    'exhibitor.ics_downloaded': '.ics file downloaded',
    'exhibitor.google_calendar_opened': 'Opening Google Calendar',
    'exhibitor.outlook_opened': 'Opening Outlook',
    'exhibitor.error_generic': 'An error occurred',
    'admin.verified': 'Verified',
    'status.confirmed': 'Confirmed',
    'status.pending': 'Pending',
    'status.completed': 'Completed',
    'status.cancelled': 'Cancelled',
    'actions.accept': 'Accept',
    'actions.reject': 'Reject',
    'actions.view': 'View',
    'actions.manage': 'Manage',
    'actions.refresh': 'Refresh',
    'actions.access': 'Access',
    'errors.accept_appointment': 'Unable to accept appointment',
    'errors.reject_appointment': 'Unable to reject appointment',
    'errors.unregister_event': 'Unable to unregister from event',
    'common.close': 'Close',
    'common.premium': 'Premium',
    'common.events': 'Events',
    'common.connections': 'Connections',
    'common.impressions': 'Impressions',
    'common.interactions': 'Interactions',
    'common.download': 'Download',
    'common.back_to_dashboard': 'Back to Dashboard',
    'common.days.mon': 'Mon',
    'common.days.tue': 'Tue',
    'common.days.wed': 'Wed',
    'common.days.thu': 'Thu',
    'common.days.fri': 'Fri',
    'common.days.sat': 'Sat',
    'common.days.sun': 'Sun',
    'home.book_appointment': 'Book Appointment',
    'home.verified': 'Verified',
    'home.featured_partners_title': 'Featured Partners',
    'home.featured_partners_desc': 'Leading organizations supporting SIPORTS 2026',
    'home.discover_all': 'Discover All Partners',
    'home.discover_all_exhibitors': 'Discover All Exhibitors',
    'home.featured_exhibitors_title': 'Featured Exhibitors',
    'home.featured_exhibitors_desc': 'The best exhibitors of the show',
    'home.networking_label': 'Smart Networking',
    'home.networking_title': 'Connect with the Right Partners',
    'home.networking_desc': 'Find and connect with maritime industry professionals',
    'home.feature_matching': 'Intelligent Matching',
    'home.feature_matching_desc': 'Our AI analyzes your profiles to find the best matches',
    'home.feature_chat': 'Real-Time Messaging',
    'home.feature_chat_desc': 'Communicate instantly with your contacts',
    'home.feature_appointments': 'Scheduled Meetings',
    'home.feature_appointments_desc': 'Organize your meetings with an integrated calendar',
    'home.feature_global': 'Global Platform',
    'home.feature_global_desc': 'Connect with professionals from around the world',
    'home.cta_networking': 'Explore Networking',
    'home.cta_member': 'Become a Member',
    'home.stats_professionals': 'Professionals',
    'home.stats_countries': 'Countries',
    'home.stats_exhibitors': 'Exhibitors',
    'home.stats_satisfaction': 'Satisfaction',
    'home.trusted_by': 'Trusted By',
    'home.logo_showcase_title': 'Our Partners & Exhibitors',
    'salon.exhibitors': 'Exhibitors',
    'salon.visitors': 'Professional Visitors',
    'salon.conferences': 'Conferences & Panels',
    'salon.countries': 'Countries Represented',
    'hero.title': 'SIPORTS 2026',
    'hero.subtitle': 'A strategic hub for ports and their ecosystems',
    'hero.countdown.title': 'Coming Soon',
    'hero.countdown.subtitle': 'Join us at Mohammed VI Exhibition Park in El Jadida',
    'hero.stats.location': 'Morocco',
    'hero.stats.participants': 'Professional Participants',
    'hero.stats.exhibitors': 'International Exhibitors',
    'hero.cta.exhibitor': 'Become an Exhibitor',
    'hero.cta.discover': 'Discover the Event',
    'time.days': 'Days',
    'time.hours': 'Hours',
    'time.minutes': 'Minutes',
    'time.seconds': 'Seconds',
    'time.day': 'Day',
    'time.hour': 'Hour',
    'time.minute': 'Minute',
    'time.second': 'Second',
    'stats.exhibitors': 'Exhibitors',
    'stats.visitors': 'Visitors',
    'stats.countries': 'Countries',
    'stats.conferences': 'Conferences',
    'login.title': 'Login',
    'login.subtitle': 'Access your SIPORTS account',
    'login.email': 'Email address',
    'login.password': 'Password',
    'login.remember_me': 'Remember me',
    'login.forgot_password': 'Forgot password?',
    'login.button': 'Sign in',
    'login.connecting': 'Signing in',
    'login.demo_accounts': 'Quick login - Demo accounts',
    'login.demo_admin': 'Main Admin',
    'login.demo_exhibitors': 'Exhibitors',
    'login.demo_partners': 'Partners',
    'login.demo_visitors': 'Visitors',
    'login.demo_free': 'Free',
    'login.demo_vip': 'VIP',
    'actions.save': 'Save',
    'actions.cancel': 'Cancel',
    'actions.edit': 'Edit',
    'actions.delete': 'Delete',
    'actions.add': 'Add',
    'actions.view_details': 'Full Profile',
    'actions.schedule_meeting': 'Schedule Meeting',
    'actions.download': 'Download',
    'actions.share': 'Share',
    'actions.close': 'Close',
    'actions.back': 'Back',
    'actions.next': 'Next',
    'actions.previous': 'Previous',
    'actions.submit': 'Submit',
    'actions.loading': 'Loading...',
    'actions.success': 'Success',
    'actions.error': 'Error',
    'actions.copy': 'Copy',
    'messages.confirm_delete': 'Are you sure you want to delete?',
    'messages.confirm_action': 'Are you sure?',
    'messages.saved': 'Saved successfully',
    'messages.deleted': 'Deleted successfully',
    'messages.error': 'An error occurred',
    'messages.no_data': 'No data available',
    'profile.name': 'Name',
    'profile.email': 'Email',
    'profile.phone': 'Phone',
    'profile.company': 'Company',
    'profile.sector': 'Sector',
    'profile.description': 'Description',
    'profile.website': 'Website',
    'profile.location': 'Location',
    'profile.logo': 'Logo',
    'profile.about': 'About',
    'networking.title': 'Networking',
    'networking.ai_powered': 'Powered by AI SIPORTS v3.0',
    'networking.hero_title': 'Networking',
    'networking.hero_subtitle': 'Intelligent',
    'networking.hero_desc': 'Connect with leaders in the global port industry through our predictive matching algorithm.',
    'networking.login_required': 'Login Required',
    'networking.hub_restricted': 'The Networking Hub is reserved for registered members.',
    'networking.discover_recommendations': 'Log in to discover your personalized recommendations.',
    'networking.login_button': 'Log In',
    'networking.signup_button': 'Sign Up',
    'networking.precise_matching': 'Precise Matching',
    'networking.matching_interests': 'Based on your interests',
    'networking.global_network': 'Global Network',
    'networking.countries_represented': '+50 countries represented',
    'networking.secure_access': 'Secure Access',
    'networking.verified_profiles': 'Verified profiles',
    'networking.ecosystem_title': 'The SIPORTS ecosystem at your fingertips',
    'networking.b2b_space': 'Pre-scheduled B2B Space',
    'networking.b2b_desc': 'Targeted meetings with decision-makers',
    'networking.afterworks': 'Afterworks & Receptions',
    'networking.afterworks_desc': 'Informal and friendly networking',
    'networking.roundtables': 'Sectoral Roundtables',
    'networking.roundtables_desc': 'In-depth expert discussions',
    'networking.lounge_zone': 'Business & VIP Lounge Zone',
    'networking.lounge_desc': 'Work and relaxation spaces',
    'networking.find_contacts': 'Find the right contacts',
    'networking.smart_matching': 'Smart Matching',
    'networking.send_message': 'Send Message',
    'networking.request_meeting': 'Request Meeting',
    'networking.messages': 'Messages',
    'networking.meetings': 'Meetings',
    'networking.recommendations': 'Recommendations',
    'dashboard.admin_title': 'Administration Dashboard',
    'dashboard.admin_subtitle': 'Manage all SIPORTS 2026 resources',
    'dashboard.restricted_access': 'Restricted Access - Administrators Only',
    'dashboard.restricted_message': 'This section is reserved for SIPORTS administrators',
    'dashboard.back_to_dashboard': 'Back to Dashboard',
    'dashboard.welcome': 'Welcome to',
    'dashboard.loading_metrics': 'Loading metrics...',
    'dashboard.metrics_error': 'Error loading metrics',
    'dashboard.retry': 'Retry',
    'dashboard.total_users': 'Total Users',
    'dashboard.active_users': 'Active Users',
    'dashboard.total_exhibitors': 'Total Exhibitors',
    'dashboard.total_partners': 'Total Partners',
    'dashboard.total_visitors': 'Total Visitors',
    'dashboard.statistics': 'Statistics',
    'dashboard.system_health': 'System Health',
    'dashboard.user_growth': 'User Growth',
    'dashboard.activity_overview': 'Activity Overview',
    'dashboard.traffic_analytics': 'Traffic Analytics',
    'dashboard.recent_activity': 'Recent Activity',
    'dashboard.registration_requests': 'Registration Requests',
    'dashboard.pending_approvals': 'Pending Approvals',
    'dashboard.content_moderation': 'Content Moderation',
    'dashboard.settings': 'Settings',
    'dashboard.reports': 'Reports',
    'dashboard.exports': 'Exports',
    'dashboard.quick_actions': 'Quick Actions',
    'dashboard.notifications': 'Notifications',
    'dashboard.logout': 'Logout',
    'dashboard.your_quotas': 'Your Quotas',
    'dashboard.exhibitor_quotas': 'Your Exhibitor Quotas',
    'dashboard.visit_activity_7days': 'Visit Activity (Last 7 days)',
    'dashboard.appointment_status': 'Appointment Status',
    'dashboard.interest_areas': 'Interest Areas',
    'dashboard.visitor_engagement_7days': 'Visitor Engagement (Last 7 days)',
    'dashboard.brand_exposure_7days': 'Brand Exposure (Last 7 days)',
    'dashboard.engagement_channels': 'Engagement Channels',
    'visitor.my_tickets': 'My Tickets',
    'visitor.appointment_confirmed': 'Appointment Confirmed',
    'visitor.appointment_declined': 'Appointment Declined',
    'visitor.no_appointments': 'No Appointments',
    'visitor.appointment_status': 'Appointment Status',
    'visitor.appointment_scheduled': 'Appointment Scheduled',
    'visitor.loading_appointments': 'Loading Appointments...',
    'visitor.error_loading': 'Unable to load Appointments. Please try again.',
    'visitor.quota_remaining': 'Remaining Quota',
    'partner.event_registration': 'Event Registration',
    'partner.attendees': 'Attendees',
    'partner.contribution_level': 'Contribution Level',
    'exhibitor.visitor_interactions': 'Visitor Interactions',
    'exhibitor.booth_analytics': 'Booth Analytics',
    'exhibitor.my_products': 'My Products',
    'contact.title': 'Contact Us',
    'contact.description': 'Get in touch with our team',
    'contact.form_title': 'Contact Form',
    'contact.first_name': 'First Name',
    'contact.last_name': 'Last Name',
    'contact.email': 'Email Address',
    'contact.company': 'Company',
    'contact.subject': 'Subject',
    'contact.message': 'Message',
    'contact.send': 'Send',
    'contact.success': 'Message sent successfully',
    'venue.title': 'Event Map',
    'venue.description': 'Explore the interactive map to locate exhibitor booths',
    'venue.how_to_use': 'How to use the map',
    'venue.step1_title': 'Browse the map',
    'venue.step1_desc': 'Scroll through the map to see all available booths',
    'venue.step2_title': 'Hover over a booth',
    'venue.step2_desc': 'Hover your mouse over a booth to see a preview',
    'venue.step3_title': 'Click for more',
    'venue.step3_desc': 'Click on a booth to access the full exhibitor details',
    'news.title': 'News',
    'news.description': 'Stay informed about the latest events',
    'news.search_placeholder': 'Search for news',
    'news.filter': 'Filter',
    'news.all_categories': 'All categories',
    'news.featured': 'Featured',
    'news.views': 'Views',
    'news.category': 'Category',
    'partnership.title': 'SIPORTS 2026 Partnerships',
    'partnership.description': 'Join the international port ecosystem',
    'partnership.premium': 'Premium Partner',
    'partnership.gold': 'Gold Partner',
    'partnership.silver': 'Silver Partner',
    'partnership.become': 'Become a Partner',
    'partnership.contact': 'Contact Us',
    'marketing.dashboard_title': 'Marketing Dashboard',
    'marketing.welcome': 'Welcome to your marketing space',
    'marketing.overview': 'Overview',
    'marketing.campaigns': 'Campaigns',
    'marketing.analytics': 'Analytics',
    'marketing.reports': 'Reports',
    'marketing.media_library': 'Media Library',
    'marketing.featured_badges': 'Featured Badges',
    'marketing.create_campaign': 'Create Campaign',
    'marketing.campaign_title': 'Campaign Title',
    'marketing.campaign_description': 'Description',
    'marketing.campaign_start_date': 'Start Date',
    'marketing.campaign_end_date': 'End Date',
    'marketing.campaign_budget': 'Budget',
    'marketing.campaign_status': 'Status',
    'marketing.active': 'Active',
    'marketing.inactive': 'Inactive',
    'marketing.draft': 'Draft',
    'marketing.published': 'Published',
    'marketing.pending': 'Pending',
    'marketing.statistics': 'Statistics',
    'marketing.views': 'Views',
    'marketing.clicks': 'Clicks',
    'marketing.conversions': 'Conversions',
    'marketing.engagement': 'Engagement',
    'marketing.reach': 'Reach',
    'marketing.impressions': 'Impressions',
    'marketing.ctr': 'Click Through Rate',
    'marketing.cpc': 'Cost Per Click',
    'marketing.roi': 'ROI',
    'marketing.filter_status': 'Filter by Status',
    'marketing.filter_date': 'Filter by Date',
    'marketing.sort': 'Sort',
    'marketing.sort_newest': 'Newest',
    'marketing.sort_oldest': 'Oldest',
    'marketing.action_edit': 'Edit',
    'marketing.action_delete': 'Delete',
    'marketing.action_publish': 'Publish',
    'marketing.action_duplicate': 'Duplicate',
    'marketing.badge': 'MARKETING CONTROL CENTER',
    'marketing.title': 'Content Strategy Hub',
    'marketing.subtitle': 'Manage the SIPORT 2026 narrative experience. Publish impactful content and analyze engagement.',
    'marketing.btn_new_content': 'New Content',
    'marketing.tabs.explore': 'Explore',
    'marketing.tabs.media_library': 'Media Library',
    'marketing.tabs.articles_news': 'Articles & News',
    'marketing.stats.total_media': 'Total Media',
    'marketing.stats.total': 'Total',
    'marketing.stats.webinars': 'Webinars',
    'marketing.stats.podcasts': 'Podcasts',
    'marketing.stats.capsules': 'Capsules',
    'marketing.stats.online': 'Online',
    'marketing.stats.drafts': 'Drafts',
    'marketing.filters': 'Filters',
    'marketing.filters.filter_by': 'Filter by:',
    'marketing.filters.status': 'Status:',
    'marketing.filters.all': 'All',
    'marketing.filters.webinars': 'Webinars',
    'marketing.filters.podcasts': 'Podcasts',
    'marketing.filters.capsules': 'Capsules',
    'marketing.filters.published': 'Published',
    'marketing.filters.drafts': 'Drafts',
    'marketing.filters.best_moments': 'Best Moments',
    'marketing.filters.capsule_inside': 'Inside Capsule',
    'marketing.filters.webinar': 'Webinar',
    'marketing.filters.live_studio': 'Live Studio',
    'marketing.filters.podcast': 'Podcast',
    'marketing.filters.testimonial': 'Testimonial',
    'marketing.media.add_media': 'Add media',
    'marketing.media.no_media': 'No media found',
    'marketing.media.no_media_found': 'No media found',
    'marketing.media.no_media_desc': 'Add photos, videos or podcasts to get started',
    'marketing.media.start_adding': 'Add photos, videos or podcasts to get started',
    'marketing.media.publish': 'Publish',
    'marketing.media.unpublish': 'Unpublish',
    'marketing.media.copy': 'Copy',
    'marketing.media.copied': 'Shortcode copied!',
    'marketing.media.deleted': 'Media deleted',
    'marketing.media.added': 'Media added',
    'marketing.media.error_update': 'Update error',
    'marketing.media.error_delete': 'Delete error',
    'marketing.media.title': 'Title',
    'marketing.media.description': 'Description',
    'marketing.media.type': 'Media type',
    'marketing.media.video_url': 'Video / Audio URL',
    'marketing.media.shortcode_copied': 'Shortcode copied!',
    'marketing.status.published': 'Published',
    'marketing.status.draft': 'Draft',
    'marketing.articles.title': 'Article Management',
    'marketing.articles.subtitle': 'Create and manage articles for siportevent.com',
    'marketing.articles.create_new': 'Create New Article',
    'marketing.articles.published_count': 'Published',
    'marketing.articles.drafts_count': 'Drafts',
    'marketing.articles.shortcodes_info': 'Using shortcodes',
    'marketing.articles.shortcodes_desc': 'Copy an article\'s shortcode to embed it',
    'marketing.articles.example': 'Example:',
    'marketing.articles.no_articles': 'No articles yet',
    'marketing.articles.author': 'Author',
    'marketing.articles.category': 'Category',
    'marketing.articles.edit': 'Edit',
    'marketing.articles.publish': 'Publish',
    'marketing.articles.unpublish': 'Unpublish',
    'marketing.articles.delete': 'Delete',
    'marketing.articles.published_badge': 'Published',
    'marketing.articles.draft_badge': 'Draft',
    'subscription.title': 'Subscription Plans',
    'subscription.description': 'Choose your perfect plan',
    'subscription.visitor': 'Visitor',
    'subscription.partner': 'Partner',
    'subscription.exhibitor': 'Exhibitor',
    'subscription.features': 'Features',
    'subscription.included': 'Included',
    'subscription.not_included': 'Not included',
    'subscription.upgrade': 'Upgrade',
    'subscription.current_plan': 'Current plan',
    'legal.terms_title': 'Terms of Service',
    'legal.privacy_title': 'Privacy Policy',
    'legal.cookies_title': 'Cookie Policy',
    'legal.last_update': 'Last Updated',
    'legal.acceptance': 'Acceptance',
    'legal.usage': 'Acceptable Use',
    'legal.data_collection': 'Data Collection',
    'legal.contact': 'Contact Us',
    'support.title': 'Support & Help',
    'support.description': 'We are here to help you',
    'support.contact_form': 'Contact Form',
    'support.faq': 'Frequently Asked Questions',
    'support.technicalTitle': 'Technical Support',
    'support.technicalDesc': 'Technical issues, bugs, or difficulties using the platform.',
    'support.contactTechnical': 'Contact Support',
    'support.commercialTitle': 'Commercial Support',
    'support.commercialDesc': 'Questions about pricing, partnerships, or event information.',
    'support.contactCommercial': 'Commercial Contact',
    'support.exhibitorTitle': 'Exhibitor Support',
    'support.exhibitorDesc': 'Help with profile creation, stand management, or exhibitor features.',
    'support.contactExhibitor': 'Exhibitor Support',
    'support.faqTitle': 'Frequently Asked Questions',
    'support.loginProblems': 'Login Issues',
    'support.forgotPassword': 'I forgot my password',
    'support.forgotPasswordAnswer': 'Use the "Forgot Password" link on the login page.',
    'support.accountNotActivated': 'My account is not activated',
    'support.accountNotActivatedAnswer': 'Check your emails or contact support for activation.',
    'support.platformFeatures': 'Platform Features',
    'support.howToAppointment': 'How do I make an appointment?',
    'support.howToAppointmentAnswer': 'Go to the "Networking" section and select an exhibitor.',
    'support.howToEditProfile': 'How do I edit my profile?',
    'support.howToEditProfileAnswer': 'Go to "My Profile" in the user menu.',
    'support.immediateHelp': 'Need immediate help?',
    'support.teamAvailable': 'Our support team is available to answer all your questions.',
    'support.emergencies': 'Emergencies',
    'support.openTicket': 'Open a ticket',
    'support.sendEmail': 'Send an email',
    'resetPassword.minLength': 'Password must contain at least 12 characters',
    'resetPassword.maxLength': 'Password must not exceed 72 characters',
    'resetPassword.uppercaseRequired': 'Must contain at least one uppercase letter',
    'resetPassword.lowercaseRequired': 'Must contain at least one lowercase letter',
    'resetPassword.digitRequired': 'Must contain at least one digit',
    'resetPassword.specialRequired': 'Must contain at least one special character',
    'resetPassword.confirmRequired': 'Please confirm your password',
    'resetPassword.passwordsMismatch': 'Passwords do not match',
    'resetPassword.supabaseNotConfigured': 'Supabase not configured.',
    'resetPassword.errorResetting': 'Error resetting password.',
    'resetPassword.success': '✅ Password set successfully. You can now log in.',
    'resetPassword.title': 'Reset Password',
    'resetPassword.linkExpired': 'The reset link appears incomplete or expired. Make sure to use the link sent by email.',
    'resetPassword.newPasswordLabel': 'New password',
    'resetPassword.newPasswordPlaceholder': 'New password (min. 12 characters)',
    'resetPassword.confirmLabel': 'Confirm password',
    'resetPassword.confirmPlaceholder': 'Confirm password',
    'resetPassword.loading': 'Loading...',
    'resetPassword.submit': 'Change password',
    'signupSuccess.welcomeMessage': 'Welcome to SIPORTS 2026!',
    'signupSuccess.title': '🎉 Registration Successful!',
    'signupSuccess.visitorSuccess': 'Congratulations! Your visitor account has been successfully created.',
    'signupSuccess.registrationSuccess': 'Congratulations! Your registration request as {{role}} has been recorded.',
    'signupSuccess.exhibitor': 'exhibitor',
    'signupSuccess.partner': 'partner',
    'signupSuccess.registrationEmail': 'Registration email',
    'signupSuccess.accessTo': '✅ You have access to:',
    'signupSuccess.nextSteps': '📋 Next Steps',
    'signupSuccess.catalogFeature': 'Browse 300 exhibitors at SIPORTS 2026',
    'signupSuccess.catalogLabel': 'Full catalog:',
    'signupSuccess.programFeature': 'Discover conferences and events',
    'signupSuccess.programLabel': 'Program:',
    'signupSuccess.networkingFeature': 'Schedule meetings with exhibitors',
    'signupSuccess.networkingLabel': 'Networking:',
    'signupSuccess.profileFeature': 'Complete your profile and explore opportunities',
    'signupSuccess.profileLabel': 'Profile:',
    'signupSuccess.confirmationEmail': 'A summary email has been sent. Please check your inbox.',
    'signupSuccess.confirmationLabel': 'Confirmation email:',
    'signupSuccess.validationStep': 'Our team will review your request within 48 business hours.',
    'signupSuccess.validationLabel': 'Validation:',
    'signupSuccess.activationStep': 'Once validated, you will receive an email with your full access.',
    'signupSuccess.activationLabel': 'Activation:',
    'signupSuccess.goToDashboard': 'Go to dashboard',
    'signupSuccess.autoRedirect': 'Automatic redirect in {{countdown}}s...',
    'signupSuccess.login': 'Log in',
    'signupSuccess.questions': 'Questions?',
    'signupSuccess.contactSupport': 'Contact our support',
    'payment.alreadyPremium': 'You are already a Premium VIP subscriber!',
    'payment.userNotConnected': 'User not connected',
    'payment.requestCreated': 'Payment request created',
    'payment.requestError': 'Error creating the request',
    'payment.stripeError': 'Error during Stripe payment',
    'payment.stripeErrorToast': 'Stripe payment error',
    'payment.paypalSuccess': 'PayPal payment successful!',
    'payment.paypalCaptureError': 'Error capturing PayPal payment',
    'payment.paypalErrorToast': 'PayPal payment error',
    'payment.cmiError': 'Error during CMI payment',
    'payment.cmiErrorToast': 'CMI payment error',
    'payment.selectImage': 'Please select an image',
    'payment.photoMaxSize': 'Photo must not exceed 5MB',
    'payment.authCreationError': 'Error creating secure account',
    'payment.profileCompleted': 'VIP profile completed successfully',
    'payment.profileUpdateError': 'Error updating profile',
    'payment.simulatedSuccess': '🎉 VIP payment successfully simulated!',
    'payment.simulationError': 'Error during payment simulation',
    'payment.preparing': 'Preparing payment...',
    'payment.redirecting': 'Redirecting to payment...',
    'payment.pleaseWait': 'Please wait, we are preparing your bank transfer payment request.',
    'login.paymentRequired': 'Payment required to access VIP dashboard.',
    'login.paymentRequiredFull': 'Payment required to access VIP dashboard. Please finalize your payment.',
    'login.connectionError': 'Connection error',
    'login.fillAllFields': 'Please fill in all fields',
    'login.wrongCredentials': 'Incorrect email or password',
    'login.googleError': 'Error during Google login',
    'login.linkedinError': 'Error during LinkedIn login',
    'login.demoMarketing': 'Marketing',
    'login.demoServiceClient': 'Customer Service',
    'login.demoAdmin': 'Administrator',
    'login.demoConnect': 'Login',
    'login.demoBadgeConnect': 'Badge Printing Login',
    'login.demoAdminConnect': 'Admin Login',
    'login.demoPasswordNote': 'Password: Demo2026! (Service2026! for customer service)',
    'login.quickAccess': 'Quick Access - Demo',
    'login.testFeatures': 'Test all features',
    'login.viewAccounts': 'View accounts',
    'login.noAccount': 'No account yet?',
    'login.createAccount': 'Create an account',
    'sub.hero.badge': 'Meeting the world\'s port industry leaders',
    'sub.hero.title1': 'Visit the International Exhibition of',
    'sub.hero.titleHighlight1': 'Ports',
    'sub.hero.title2': 'and their',
    'sub.hero.titleHighlight2': 'Ecosystem',
    'sub.hero.title3': 'and their Ecosystem',
    'sub.hero.desc': 'From April 1 to 3, 2026 at the Mohammed VI Exhibition Park in El Jadida, Morocco, the SIPORTS Exhibition opens its doors so you can discover, meet and collaborate with the greatest players in the global port industry. Whether you are a professional, investor, industrialist or academic: this event is designed for you.',
    'sub.hero.badgeBtn': 'Request my visitor badge',
    'sub.hero.vipBtn': 'VIP Pass',
    'sub.stat1.label': 'International exhibitors',
    'sub.stat2.label': 'Professional visitors',
    'sub.stat3.label': 'Countries represented',
    'sub.stat4.label': 'Conferences and workshops',
    'sub.whySection.label': 'Why visit?',
    'sub.whySection.title': 'Why visit SIPORTS?',
    'sub.whySection.title1': 'Why visit',
    'sub.whySection.title2': '?',
    'sub.whySection.subtitle': 'An immersive experience at the heart of the international port ecosystem',
    'sub.whySection.worldEvent': 'A world-class event',
    'sub.whySection.worldEventDesc': 'The largest port exhibition in Africa and the Arab world',
    'sub.why1': 'Explore the latest innovations in smart ports, maritime connectivity, sustainable infrastructure and logistics automation.',
    'sub.why2': 'Attend 30 conferences, panels and technical workshops led by world-renowned experts.',
    'sub.why3': 'Benefit from targeted networking sessions to make quality contacts.',
    'sub.why4': 'Discover training programs, future careers and talent in the port sector in a dedicated pavilion.',
    'sub.why5': 'Enjoy a unique artistic immersion in the Port Museum and the Artistic space inspired by the Atlantic initiative.',
    'sub.pav1.title': 'Institutional Organizations',
    'sub.pav1.desc': 'Global strategies and international cooperation',
    'sub.pav2.title': 'Port Industry',
    'sub.pav2.desc': 'Equipment, digitalization, sustainability',
    'sub.pav3.title': 'Management and Operations',
    'sub.pav3.desc': 'Innovations, expertise and corridors',
    'sub.pav4.title': 'Academic & Training',
    'sub.pav4.desc': 'Careers, training, simulators',
    'sub.pav5.title': 'Port Museum',
    'sub.pav5.desc': 'Heritage, art, memory and cultural innovation',
    'sub.pavSection.label': 'Discover the 5 worlds of SIPORTS',
    'sub.pavSection.title': 'Visitors, explore our pavilions',
    'sub.pavSection.title1': 'Discover the 5 worlds of',
    'sub.pavSection.titleHighlight': 'SIPORTS',
    'sub.needInfo': 'Need additional information?',
    'sub.contactUs': 'Contact us',
    'sub.plans.label': 'Visitor Plans',
    'sub.plans.title': 'Choose the plan that best suits your needs',
    'sub.plans.subtitle': 'Maximize your SIPORTS experience',
    'sub.plans.visitors': 'Visitors',
    'sub.plans.exhibitors': 'Exhibitors',
    'sub.plans.partners': 'Partners',
    'sub.plans.features': 'Features',
    'sub.plans.benefits': 'Benefits',
    'sub.plans.onQuote': 'On quote',
    'sub.plans.free': 'Free',
    'sub.plans.customPlan': 'Need a custom plan for your team?',
    'sub.plans.customPlanDesc': 'Contact us',
    'sub.how.title': 'How does it work?',
    'sub.how.step1Title': 'Choose your plan',
    'sub.how.step1Desc': 'Select the plan that suits your needs from our different levels.',
    'sub.how.step2Title': 'Secure payment',
    'sub.how.step2Desc': 'Pay online or through a sales representative. Automatic administrator validation.',
    'sub.how.step3Title': 'Instant access',
    'sub.how.step3Desc': 'Instant access to your dashboard and all the benefits of your plan.',
    'sub.info.label': 'Plan your visit!',
    'sub.info.title': 'Practical information',
    'sub.info.venue': 'Venue',
    'sub.info.venueAddr': 'Mohammed VI Exhibition Park – El Jadida, Morocco',
    'sub.info.dates': 'Dates',
    'sub.info.datesVal': 'April 1-3, 2026',
    'sub.info.hours': 'Hours',
    'sub.info.hoursVal': '9:30 AM to 6:00 PM',
    'sub.info.entry': 'Entry',
    'sub.info.entryVal': 'By registered badge',
    'sub.info.contact': 'Event Organizer Contact',
    'sub.info.contactOrg': 'LINECO EVENTS',
    'sub.info.contactAddr': '19, rue Badr Assayab – 1st floor n°2, Casablanca – Morocco',
    'sub.info.contactBtn': 'Contact us',
    'sub.faq.title': 'Frequently asked questions',
    'sub.faq.q1': 'Can I change my plan?',
    'sub.faq.a1': 'Yes, you can upgrade your plan at any time. An administrator will validate the changes.',
    'sub.faq.q2': 'What is the activation delay?',
    'sub.faq.a2': 'Once payment is validated, your access is activated within 24 hours.',
    'sub.faq.q3': 'Is there recurring billing?',
    'sub.faq.a3': 'No, unless otherwise stated. Plans are flat-rate for the 2026 exhibition.',
    'sub.faq.q4': 'How do I contact support?',
    'sub.faq.a4': 'Contact our team via the website form or by email: contact@siportevent.com',
    'sub.visitorFree.name': 'Free Visitor',
    'sub.visitorFree.desc': 'Basic exhibition access',
    'sub.visitorFree.cta': 'Register for free',
    'sub.visitorFree.f1': 'Exhibition website access',
    'sub.visitorFree.f2': 'Browse exhibitors',
    'sub.visitorFree.f3': 'Meeting requests',
    'sub.visitorFree.f4': 'Direct messaging',
    'sub.visitorFree.f5': 'Exhibitor mini-sites',
    'sub.visitorFree.f6': 'Live events',
    'sub.visitorFree.b1': 'Full access to the exhibitor directory',
    'sub.visitorFree.b2': 'View public profiles',
    'sub.visitorFree.b3': 'See events and conferences',
    'sub.visitorFree.b4': 'Free visitor badge',
    'sub.visitorPremium.name': 'Premium Visitor',
    'sub.visitorPremium.desc': 'Extended access + 5 meetings',
    'sub.visitorPremium.cta': 'Premium Registration',
    'sub.visitorPremium.f1': 'Exhibition website access',
    'sub.visitorPremium.f2': 'Browse exhibitors',
    'sub.visitorPremium.f3': 'Meeting requests (5)',
    'sub.visitorPremium.f4': 'Direct messaging',
    'sub.visitorPremium.f5': 'Exhibitor mini-sites',
    'sub.visitorPremium.f6': 'Live events',
    'sub.visitorPremium.b1': '5 active meeting requests',
    'sub.visitorPremium.b2': 'Direct messaging with exhibitors',
    'sub.visitorPremium.b3': 'Premium badge with QR code',
    'sub.visitorPremium.b4': 'Conference access',
    'sub.visitorVip.name': 'VIP Visitor',
    'sub.visitorVip.desc': 'Priority access + 10 meetings',
    'sub.visitorVip.cta': 'VIP Visitor Registration',
    'sub.visitorVip.f1': 'Exhibition website access',
    'sub.visitorVip.f2': 'Browse exhibitors',
    'sub.visitorVip.f3': 'Meeting requests (10)',
    'sub.visitorVip.f4': 'Direct messaging',
    'sub.visitorVip.f5': 'Exhibitor mini-sites',
    'sub.visitorVip.f6': 'Live events',
    'sub.visitorVip.f7': 'Priority VIP badge',
    'sub.visitorVip.f8': 'Priority access to new releases',
    'sub.visitorVip.b1': '10 active meeting requests',
    'sub.visitorVip.b2': 'Direct messaging with exhibitors',
    'sub.visitorVip.b3': 'Virtual VIP badge with QR code',
    'sub.visitorVip.b4': 'Priority in recommendation algorithms',
    'sub.visitorVip.b5': 'Exclusive webinar access',
    'sub.visitorVip.b6': 'Priority support',
    'sub.exh9m.name': 'Exhibitor 9m² (Basic)',
    'sub.exh9m.desc': 'Profile & basic presence',
    'sub.exh9m.cta': 'Exhibitor Registration',
    'sub.exh9m.f1': 'Public exhibitor profile',
    'sub.exh9m.f2': 'Logo on website',
    'sub.exh9m.f3': 'Short presentation',
    'sub.exh9m.f4': 'Custom mini-site',
    'sub.exh9m.f5': 'Meeting management',
    'sub.exh9m.f6': 'Product store',
    'sub.exh9m.f7': 'Exhibitor dashboard',
    'sub.exh9m.f8': 'Contact form',
    'sub.exh9m.b1': 'Editable exhibitor profile',
    'sub.exh9m.b2': 'Website presence',
    'sub.exh9m.b3': 'Logo and description',
    'sub.exh9m.b4': 'Basic contact form',
    'sub.exh9m.b5': 'Dashboard access',
    'sub.exh18m.name': 'Exhibitor 18m² (Standard)',
    'sub.exh18m.desc': 'Mini-site + 15 meetings',
    'sub.exh18m.cta': 'Exhibitor Registration',
    'sub.exh18m.f1': 'Public exhibitor profile',
    'sub.exh18m.f2': 'Logo on website',
    'sub.exh18m.f3': 'Custom mini-site',
    'sub.exh18m.f4': 'Meeting management (15)',
    'sub.exh18m.f5': 'Product store & filtering',
    'sub.exh18m.f6': 'Custom URL',
    'sub.exh18m.f7': 'Full dashboard',
    'sub.exh18m.f8': 'Standard support',
    'sub.exh18m.b1': 'Dedicated mini-site with custom URL',
    'sub.exh18m.b2': '15 available meeting slots',
    'sub.exh18m.b3': 'Complete product/service presentation',
    'sub.exh18m.b4': 'Visitor filtering system',
    'sub.exh18m.b5': 'Integrated messaging',
    'sub.exh18m.b6': 'Basic analytics access',
    'sub.exh36m.name': 'Exhibitor 36m² (Premium)',
    'sub.exh36m.desc': 'Spotlight + 30 meetings',
    'sub.exh36m.cta': 'Exhibitor Registration',
    'sub.exh36m.f1': 'Public exhibitor profile',
    'sub.exh36m.f2': 'Custom mini-site',
    'sub.exh36m.f3': '"Featured" spotlight',
    'sub.exh36m.f4': 'Meeting management (30)',
    'sub.exh36m.f5': 'Advanced product store',
    'sub.exh36m.f6': 'Limited Supabase API access',
    'sub.exh36m.f7': 'Advanced networking tools',
    'sub.exh36m.f8': 'Priority support',
    'sub.exh36m.f9': 'Custom virtual badge',
    'sub.exh36m.b1': 'Homepage spotlight feature',
    'sub.exh36m.b2': '30 meeting slots',
    'sub.exh36m.b3': 'Premium mini-site with unlimited media',
    'sub.exh36m.b4': 'Custom API integration',
    'sub.exh36m.b5': 'Direct messaging and chat',
    'sub.exh36m.b6': 'Detailed analytics',
    'sub.exh36m.b7': 'Priority technical support',
    'sub.exh54m.name': 'Exhibitor 54m²+ (Elite)',
    'sub.exh54m.desc': 'Maximum visibility + unlimited slots',
    'sub.exh54m.cta': 'Exhibitor Registration',
    'sub.exh54m.f1': 'Public exhibitor profile',
    'sub.exh54m.f2': 'Premium mini-site',
    'sub.exh54m.f3': 'Permanent spotlight',
    'sub.exh54m.f4': 'Unlimited meetings',
    'sub.exh54m.f5': 'Full product store',
    'sub.exh54m.f6': 'Full Supabase API access',
    'sub.exh54m.f7': 'Unlimited networking tools',
    'sub.exh54m.f8': 'VIP support 24/7',
    'sub.exh54m.f9': 'Advanced customization',
    'sub.exh54m.b1': 'Permanent and priority spotlight',
    'sub.exh54m.b2': 'Unlimited meeting slots',
    'sub.exh54m.b3': 'Mini-site with custom scripts',
    'sub.exh54m.b4': 'Full API access for integrations',
    'sub.exh54m.b5': 'Unlimited media storage',
    'sub.exh54m.b6': 'Unlimited chat and messaging',
    'sub.exh54m.b7': 'Dedicated VIP technical support',
    'sub.exh54m.b8': 'Algorithmic priority',
    'sub.partMuseum.name': 'Museum Partner ($20k)',
    'sub.partMuseum.desc': 'Presence & mini-site',
    'sub.partMuseum.cta': 'Partner Registration',
    'sub.partMuseum.f1': 'Logo on website',
    'sub.partMuseum.f2': 'Dedicated mini-site',
    'sub.partMuseum.f3': 'Rotating banner',
    'sub.partMuseum.f4': 'Newsletter presence',
    'sub.partMuseum.f5': '"Inside SIPORT" videos',
    'sub.partMuseum.f6': 'Live Studio interview',
    'sub.partMuseum.f7': 'Podcast inclusion',
    'sub.partMuseum.f8': 'Algorithmic priority',
    'sub.partMuseum.b1': '4th-row logo on website',
    'sub.partMuseum.b2': 'Premium Exposure mini-site',
    'sub.partMuseum.b3': 'Rotating web banner',
    'sub.partMuseum.b4': 'Presence in e-mailings',
    'sub.partMuseum.b5': 'Branded video capsules',
    'sub.partMuseum.b6': '"Meet The Leaders" interview',
    'sub.partMuseum.b7': '"Best Moments" mention',
    'sub.partSilver.name': 'Silver Partner ($48k)',
    'sub.partSilver.desc': 'Enhanced 3rd-row visibility',
    'sub.partSilver.cta': 'Partner Registration',
    'sub.partSilver.f1': '3rd-row logo',
    'sub.partSilver.f2': 'Dedicated mini-site',
    'sub.partSilver.f3': 'Rotating banner',
    'sub.partSilver.f4': '"Top Innovations" section',
    'sub.partSilver.f5': 'Newsletter presence',
    'sub.partSilver.f6': 'Sponsored video capsules',
    'sub.partSilver.f7': 'SIPORT Talks podcast',
    'sub.partSilver.f8': 'Live Studio interview',
    'sub.partSilver.f9': 'Video testimonial (1 min)',
    'sub.partSilver.b1': 'Visible 3rd-row priority logo',
    'sub.partSilver.b2': 'Presence in all newsletters',
    'sub.partSilver.b3': 'Mini-site with full news',
    'sub.partSilver.b4': '"Inside SIPORT" video capsules',
    'sub.partSilver.b5': 'Audio interview in Podcast',
    'sub.partSilver.b6': '"Meet The Leaders" Live Studio interview',
    'sub.partSilver.b7': 'Video testimonial broadcast',
    'sub.partSilver.b8': '50 monthly meetings',
    'sub.partGold.name': 'Gold Partner ($68k)',
    'sub.partGold.desc': 'Premium 2nd-row visibility',
    'sub.partGold.cta': 'Partner Registration',
    'sub.partGold.f1': '2nd-row logo',
    'sub.partGold.f2': 'Premium mini-site',
    'sub.partGold.f3': 'Rotating web banner',
    'sub.partGold.f4': '"Top Innovations" section',
    'sub.partGold.f5': '2nd-row newsletter',
    'sub.partGold.f6': 'Sponsored video capsules',
    'sub.partGold.f7': 'SIPORT Talks podcast',
    'sub.partGold.f8': 'Live Studio interview',
    'sub.partGold.f9': 'Video testimonial (2 min)',
    'sub.partGold.f10': 'Priority support',
    'sub.partGold.b1': 'Visible 2nd-row priority logo',
    'sub.partGold.b2': 'All web & email channels',
    'sub.partGold.b3': '"SIPORT Premium Exposure" mini-site',
    'sub.partGold.b4': 'Video capsules & brand awareness',
    'sub.partGold.b5': 'Podcast audio interview',
    'sub.partGold.b6': 'Priority Live Studio interview',
    'sub.partGold.b7': '2 min video testimonial broadcast',
    'sub.partGold.b8': '100 monthly meetings',
    'sub.partGold.b9': 'Priority technical support',
    'sub.partPlatinum.name': 'Platinum Partner ($98k)',
    'sub.partPlatinum.desc': 'Maximum 1st-row visibility + unlimited',
    'sub.partPlatinum.cta': 'Partner Registration',
    'sub.partPlatinum.f1': '1st-row logo everywhere',
    'sub.partPlatinum.f2': 'Premium mini-site',
    'sub.partPlatinum.f3': 'Rotating web banner',
    'sub.partPlatinum.f4': '"Top Innovations" section',
    'sub.partPlatinum.f5': '1st-row newsletters',
    'sub.partPlatinum.f6': 'Sponsored webinars',
    'sub.partPlatinum.f7': '"Inside SIPORT" video capsules',
    'sub.partPlatinum.f8': 'SIPORT Talks podcast',
    'sub.partPlatinum.f9': 'Priority Live Studio interview',
    'sub.partPlatinum.f10': 'Video testimonial (3 min)',
    'sub.partPlatinum.f11': 'VIP support 24/7',
    'sub.partPlatinum.b1': '1st-row logo on all channels',
    'sub.partPlatinum.b2': 'Full "Premium Exposure" mini-site',
    'sub.partPlatinum.b3': 'Sponsored webinars with replay',
    'sub.partPlatinum.b4': 'Exclusive branded video capsules',
    'sub.partPlatinum.b5': 'Priority podcast inclusion',
    'sub.partPlatinum.b6': '"Meet The Leaders" Live Studio interview',
    'sub.partPlatinum.b7': '3 min premium video testimonial',
    'sub.partPlatinum.b8': 'Unlimited meetings',
    'sub.partPlatinum.b9': 'Dedicated VIP support',
    'sub.partPlatinum.b10': 'Maximum algorithmic priority',
    'partSupport.pageTitle': 'Partner Support',
    'partSupport.pageSubtitle': 'Dedicated technical assistance, training and commercial support',
    'partSupport.backToDashboard': 'Back to dashboard',
    'partSupport.premiumSupport': 'Premium Support 24/7',
    'partSupport.responseTime': 'Response time: 2h 15m',
    'partSupport.activeTickets': 'Active tickets',
    'partSupport.resolvedThisMonth': 'Resolved this month',
    'partSupport.avgResponseTime': 'Average response time',
    'partSupport.clientSatisfaction': 'Client satisfaction',
    'partSupport.quickActions': 'Quick Actions',
    'partSupport.createTicket': 'Create a ticket',
    'partSupport.createTicketDesc': 'Report a problem or make a request',
    'partSupport.contactSupport': 'Contact support',
    'partSupport.contactSupportDesc': 'Speak directly with an advisor',
    'partSupport.knowledgeBase': 'Knowledge base',
    'partSupport.knowledgeBaseDesc': 'Find answers to frequently asked questions',
    'partSupport.scheduleTraining': 'Schedule training',
    'partSupport.scheduleTrainingDesc': 'Book a personalized training session',
    'partSupport.recentTickets': 'Recent Tickets',
    'partSupport.ticket': 'Ticket',
    'partSupport.statusInProgress': 'In progress',
    'partSupport.statusResolved': 'Resolved',
    'partSupport.statusPending': 'Pending',
    'partSupport.statusClosed': 'Closed',
    'partSupport.priorityHigh': 'High',
    'partSupport.priorityMedium': 'Medium',
    'partSupport.priorityLow': 'Low',
    'partSupport.category': 'Category:',
    'partSupport.createdAt': 'Created:',
    'partSupport.lastUpdate': 'Last update:',
    'partSupport.assignedTo': 'Assigned to:',
    'partSupport.reply': 'Reply',
    'partSupport.markResolved': 'Mark resolved',
    'partSupport.supportCategories': 'Support Categories',
    'partSupport.technicalSupport': 'Technical Support',
    'partSupport.technicalSupportDesc': 'Technical issues, bugs, integrations',
    'partSupport.trainingOnboarding': 'Training & Onboarding',
    'partSupport.trainingOnboardingDesc': 'Training sessions, user guides',
    'partSupport.commercial': 'Commercial',
    'partSupport.commercialDesc': 'Commercial questions, contracts, billing',
    'partSupport.administrative': 'Administrative',
    'partSupport.administrativeDesc': 'Profile updates, documents, access',
    'partSupport.activeTicketsLabel': 'Active tickets:',
    'partSupport.avgResolution': 'Average resolution:',
    'partSupport.contactSupportTitle': 'Contact Support',
    'partSupport.phoneSupport': 'Phone Support',
    'partSupport.phoneAvailability': '24/7 - Available immediately',
    'partSupport.emailSupport': 'Email Support',
    'partSupport.emailResponseTime': 'Response within 2h',
    'partSupport.liveChat': 'Live Chat',
    'partSupport.liveChatAvailability': 'Available 8am-6pm',
    'partSupport.liveChatLocation': 'Chat at bottom right',
    'partSupport.ticket1Title': 'Analytics platform access issue',
    'partSupport.ticket1Desc': 'Unable to access performance reports since this morning.',
    'partSupport.ticket1Category': 'Technical',
    'partSupport.ticket2Title': 'Sales team training request',
    'partSupport.ticket2Desc': 'Need training on new prospecting tools.',
    'partSupport.ticket2Category': 'Training',
    'partSupport.ticket3Title': 'Company information update',
    'partSupport.ticket3Desc': 'Address and phone number change to update.',
    'partSupport.ticket3Category': 'Administrative',
    'detail.overview': 'Overview',
    'detail.contact': 'Contact Us',
    'detail.book_appointment': 'Book Appointment',
    'detail.add_favorite': 'Add to Favorites',
    'detail.share': 'Share',
    'detail.products': 'Products',
    'detail.services': 'Services',
    'detail.team': 'Team',
    'networking.description': 'Smart connections based on your profile',
    'networking.connections': 'My Connections',
    'networking.favorites': 'My Favorites',
    'networking.find_matches': 'Find Matches',
    'networking.compatibility': 'Compatibility',
    'api.title': 'SIPORTS API',
    'api.description': 'Integrate SIPORTS into your applications',
    'api.documentation': 'API Documentation',
    'api.authentication': 'Authentication',
    'api.endpoints': 'Endpoints',
    'api.rate_limiting': 'Rate Limiting',
    'api.webhook': 'Webhooks',
    'api.get_started': 'Get Started',
    'badge.title': 'My Badge',
    'badge.badge_info': 'Badge Information',
    'badge.access_level': 'Access Level',
    'badge.qr_code': 'QR Code',
    'badge.download': 'Download',
    'badge.print': 'Print',
    'badge.share': 'Share',
    'enhanced_networking.title': 'Advanced Networking',
    'enhanced_networking.ai_matching': 'AI Matching',
    'enhanced_networking.analytics': 'Analytics',
    'enhanced_networking.compatibility_score': 'Compatibility Score',
    'enhanced_networking.mutual_connections': 'Mutual Connections',
    'upgrade.partner_title': 'Partner Subscription Plans',
    'upgrade.partner_description': 'Increase your visibility at SIPORTS 2026',
    'upgrade.visitor_title': 'Visitor Upgrades',
    'upgrade.visitor_description': 'Access premium features',
    'upgrade.payment_method': 'Payment Method',
    'upgrade.card': 'Credit Card',
    'upgrade.paypal': 'PayPal',
    'upgrade.bank_transfer': 'Bank Transfer',
    'upgrade.amount': 'Amount',
    'upgrade.total': 'Total',
    'payment.error.missingReference': 'Please enter the transfer reference',
    'payment.success.proofSubmitted': 'Proof submitted! Your payment will be validated within 24-48h.',
    'payment.error.generic': 'Error: {{message}}',
    'common.copiedToClipboard': 'Copied to clipboard',
    'payment.error.notFound': 'User or payment request not found.',
    'payment.instructions.title': 'Payment Instructions',
    'payment.instructions.subtitle': 'Premium VIP Pass - ',
    'payment.status.pendingTitle': 'Request pending validation',
    'payment.status.pendingDescription': 'Your request has been received. Please proceed with the transfer to finalize your registration.',
    'payment.status.approvedTitle': 'Payment approved!',
    'payment.status.approvedDescription': 'You now have access to the Premium VIP Pass.',
    'payment.status.rejectedTitle': 'Payment rejected',
    'payment.status.rejectedReason': 'Reason: ',
    'payment.bank.title': 'Bank Information',
    'payment.bank.bankName': 'Bank',
    'payment.bank.accountHolder': 'Account Holder',
    'payment.bank.iban': 'IBAN',
    'payment.bank.bic': 'BIC/SWIFT',
    'payment.bank.mandatoryReference': 'Mandatory Reference',
    'payment.bank.referenceNote': 'Must be included in the transfer description',
    'payment.instructions.stepsTitle': 'Instructions',
    'payment.instructions.step1': 'Make a transfer of <strong>{{amount}} EUR</strong> to the specified account.',
    'payment.instructions.step2': 'Include the reference <strong>{{reference}}</strong> in the description.',
    'payment.instructions.step3': 'Keep your proof of transfer.',
    'payment.instructions.step4': 'Enter the reference below for validation.',
    'payment.proof.title': 'Submit your proof',
    'payment.proof.referenceLabel': 'Transfer reference',
    'payment.proof.referenceHint': 'Transaction number or bank reference',
    'payment.proof.urlLabel': 'Proof URL (optional)',
    'payment.proof.urlHint': 'Link to your proof (Google Drive, Dropbox, etc.)',
    'payment.proof.submitting': 'Sending...',
    'payment.proof.submit': 'Submit proof',
    'payment.proof.submittedTitle': 'Proof submitted',
    'payment.proof.submittedDate': 'Submitted on {{date}}',
    'payment.proof.processingNote': 'Your request is being processed. You will be notified upon validation.',
    'payment.support.needHelp': 'Need help? Contact us at',
    'payment.success.confirmed': 'Payment confirmed! You are now VIP.',
    'payment.success.validated': 'Payment validated! You are now VIP.',
    'payment.success.welcomeVip': 'Welcome to the VIP Club!',
    'payment.error.verificationFailed': 'Unable to verify payment. Contact support.',
    'payment.error.verificationError': 'Error during payment verification',
    'payment.verification.loading': 'Verifying payment...',
    'payment.verification.pleaseWait': 'Please wait a moment',
    'payment.error.title': 'Payment Error',
    'payment.error.retry': 'Retry payment',
    'payment.error.contactSupport': 'Contact support',
    'payment.success.title': 'Payment successful!',
    'payment.success.welcomeClub': 'Welcome to the VIP Club',
    'payment.success.description': 'Your Premium VIP Pass is now active! You now have access to all exclusive features of SIPORT 2026.',
    'payment.success.emailSent': 'A confirmation email has been sent to <strong>{{email}}</strong>',
    'payment.success.nextSteps': 'Next steps',
    'payment.success.step1Title': 'Download your VIP badge',
    'payment.success.step1Desc': 'Premium badge with photo and secure QR code',
    'payment.success.step2Title': 'Access your VIP dashboard',
    'payment.success.step2Desc': 'All premium features are now unlocked',
    'payment.success.step3Title': 'Plan your B2B meetings',
    'payment.success.step3Desc': 'UNLIMITED B2B meetings available immediately',
    'payment.success.downloadBadge': 'Download my VIP badge',
    'payment.success.goToDashboard': 'Go to my VIP dashboard',
    'payment.success.benefit1Title': 'Unlimited Networking',
    'payment.success.benefit1Desc': 'Meet all decision-makers',
    'payment.success.benefit2Title': 'Unlimited B2B Meetings',
    'payment.success.benefit2Desc': 'Plan your strategic meetings',
    'payment.success.benefit3Title': 'Exclusive Events',
    'payment.success.benefit3Desc': 'Gala, workshops, VIP conferences',
    'upgrade.free.badge': 'Basic digital badge',
    'upgrade.free.exhibition': 'Exhibition area access',
    'upgrade.free.publicConferences': 'Public conferences',
    'upgrade.free.b2bMeetings': 'B2B meetings',
    'upgrade.free.unlimitedNetworking': 'Unlimited networking',
    'upgrade.free.exclusiveEvents': 'Exclusive events',
    'upgrade.free.workshops': 'Specialized workshops',
    'upgrade.free.gala': 'Gala evening',
    'upgrade.vip.premiumBadge': 'Premium badge with photo',
    'upgrade.vip.fullAccess': 'Full 3-day access',
    'upgrade.vip.b2bRequests': '10 active B2B meeting requests',
    'upgrade.vip.unlimitedNetworking': 'Unlimited networking',
    'upgrade.vip.inauguration': 'Inauguration invitation',
    'upgrade.vip.workshops': 'Specialized workshops',
    'upgrade.vip.exclusiveGala': 'Exclusive gala evening',
    'upgrade.vip.networkingLunches': 'Networking lunches',
    'upgrade.vip.vipConferences': 'VIP conferences',
    'upgrade.vip.privateLounge': 'Private lounge access',
    'upgrade.testimonial1.content': 'The VIP Pass transformed my participation. I got 8 strategic meetings and signed 2 major partnerships.',
    'upgrade.testimonial2.content': 'The exclusive VIP events allowed me to meet key decision-makers. Exceptional ROI!',
    'upgrade.testimonial3.content': 'Access to unlimited networking is well worth the investment. I highly recommend it.',
    'upgrade.hero.title': 'Upgrade to Premium VIP Pass',
    'upgrade.hero.subtitle': 'Unlock all features and maximize your return on investment at SIPORT 2026',
    'upgrade.hero.launchOffer': 'Launch offer: 700€ instead of 950€',
    'upgrade.freeCard.title': 'Free Pass',
    'upgrade.freeCard.subtitle': 'Limited access',
    'upgrade.freeCard.currentPass': 'Your current pass',
    'upgrade.vipCard.recommended': '⭐ RECOMMENDED',
    'upgrade.vipCard.title': 'Premium VIP Pass',
    'upgrade.vipCard.subtitle': 'Full 3-day access',
    'upgrade.vipCard.cta': 'Upgrade to Premium VIP',
    'upgrade.benefits.title': 'Why go Premium?',
    'upgrade.benefits.b2bTitle': 'Strategic B2B Meetings',
    'upgrade.benefits.b2bDesc': '10 active requests to meet key decision-makers. Automatic release after response.',
    'upgrade.benefits.networkTitle': 'Premium Networking',
    'upgrade.benefits.networkDesc': 'Unlimited access to exclusive events: gala, lunches, private lounge with 500+ decision-makers.',
    'upgrade.benefits.badgeTitle': 'Ultra-Secure Badge',
    'upgrade.benefits.badgeDesc': 'Premium badge with photo and encrypted QR code. Priority access to all VIP areas.',
    'upgrade.testimonials.title': 'What our VIP members say',
    'upgrade.roi.title': 'Guaranteed ROI',
    'upgrade.roi.description': 'Our VIP members generate an average of <span class="font-bold text-yellow-300">€15,000</span> in new business opportunities at the exhibition. Invest €700, reap thousands.',
    'upgrade.roi.cta': 'Become VIP Now',
    'upgrade.faq.title': 'Frequently Asked Questions',
    'upgrade.faq.q1': 'What payment methods do you accept?',
    'upgrade.faq.a1': 'Credit cards (Visa, Mastercard), PayPal, and Moroccan cards (CMI).',
    'upgrade.faq.q2': 'Is access immediate after payment?',
    'upgrade.faq.a2': 'Yes! Your account is activated instantly and you receive your VIP badge by email.',
    'upgrade.faq.q3': 'Can I cancel after payment?',
    'upgrade.faq.a3': 'Full refund possible up to 30 days before the event.',
    'users.title': 'User Management',
    'users.total': 'Total Users',
    'users.active': 'Active Users',
    'users.search': 'Search users',
    'users.filter': 'Filter by type',
    'users.status': 'Status',
    'users.action': 'Actions',
    'users.delete': 'Delete',
    'partner_detail.about': 'About',
    'partner_detail.projects': 'Projects',
    'partner_detail.contact_info': 'Contact Information',
    'partner_detail.request_meeting': 'Request Meeting',
    'partner_detail.back': 'Back',
    'product_detail.specifications': 'Specifications',
    'product_detail.price': 'Price',
    'product_detail.availability': 'Availability',
    'product_detail.request_demo': 'Request Demo',
    'product_detail.contact_supplier': 'Contact Supplier',
    'password.reset_title': 'Reset Password',
    'password.reset_description': 'Enter your new password',
    'password.new_password': 'New Password',
    'password.confirm': 'Confirm',
    'password.error': 'Error resetting password',
    'auth.forgotten_password': 'Forgotten password',
    'auth.forgotten_password_desc': 'Enter your email address and we will send you a link to reset your password.',
    'auth.email': 'Email',
    'auth.email_placeholder': 'your@email.com',
    'auth.send_reset_link': 'Send reset link',
    'auth.go_login': 'Go to login page',
    'common.error_401': '401 - Unauthorized',
    'common.error_401_desc': 'Please log in to access this page.',
    'common.error_403': '403 - Forbidden',
    'common.error_403_desc': 'You do not have the necessary permissions to access this page.',
    'common.back_dashboard': 'Back to dashboard',
    'common.sending': 'Sending...',
    'common.view': 'View details',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'ui.sync_official': 'Sync with official site',
    'ui.share_article': 'Share this article',
    'ui.back_to_top': 'Back to top',
    'ui.search_by': 'Search by...',
    'admin_media.create_title_example': 'Ex: Port Innovation Interview',
    'admin_media.create_description_placeholder': 'Describe media content...',
    'admin_media.duration_example': '120',
    'admin_media.tags_example': 'Ex: Innovation, Tech, Interview',
    'admin_media.manager_title': 'Media Manager',
    'accommodation.badge': 'Partner Hotels',
    'accommodation.title': 'Accommodation in El Jadida',
    'accommodation.subtitle': 'Enjoy preferential rates at our partner hotels',
    'accommodation.hotels_partners': 'Partner hotels',
    'accommodation.vip_discount': 'VIP Discount',
    'accommodation.april_dates': 'April 2026',
    'accommodation.vip_advantage_title': '🌟 VIP Visitor Advantage',
    'accommodation.vip_advantage_desc': 'As a VIP visitor, benefit from exclusive preferential rates at all our partner hotels',
    'accommodation.vip_benefit_1': 'Up to -20% off all hotels',
    'accommodation.vip_benefit_2': 'Priority reservation guaranteed',
    'accommodation.vip_benefit_3': 'Free upgrade subject to availability',
    'accommodation.featured_partner': '⭐ Premium Partner',
    'accommodation.standard_rate': 'Standard Rate',
    'accommodation.vip_rate': 'VIP Rate',
    'accommodation.per_night': 'per night',
    'accommodation.view_details': 'View details',
    'accommodation.amenity_wifi': 'Free WiFi',
    'accommodation.amenity_parking': 'Parking',
    'accommodation.amenity_pool': 'Swimming Pool',
    'accommodation.amenity_spa': 'Spa',
    'accommodation.amenity_restaurant': 'Restaurant',
    'accommodation.amenity_gym': 'Fitness Center',
    'accommodation.amenity_casino': 'Casino',
    'accommodation.amenity_beach': 'Beach Access',
    'accommodation.amenity_golf': 'Golf',
    'accommodation.amenity_bar': 'Bar',
    'accommodation.amenity_terrace': 'Terrace',
    'accommodation.how_to_book': 'How to book?',
    'accommodation.step1_title': 'Choose your hotel',
    'accommodation.step1_desc': 'Select the hotel that meets your needs',
    'accommodation.step2_title': 'Contact the hotel',
    'accommodation.step2_desc': 'Call directly or send an email',
    'accommodation.step3_title': 'Mention SIPORTS',
    'accommodation.step3_desc': 'Provide the code "SIPORTS2026" for the preferential rate',
    'accommodation.step4_title': 'Confirm your reservation',
    'accommodation.step4_desc': 'Receive your confirmation by email',
    'accommodation.need_help': 'Need help booking?',
    'accommodation.contact_desc': 'Our team is available to assist you',
    'security.title': 'Security',
    'security.two_factor': 'Two-Factor Authentication',
    'security.enable_2fa': 'Enable 2FA',
    'security.disable_2fa': 'Disable 2FA',
    'security.totp': 'Authenticator App',
    'security.sms': 'SMS',
    'security.email': 'Email',
    'security.backup_codes': 'Backup Codes',
    'security.password': 'Password',
    'security.change_password': 'Change Password',
    'security.change_password_desc': 'Change your temporary password to secure your account.',
    'security.current_password': 'Current Password',
    'security.new_password': 'New Password',
    'security.confirm_password': 'Confirm New Password',
    'security.new_password_placeholder': 'Minimum 8 characters',
    'security.confirm_password_placeholder': 'Re-enter the new password',
    'security.password_requirements': 'Minimum 8 characters. Use letters, numbers and symbols.',
    'security.change_password_btn': 'Update Password',
    'security.password_changed': 'Password changed successfully!',
    'security.passwords_mismatch': 'Passwords do not match.',
    'security.password_too_short': 'Password must be at least 8 characters.',
    'security.current_password_wrong': 'Current password is incorrect.',
    'security.fields_required': 'All fields are required.',
    'security.sessions': 'Active Sessions',
    'security.api_keys': 'API Keys',
    'security.audit_logs': 'Audit Logs',
    'notifications.title': 'Notifications',
    'notifications.mark_all_read': 'Mark all as read',
    'notifications.no_notifications': 'No notifications',
    'notifications.new': 'New',
    'notifications.unread': 'Unread',
    'notifications.settings': 'Notification Settings',
    'notifications.email_notifications': 'Email Notifications',
    'notifications.push_notifications': 'Push Notifications',
    'notifications.sms_notifications': 'SMS Notifications',
    'notifications.preferences': 'Preferences',
    'analytics.title': 'Analytics',
    'analytics.overview': 'Overview',
    'analytics.visitors': 'Visitors',
    'analytics.pageviews': 'Page Views',
    'analytics.conversions': 'Conversions',
    'analytics.revenue': 'Revenue',
    'analytics.export': 'Export',
    'analytics.period': 'Period',
    'analytics.today': 'Today',
    'analytics.week': 'This Week',
    'analytics.month': 'This Month',
    'analytics.year': 'This Year',
    'analytics.custom': 'Custom',
    'payments.title': 'Payments',
    'payments.methods': 'Payment Methods',
    'payments.history': 'History',
    'payments.invoices': 'Invoices',
    'payments.refunds': 'Refunds',
    'payments.pending': 'Pending',
    'payments.completed': 'Completed',
    'payments.failed': 'Failed',
    'payments.amount': 'Amount',
    'payments.date': 'Date',
    'payments.status': 'Status',
    'payments.download_invoice': 'Download Invoice',
    'partner.activity.title': 'Partner Activity',
    'partner.activity.connection_established': 'Connection Established',
    'partner.activity.connected_with': 'Connected with',
    'partner.activity.new_message': 'New Message',
    'partner.activity.event_participation': 'Event Participation',
    'partner.activity.stand_visit': 'Stand Visit',
    'partner.activity.product_inquiry': 'Product Inquiry',
    'partner.activity.meeting_scheduled': 'Meeting Scheduled',
    'partner.activity.meeting_confirmed': 'Meeting Confirmed',
    'partner.activity.meeting_completed': 'Meeting Completed',
    'partner.activity.meeting_cancelled': 'Meeting Cancelled',
    'partner.activity.lead_generated': 'Lead Generated',
    'partner.activity.download': 'Download Resources',
    'partner.activity.brochure_request': 'Brochure Request',
    'partner.activity.contact_request': 'Contact Request',
    'partner.activity.quote_request': 'Quote Request',
    'partner.activity.demo_request': 'Demo Request',
    'partner.activity.partnership_interest': 'Partnership Interest',
    'partner.activity.event_interest': 'Event Interest',
    'partner.activity.network_join': 'Join Network',
    'partner.activity.filter_all': 'All',
    'partner.activity.filter_connections': 'Connections',
    'partner.activity.filter_messages': 'Messages',
    'partner.activity.filter_meetings': 'Meetings',
    'partner.activity.filter_inquiries': 'Inquiries',
    'partner.activity.timestamp_today': 'Today',
    'partner.activity.timestamp_yesterday': 'Yesterday',
    'partner.activity.timestamp_this_week': 'This Week',
    'partner.activity.timestamp_this_month': 'This Month',
    'partner.activity.total_connections': 'Total Connections',
    'partner.activity.total_messages': 'Total Messages',
    'partner.activity.total_meetings': 'Total Meetings',
    'partner.activity.message_from': '{name} sent you a message',
    'partner.activity.participated_in': 'You participated in {event}',
    'partner.activity.sponsoring_activated': 'Sponsoring Activated',
    'partner.activity.logo_displayed': 'Your logo is now displayed on {page}',
    'partner.activity.profile_viewed': 'Profile Viewed',
    'partner.activity.views_today': 'Your profile was viewed {count} times today',
    'partner.activity.content_shared': 'Content Shared',
    'partner.activity.article_shared': 'Your article "{title}" was shared',
    'partner.activity.system_alert': 'System Alert',
    'partner.activity.metrics_update': 'Your performance metrics update is available',
    'partner.activity.just_now': 'Just now',
    'partner.activity.hours_ago': '{n}h ago',
    'partner.activity.days_ago': '{n}d ago',
    'partner.activity.type.connection': 'Connection',
    'partner.activity.type.message': 'Message',
    'partner.activity.type.event': 'Event',
    'partner.activity.type.sponsorship': 'Sponsorship',
    'partner.activity.type.consultation': 'Consultation',
    'partner.activity.type.content': 'Content',
    'partner.activity.type.alert': 'Alert',
    'partner.activity.type.meeting': 'Meeting',
    'partner.activity.filter.all': 'All Activities',
    'partner.activity.filter.networking': 'Networking',
    'partner.activity.filter.communication': 'Communication',
    'partner.activity.filter.events': 'Events',
    'partner.activity.filter.sponsorship': 'Sponsorship',
    'partner.activity.filter.engagement': 'Engagement',
    'partner.activity.filter.content': 'Content',
    'partner.activity.filter.meetings': 'Meetings',
    'partner.activity.filter.system': 'System',
    'partner.activity.full_history': 'Full Activity History',
    'partner.activity.realtime': 'Real Time',
    'partner.activity.stats.total': 'Total Activities',
    'partner.activity.stats.today': 'Today',
    'partner.activity.stats.this_week': 'This Week',
    'partner.activity.history': 'Activity History',
    'partner.activity.no_activity': 'No activity found',
    'partner.activity.try_filters': 'Try changing your search filters',
    'partner.leads.title': 'Lead Management',
    'partner.leads.overview': 'Leads Overview',
    'partner.leads.total_leads': 'Total Leads',
    'partner.leads.new_leads': 'New Leads',
    'partner.leads.qualified_leads': 'Qualified Leads',
    'partner.leads.contacted': 'Contacted',
    'partner.leads.converted': 'Converted',
    'partner.leads.source_event': 'Source: Event',
    'partner.leads.source_website': 'Source: Website',
    'partner.leads.source_email': 'Source: Email',
    'partner.leads.source_referral': 'Source: Referral',
    'partner.leads.source_other': 'Source: Other',
    'partner.leads.stage_new': 'Stage: New',
    'partner.leads.stage_contacted': 'Stage: Contacted',
    'partner.leads.stage_qualified': 'Stage: Qualified',
    'partner.leads.stage_proposal': 'Stage: Proposal',
    'partner.leads.stage_negotiation': 'Stage: Negotiation',
    'partner.leads.stage_won': 'Stage: Won',
    'partner.leads.stage_lost': 'Stage: Lost',
    'partner.leads.quality_high': 'Quality: High',
    'partner.leads.quality_medium': 'Quality: Medium',
    'partner.leads.quality_low': 'Quality: Low',
    'partner.leads.tip_follow_up': 'Tip: Follow up within 48h after initial contact',
    'partner.leads.tip_personalize': 'Tip: Personalize each lead approach',
    'partner.leads.tip_document': 'Tip: Document all interactions',
    'partner.leads.tip_timing': 'Tip: Timing is key for conversion',
    'partner.leads.tip_interests': 'Tip: Identify the specific interests of the lead',
    'partner.leads.exhibitor': 'Exhibitor',
    'partner.leads.visitor': 'Visitor',
    'partner.leads.other': 'Other',
    'partner.leads.connected': 'Connected',
    'partner.leads.pending': 'Pending',
    'partner.leads.rejected': 'Rejected',
    'partner.leads.active_followup': 'Active Follow-up',
    'partner.leads.awaiting_response': 'Awaiting Response',
    'partner.leads.sources.events': 'SIPORTS Events',
    'partner.leads.sources.networking': 'Partner Networking',
    'partner.leads.sources.referrals': 'Client Referrals',
    'partner.leads.sources.marketing': 'Marketing Campaigns',
    'partner.leads.funnel.generated': 'Leads Generated',
    'partner.leads.funnel.qualified': 'Qualified',
    'partner.leads.funnel.proposal': 'Proposal',
    'partner.leads.funnel.negotiation': 'Negotiation',
    'partner.leads.funnel.conversion': 'Conversion',
    'partner.leads.subtitle': 'Manage your qualified leads and track their progress in the sales pipeline',
    'partner.leads.premium_program': 'Premium Leads Program',
    'partner.leads.conversion_rate': '12% Conversion Rate',
    'partner.leads.generated': 'Leads Generated',
    'partner.leads.qualified': 'Qualified Leads',
    'partner.leads.conversion': 'Conversion Rate',
    'partner.leads.estimated_value': 'Estimated Value',
    'partner.leads.recent': 'Recent Leads',
    'partner.leads.tips.title': 'Lead Management Tips',
    'partner.leads.tips.qualification': 'Quick Qualification',
    'partner.leads.tips.qualification_desc': 'Contact hot leads within 24h to maximize your conversion chances',
    'partner.leads.tips.followup': 'Regular Follow-up',
    'partner.leads.tips.followup_desc': 'Schedule weekly check-ins to maintain engagement',
    'partner.leads.tips.personalization': 'Personalization',
    'partner.leads.tips.personalization_desc': 'Adapt your proposals to the specific needs of each prospect',
    'partner.leads.tips.measure': 'Measure Results',
    'partner.leads.tips.measure_desc': 'Regularly analyze your conversion rates to optimize your approach',
    'partner.events.title': 'Event Management',
    'partner.events.overview': 'Events Overview',
    'partner.events.upcoming': 'Upcoming Events',
    'partner.events.past': 'Past Events',
    'partner.events.registered': 'Registered Events',
    'partner.events.status_scheduled': 'Status: Scheduled',
    'partner.events.status_ongoing': 'Status: Ongoing',
    'partner.events.status_completed': 'Status: Completed',
    'partner.events.status_cancelled': 'Status: Cancelled',
    'partner.events.registration_open': 'Registration Open',
    'partner.events.registration_closed': 'Registration Closed',
    'partner.events.capacity': 'Capacity',
    'partner.events.attendees': 'Attendees',
    'partner.events.program': 'Program',
    'partner.events.speakers': 'Speakers',
    'partner.events.location': 'Location',
    'partner.events.date_time': 'Date and Time',
    'partner.events.available': 'Available Events',
    'partner.events.loading': 'Loading events...',
    'partner.events.none': 'No events available at this time.',
    'networking.matchmaking_title': 'Network Matchmaking',
    'networking.compatibility_level_excellent': 'Excellent',
    'networking.compatibility_level_good': 'Good',
    'networking.compatibility_level_fair': 'Fair',
    'networking.compatibility_level_poor': 'Poor',
    'networking.ai_reserved_premium': 'Reserved for Premium/VIP accounts',
    'networking.excellent_match': 'Excellent',
    'networking.good_match': 'Good',
    'networking.potential_match': 'Potential',
    'networking.low_match': 'Low',
    'nav.my_account': 'My Account',
    'nav.my_profile': 'My Profile',
    'nav.admin_profile': 'Admin Profile',
    'nav.admin_dashboard': 'Admin Dashboard',
    'nav.payment_validation': 'Payment Validation',
    'nav.metrics': 'Metrics & Performance',
    'nav.qr_scanner': 'QR Scanner (Security)',
    'nav.badge_print': 'Badge Printing (Client Service)',
    'nav.digital_badge': 'My Digital Badge',
    'nav.admin_zone': 'Administrator Zone',
    'nav.exhibitor_dashboard': 'Exhibitor Dashboard',
    'nav.b2b_networking': 'B2B Networking',
    'nav.minisite_editor': 'Mini-Site Editor',
    'nav.my_slots': 'My Appointment Slots',
    'nav.messages': 'Messages & Contact',
    'nav.partner_dashboard': 'Partner Dashboard',
    'nav.vip_networking': 'VIP Networking',
    'nav.partner_subscription': 'Partner Subscription',
    'nav.visitor_dashboard': 'Visitor Dashboard',
    'nav.visitor_settings': 'Visitor Settings',
    'nav.my_appointments': 'My Appointments',
    'footer.tagline': 'Redefining port excellence through technological innovation and global strategic networking.',
    'footer.navigation': 'Navigation',
    'footer.nav_home': 'Home',
    'footer.nav_exhibitors_catalog': 'Exhibitors Catalog',
    'footer.nav_networking': 'B2B Networking',
    'footer.nav_conferences': 'Conferences',
    'footer.nav_news': 'News',
    'footer.media_platform': 'Media Platform',
    'footer.strategic_contact': 'Strategic Contact',
    'footer.privacy': 'Privacy',
    'footer.legal': 'Legal Notice',
    'footer.all_rights': 'All rights reserved',
    'exhibitors.catalog_label': 'SIPORT 2026 • Exhibitors Catalog',
    'exhibitors.leaders_count': 'port industry leaders to discover.',
    'exhibitors.filters': 'Filters',
    'exhibitors.all_sectors': 'All sectors',
    'exhibitors.no_results_desc': 'No exhibitors match your current criteria. Try broadening your search.',
    'exhibitors.reset_search': 'Reset search',
    'home.about_siports': 'About SIPORTS',
    'home.about_subtitle': 'The unmissable event for the port industry',
    'home.discover_exhibitors_btn': 'Discover Exhibitors',
    'home.see_partners_btn': 'See Partners',
    'home.discover_all_partners_subtitle': 'Discover all official partners of the fair',
    'home.no_partners_available': 'No partners available at this time',
    'home.discover_all_exhibitors_subtitle': 'Discover all participating exhibitors',
    'contact.select_subject': 'Select a subject',
    'contact.subject_exhibitor': 'Become an exhibitor',
    'contact.subject_visitor': 'Register as a visitor',
    'contact.subject_partnership': 'Partnership',
    'contact.subject_support': 'Technical support',
    'contact.subject_other': 'Other',
    'contact.sending': 'Sending...',
    'contact.address': 'Address',
    'contact.phone': 'Phone',
    'contact.weekdays': 'Monday - Friday',
    'contact.saturday': 'Saturday',
    'contact.sunday': 'Sunday',
    'contact.closed': 'Closed',
    'contact.contact_info': 'Contact Information',
    'contact.opening_hours': 'Opening Hours',
    'contact.follow_us': 'Follow Us',
    'contact.follow_us_desc': 'Stay informed about the latest SIPORTS 2026 news',
    'contact.characters': 'characters',
    'contact.required_fields': 'Please fill in all required fields',
    'contact.invalid_email': 'Please enter a valid email address',
    'contact.message_too_short': 'Message must contain at least 10 characters',
    'contact.error': 'An error occurred. Please try again later.',
    'about.excellence': 'Port Excellence',
    'about.excellence_desc': 'The largest port event in Africa',
    'about.international': 'International Reach',
    'about.international_desc': '42+ countries represented across 5 continents',
    'about.networking': 'B2B & B2G Networking',
    'about.networking_desc': '6,000 professionals gathered',
    'about.innovation': 'Innovation & Smart Ports',
    'about.innovation_desc': 'Cutting-edge port technologies',
    'about.exhibitors_stat': 'Exhibitors',
    'about.countries_stat': 'Countries',
    'about.visitors_stat': 'Visitors',
    'about.days_stat': 'Days',
    'about.badge': 'About SIPORTS',
    'about.title': 'SIPORTS 2026 — <highlight>The unmissable event</highlight> for the port industry',
    'about.desc1': 'The <strong>International Ports and Ecosystem Exhibition (SIPORTS)</strong> is the must-attend event for professionals in the port, logistics and maritime sectors in Africa and worldwide.',
    'about.desc2': 'From <strong>April 1 to 3, 2026</strong>, the <strong>Mohammed VI Exhibition Park in El Jadida</strong>, Morocco, will host <strong>300 exhibitors</strong> and <strong>6,000 professional visitors</strong> from more than 42 countries.',
    'about.desc3': '<strong>Under the aegis of the Ministry of Equipment and Water of the Kingdom of Morocco</strong>, this strategic event facilitates exchanges between port authorities, shipowners, logistics operators and solution providers.',
    'about.card_title': 'International Ports Exhibition',
    'about.card_desc': 'The largest port event in Africa and the Arab world',
    'about.cta_title': 'Ready to join SIPORTS 2026?',
    'about.cta_desc': 'Book your spot now and discover the opportunities of the largest international port exhibition in Africa.',
    'about.cta_button': 'Register now',
    'about.dates': 'April 1-3',
    'about.location_city': 'El Jadida',
    'about.location_country': 'Morocco 🇲🇦',
    'services.need_help': 'Need assistance?',
    'services.help_desc': 'Our sales teams are available to help you',
    'services.send_message': 'Send a message',
    'services.whatsapp_desc': 'Contact us directly by message',
    'services.send_email': 'Send an email',
    'services.email_desc': 'Send an email to our team',
    'services.phone': 'Phone',
    'services.phone_desc': 'Call us directly',
    'services.call_now': 'Call now',
    'services.hours': 'Hours',
    'services.hours_desc': 'We are available:<br />Monday - Friday: 9am-6pm',
    'services.timezone': 'Timezone: GMT+1',
    'services.ready_to_chat': 'Ready to chat with our team?',
    'services.whatsapp_cta': 'Start a WhatsApp conversation',
    'services.whatsapp_fast': 'Use WhatsApp for a fast and instant response',
    'media.gallery_badge': 'SIPORTS Gallery',
    'media.gallery_title': 'SIPORTS in Pictures',
    'media.gallery_desc': 'Discover the unique atmosphere of the International Ports Exhibition',
    'media.view_gallery': 'View full gallery',
    'partners.catalog_label': 'SIPORT 2026 \\u2022 Partners Catalog',
    'partners.page_title': 'Partners',
    'partners.page_subtitle': 'Discover the organizations and institutions supporting the port industry',
    'partners.leaders_count': 'strategic partners to discover.',
    'partners.search_placeholder': 'Search a partner',
    'partners.filters': 'Filters',
    'partners.sort_by': 'Sort by:',
    'partners.sort_name': 'Name',
    'partners.sort_sector': 'Sector',
    'partners.sort_type': 'Type',
    'partners.sort_country': 'Country',
    'partners.export': 'Export',
    'partners.no_results': 'No partners found for your search',
    'partners.clear_filters': 'Clear filters',
    'partners.total': 'Total Partners',
    'partners.type': 'Partner type',
    'partners.institutional': 'Institutional',
    'partners.verified_only': 'Verified only',
    'partners.featured_only': 'Featured only',
    'partners.export_limit': 'Export limit reached. {{remaining}} exports remaining.',
    'partners.export_error': 'Export error',
    'partners.country': 'Country',
    'partner.status.upcoming': 'Upcoming',
    'partner.status.draft': 'Draft',
    'partner.priority': 'Priority',
    'partner.details': 'Details',
    'visitor.premium_feature': 'Premium Feature',
    'visitor.upgrade_level': 'Upgrade my level',
    'accommodation.dist.2km': '2 km away',
    'accommodation.dist.2.5km': '2.5 km away',
    'accommodation.dist.3km': '3 km away',
    'accommodation.dist.4km': '4 km away',
    'accommodation.dist.5km': '5 km away',
    'accommodation.dist.6km': '6 km away',
    'accommodation.hotel.ibis.desc': 'Ibis Hotel - Budget hotel with excellent service',
    'accommodation.hotel.mazagan.desc': 'Mazagan Beach Resort - 5-star luxury resort',
    'accommodation.hotel.provence.desc': 'Hotel Provence - 4-star hotel near the convention center',
    'accommodation.hotel.pullman.desc': 'Pullman Hotel - 4-star international hotel',
    'accommodation.hotel.royal.desc': 'Royal Hotel - 3-star hotel with good amenities',
    'accommodation.hotel.suisse.desc': 'Suisse Hotel - 4-star hotel in city center',
    'accommodation.room.deluxe_double': 'Deluxe Double Room',
    'accommodation.room.deluxe_single': 'Deluxe Single Room',
    'accommodation.room.garden_pool_double': 'Garden View Pool Double Room',
    'accommodation.room.garden_pool_single': 'Garden View Pool Single Room',
    'accommodation.room.suite_full_ocean': 'Suite with Full Ocean View',
    'accommodation.room.suite_junior_double': 'Junior Suite Double',
    'accommodation.room.suite_junior_single': 'Junior Suite Single',
    'accommodation.room.suite_partial_ocean': 'Suite with Partial Ocean View',
    'badge.active': 'Active',
    'badge.badge_downloaded': 'Badge downloaded',
    'badge.badge_generated_success': 'Badge generated successfully',
    'badge.comment': 'Comment',
    'badge.download_error': 'Download error',
    'badge.download_print_info': 'Download or print your access badge',
    'badge.download_png': 'Download PNG',
    'badge.error_generating': 'Error generating badge',
    'badge.error_loading': 'Error loading badge',
    'badge.generate_badge_info': 'Generate your access badge for the event',
    'badge.generate_my_badge': 'Generate my badge',
    'badge.generating': 'Generating badge...',
    'badge.instruction_1': 'Click below to generate your badge',
    'badge.instruction_1_desc': 'Your personalized access badge will be created with your information',
    'badge.instruction_2': 'Download or print your badge',
    'badge.instruction_2_desc': 'You can download as PNG or print directly from here',
    'badge.instruction_3': 'Show your badge at the entrance',
    'badge.instruction_3_desc': 'Present your badge to gain entry to the event',
    'badge.instruction_4': 'Keep your badge with you',
    'badge.instruction_4_desc': 'Show your badge to security or at partner stands',
    'badge.last_scan': 'Last scan',
    'badge.login_required': 'Login required',
    'badge.must_login_badge': 'You must be logged in to generate your badge',
    'badge.my_access_badge': 'My access badge',
    'badge.print.camera_activated': 'Camera activated',
    'badge.print.error_camera': 'Camera error - please allow camera access',
    'badge.print.error_printing': 'Printing error occurred',
    'badge.print.generated': 'Badge printed',
    'badge.print.sent': 'Badge sent to printer',
    'badge.regenerate': 'Regenerate',
    'badge.regenerating': 'Regenerating badge...',
    'badge.scanner.activated': 'Scanner activated',
    'badge.scanner.deactivated': 'Scanner deactivated',
    'badge.scanner.error_camera': 'Camera error',
    'badge.scanner.error_lead': 'Lead capture error',
    'badge.scanner.error_processing': 'Error processing scan',
    'badge.scanner.error_start': 'Error starting scanner',
    'badge.scanner.error_stats': 'Error loading statistics',
    'badge.scanner.error_stop': 'Error stopping scanner',
    'badge.scanner.error_validate': 'Validation error',
    'badge.scanner.error_validation': 'Badge validation error',
    'badge.scanner.expired': 'Badge expired',
    'badge.scanner.inactive': 'Badge inactive',
    'badge.scanner.invalid': 'Invalid badge',
    'badge.scans_done': 'Scans completed',
    'badge.stand_number': 'Stand number',
    'badge.statistics': 'Statistics',
    'badge.status': 'Status',
    'badge.usage_instructions': 'How to use your badge',
    'badge.valid_from': 'Valid from',
    'badge.vip_advantage_1': 'Priority entrance to the event',
    'badge.vip_advantage_2': 'Access to VIP lounge and special areas',
    'badge.vip_advantage_3': 'Exclusive networking opportunities',
    'badge.vip_advantages': 'VIP Advantages',
    'common.bookmarked_add': 'Bookmark',
    'common.bookmarked_remove': 'Remove bookmark',
    'common.comment': 'Comment',
    'common.comments': 'Comments',
    'common.generating_pdf': 'Generating PDF...',
    'common.like': 'Like',
    'common.loading_article': 'Loading article...',
    'common.newsletter_placeholder': 'Enter your email address',
    'common.newsletter_subscribe': 'Subscribe to our newsletter',
    'common.newsletter_subtitle': 'Get the latest news and updates about SIPORT',
    'common.newsletter_title': 'Newsletter subscription',
    'common.read_more': 'Read more',
    'common.related_articles': 'Related articles',
    'common.share': 'Share',
    'common.share_link_copied': 'Link copied to clipboard',
    'common.share_link_error': 'Error copying link',
    'common.source': 'Source',
    'common.tags': 'Tags',
    'common.views': 'Views',
    'exhibitors.count': 'exhibitors',
    'minisite.list.subtitle': 'Explore the mini-sites of our exhibitors and partners',
    'minisite.list.title': 'Mini-sites',
    'minisite.search.no_match': 'No mini-sites match your search',
    'minisite.search.no_sites_yet': 'No mini-sites available yet',
    'minisite.search.not_found': 'Mini-site not found',
    'minisite.search.placeholder': 'Search mini-sites...',
    'navigation.news': 'News',
    'payment.paypalCaptureErrorToast': 'PayPal payment error. Please try again.',
    'actions.open': 'Open',
    'admin.all_categories': 'All Categories',
    'admin.create_first_article': 'Create Your First Article',
    'admin.featured': 'Featured',
    'admin.no_articles_criteria': 'No articles match the selected criteria',
    'admin.no_articles_found': 'No articles found',
    'admin.platform_statistics': 'Platform Statistics',
    'appointments.no_appointments_date': 'No appointments scheduled for this date',
    'auth.bio': 'Bio',
    'auth.bio_placeholder': 'Tell us about yourself',
    'auth.company': 'Company',
    'auth.company_placeholder': 'Your company name',
    'auth.country': 'Country',
    'auth.login': 'Login',
    'auth.login_required': 'Login required',
    'auth.phone': 'Phone',
    'auth.please_login': 'Please login to continue',
    'auth.premium_required': 'Premium access required',
    'badge.access_badge': 'Access Your Badge',
    'badge.authorized_zones': 'Authorized Zones',
    'badge.automatic_rotation': 'Automatic Rotation',
    'badge.loading_badge': 'Loading your badge...',
    'badge.max_security': 'Maximum Security',
    'badge.regenerate_qr': 'Regenerate QR Code',
    'badge.secure_qr_jwt': 'Secure JWT Token',
    'badge.security_info': 'Security Information',
    'badge.total_access': 'Total Access',
    'badge.unknown_level': 'Unknown Access Level',
    'calendar.add_new_slot': 'Add New Slot',
    'calendar.available_spots': 'Available Spots',
    'calendar.create_first_slot': 'Create Your First Time Slot',
    'calendar.default_location': 'Default Location',
    'calendar.event_days_description': 'View availability across all event days',
    'calendar.grid_view': 'Grid View',
    'calendar.list_view': 'List View',
    'calendar.no_availability_message': 'No availability scheduled yet',
    'calendar.no_slots': 'No time slots available',
    'calendar.no_slots_configured': 'No time slots configured',
    'calendar.plan_availability': 'Plan Your Availability',
    'calendar.this_week': 'This Week',
    'calendar.title': 'Availability Calendar',
    'calendar.total_slots': 'Total Slots',
    'common.all': 'All',
    'common.appointments': 'Appointments',
    'common.b2b_meetings': 'B2B Meetings',
    'common.back_home': 'Back Home',
    'common.cancel': 'Cancel',
    'common.categories': 'Categories',
    'common.close_error': 'Close Error',
    'common.complete_dashboard': 'Complete Dashboard',
    'common.dashboard': 'Dashboard',
    'common.delete_error': 'Delete Error',
    'common.delete_success': 'Successfully deleted',
    'common.error': 'Error',
    'common.load_more': 'Load More',
    'common.loading': 'Loading...',
    'common.networking': 'Networking',
    'common.new': 'New',
    'common.not_verified': 'Not Verified',
    'common.public_conferences': 'Public Conferences',
    'common.published': 'Published',
    'common.save': 'Save',
    'common.saving': 'Saving...',
    'common.total': 'Total',
    'common.unlimited': 'Unlimited',
    'common.update_success': 'Successfully updated',
    'common.updated': 'Updated',
    'common.upgrade': 'Upgrade',
    'common.verified': 'Verified',
    'common.view_all': 'View All',
    'common.vip_zones': 'VIP Zones',
    'common.warning': 'Warning',
    'countdown.add_to_calendar': 'Add to Calendar',
    'countdown.address': 'Address',
    'countdown.calendar_added': 'Added to your calendar',
    'countdown.calendar_description': 'Event reminder added',
    'countdown.conferences': 'Conferences',
    'countdown.contact_hours': 'Contact Hours',
    'countdown.contact_org': 'Contact Organization',
    'countdown.copied_clipboard': 'Copied to clipboard',
    'countdown.copy_failed': 'Copy failed',
    'countdown.countries': 'Countries',
    'countdown.day': 'Day',
    'countdown.day1_networking': 'Opening Networking',
    'countdown.day1_opening': 'Official Opening',
    'countdown.day1_plenary': 'Plenary Session',
    'countdown.day1_title': 'Day 1: Opening & Networking',
    'countdown.day2_b2b': 'B2B Meetings',
    'countdown.day2_demos': 'Live Demonstrations',
    'countdown.day2_title': 'Day 2: B2B & Workshops',
    'countdown.day2_workshops': 'Workshops',
    'countdown.day3_awards': 'Awards Ceremony',
    'countdown.day3_closing': 'Closing Session',
    'countdown.day3_roundtables': 'Round Tables',
    'countdown.day3_title': 'Day 3: Closing & Awards',
    'countdown.days': 'Days',
    'countdown.days_plural': 'Days',
    'countdown.event_address': 'Event Address',
    'countdown.event_started': 'Event has started',
    'countdown.event_welcome': 'Welcome to SIPORTS 2026',
    'countdown.exhibitors': 'Exhibitors',
    'countdown.hour': 'Hour',
    'countdown.hours': 'Hours',
    'countdown.info_catering': 'Catering Information',
    'countdown.info_parking': 'Parking Information',
    'countdown.info_registration': 'Registration Details',
    'countdown.info_shuttles': 'Shuttle Services',
    'countdown.info_wifi': 'WiFi Access',
    'countdown.key_figures': 'Key Figures',
    'countdown.location_access': 'Location & Access',
    'countdown.minute': 'Minute',
    'countdown.minutes': 'Minutes',
    'countdown.months': 'Months',
    'countdown.opening_in': 'Opening in',
    'countdown.practical_info': 'Practical Information',
    'countdown.program_3days': '3-Day Program',
    'countdown.reminder_set': 'Reminder set',
    'countdown.schedule': 'Schedule',
    'countdown.second': 'Second',
    'countdown.seconds': 'Seconds',
    'countdown.set_reminder': 'Set Reminder',
    'countdown.share_countdown': 'Share Countdown',
    'countdown.share_title': 'Share SIPORTS 2026',
    'countdown.venue': 'Venue',
    'countdown.visitors': 'Visitors',
    'countdown.weeks': 'Weeks',
    'dashboard.appointments': 'Appointments',
    'dashboard.bio_help': 'Help with bio',
    'dashboard.complete_profile': 'Complete Your Profile',
    'dashboard.completion_help': 'Profile completion help',
    'dashboard.completion_score': 'Profile Completion Score',
    'dashboard.contacts': 'Contacts',
    'dashboard.event_goals': 'Event Goals',
    'dashboard.login_to_see_stats': 'Login to see your statistics',
    'dashboard.minisite_views': 'Minisite Views',
    'dashboard.partnership_types': 'Partnership Types',
    'dashboard.products': 'Products',
    'dashboard.profile_tips': 'Profile Tips',
    'dashboard.profile_views': 'Profile Views',
    'dashboard.visibility': 'Visibility',
    'dashboard.why_complete': 'Why complete your profile?',
    'error.auto_generation': 'Auto-generation error',
    'error.generic': 'An error occurred',
    'error.recommendation': 'Recommendation error',
    'errors.back_to_home': 'Back to Home',
    'errors.error_message': 'Error message',
    'errors.oops': 'Oops!',
    'errors.reload_page': 'Reload Page',
    'errors.unexpected_error': 'An unexpected error occurred. Our team has been notified.',
    'errors.view_stack_trace': 'View Details',
    'exhibitors.company_info': 'Company Information',
    'exhibitors.company_size': 'Company Size',
    'form.activity_sector': 'Activity Sector',
    'form.confirm_and_send': 'Confirm and Send',
    'form.contact_information': 'Contact Information',
    'form.country': 'Country',
    'form.description': 'Description',
    'form.edit_information': 'Edit Information',
    'form.email': 'Email',
    'form.ensure_correct_before_submit': 'Please ensure all information is correct before submitting',
    'form.error.generic': 'Form submission error',
    'form.full_name': 'Full Name',
    'form.organization_information': 'Organization Information',
    'form.organization_name': 'Organization Name',
    'form.partnership_type': 'Partnership Type',
    'form.phone': 'Phone',
    'form.position': 'Position',
    'form.request_review_warning': 'Your submission will be reviewed by our team',
    'form.required': 'Required field',
    'form.sending': 'Sending...',
    'form.status.saving': 'Saving your changes...',
    'form.success.updated': 'Your information has been updated',
    'form.verify_information': 'Verify Your Information',
    'form.website': 'Website',
    'matching.form.collaboration_types': 'Types of Collaboration',
    'matching.form.goals': 'Your Goals',
    'matching.form.interests': 'Your Interests',
    'matching.form.save': 'Save Preferences',
    'matching.form.sectors': 'Your Sectors',
    'matching.results.contact': 'Contact this person',
    'matching.subtitle': 'AI-Powered Networking Recommendations',
    'matching.title': 'Networking Matching',
    'media.action.listen_now': 'Listen Now',
    'media.capsule.added_to_favorites': 'Added to favorites',
    'media.capsule.link_copied': 'Link copied',
    'media.capsule.not_found': 'Media not found',
    'media.capsule.save': 'Save',
    'media.capsule.saved': 'Saved',
    'media.detail.views': 'views',
    'media.error.loading_capsule': 'Error loading media content',
    'media.filter.all_categories': 'All Categories',
    'media.info.audio_unavailable': 'Audio currently unavailable',
    'media.info.try_filter': 'Try using filters to find content',
    'media.podcast.featured_episode': 'Featured Episode',
    'media.podcast.no_results': 'No podcasts found',
    'media.podcast.page_subtitle': 'Listen to expert insights and industry leaders',
    'media.podcast.page_title': 'Podcasts',
    'media.podcast.search_placeholder': 'Search podcasts...',
    'media.share': 'Share',
    'media.stats.hours': 'hours',
    'media.stats.listening': 'Listening Time',
    'media.stats.listens': 'Listens',
    'media.stats.total_episodes': 'Total Episodes',
    'media.testimonial.no_results': 'No testimonials found',
    'media.testimonial.no_results_desc': 'Be the first to share your experience',
    'media.testimonial.satisfaction': 'Satisfaction Rate',
    'media.testimonial.search_placeholder': 'Search testimonials...',
    'media.testimonial.subtitle': 'Hear from attendees and exhibitors',
    'media.testimonial.title': 'Testimonials',
    'minisite.ai_info': 'Let AI create your minisite automatically',
    'minisite.ai_unavailable': 'AI generation temporarily unavailable',
    'minisite.auto_creation_title': 'Auto-Generate Your Minisite',
    'minisite.auto_generate_button': 'Generate with AI',
    'minisite.back_to_dashboard': 'Back to Dashboard',
    'minisite.button_next': 'Next',
    'minisite.button_previous': 'Previous',
    'minisite.create.title': 'Create Your Minisite',
    'minisite.creation_error': 'Error creating minisite',
    'minisite.default_company': 'Company Name',
    'minisite.delete_image': 'Delete Image',
    'minisite.editor.add_section': 'Add Section',
    'minisite.editor.click_to_edit': 'Click to Edit',
    'minisite.editor.customize': 'Customize Your Minisite',
    'minisite.editor.empty_state': 'No content added yet',
    'minisite.error_title': 'Minisite Creation Error',
    'minisite.generate_button': 'Generate Minisite',
    'minisite.generating': 'Generating your minisite...',
    'minisite.generating_auto': 'Generating with AI...',
    'minisite.hero.cta_placeholder': 'Call to Action Button Text',
    'minisite.hero.tips.cta': 'Use a clear, action-oriented call-to-action',
    'minisite.hero.tips.image': 'Use a high-quality image that represents your company',
    'minisite.invalid_url': 'Invalid URL format',
    'minisite.login_required': 'Login required to create minisite',
    'minisite.manual_alternative': 'Or create manually',
    'minisite.page.create_subtitle': 'Choose how you want to create your minisite',
    'minisite.page.create_title': 'Create Your Minisite',
    'minisite.page.scratch_desc': 'Build from scratch with full customization',
    'minisite.page.scratch_option': 'Start from Scratch',
    'minisite.page.template_desc': 'Let AI generate content for you',
    'minisite.page.template_option': 'AI Generation',
    'minisite.placeholder_company': 'Enter your company name',
    'minisite.placeholder_description': 'Describe your company and offerings',
    'minisite.placeholder_products': 'List your main products or services',
    'minisite.placeholder_socials': 'Add your social media links',
    'minisite.placeholder_url': 'Enter website URL',
    'minisite.preview.create': 'Create',
    'minisite.preview.edit': 'Edit',
    'minisite.preview.products_found': 'products found',
    'minisite.preview.verify': 'Verify and Publish',
    'minisite.section.gallery_desc': 'Showcase your products and services',
    'minisite.section.gallery_empty': 'Add images to your gallery',
    'minisite.section.gallery_order': 'Drag to reorder your gallery',
    'minisite.section.gallery_title': 'Image Gallery',
    'minisite.section.products': 'Products',
    'minisite.section.products_title': 'Featured Products',
    'minisite.step_company': 'Company Information',
    'minisite.step_description': 'Company Description',
    'minisite.step_documents': 'Documents',
    'minisite.step_logo': 'Company Logo',
    'minisite.step_products': 'Products',
    'minisite.step_socials': 'Social Media',
    'minisite.success_emoji': '🎉',
    'minisite.success_message': 'Your minisite has been successfully created',
    'minisite.success_title': 'Minisite Created!',
    'minisite.unknown_error': 'An unknown error occurred',
    'minisite.view_my_minisite': 'View My Minisite',
    'minisite.wizard_title': 'Minisite Creation Wizard',
    'months.april': 'April',
    'networking.confirm.cancel': 'Cancel Appointment',
    'networking.error.acceptance': 'Error accepting appointment',
    'networking.error.cancellation': 'Error cancelling appointment',
    'networking.error.duplicate_appointment': 'This appointment already exists',
    'networking.error.duplicate_slot': 'This time slot is already taken',
    'networking.error.generation': 'Error generating recommendations',
    'networking.error.invalid_dates': 'Invalid date range',
    'networking.error.loading_data': 'Error loading data',
    'networking.error.login_required': 'Login required',
    'networking.error.must_be_logged': 'You must be logged in',
    'networking.error.no_exhibitor': 'Exhibitor not found',
    'networking.error.no_slot': 'Time slot not found',
    'networking.error.past_slot': 'This time slot is in the past',
    'networking.error.profile_not_found': 'Profile not found',
    'networking.error.quota_reached_free': 'Free quota has been reached',
    'networking.error.recommendations': 'Error loading recommendations',
    'networking.error.refusal': 'Error refusing appointment',
    'networking.error.search': 'Search error',
    'networking.error.slot_taken': 'This slot is already taken',
    'networking.generation.loading': 'Generating recommendations...',
    'networking.restricted': 'This feature is restricted',
    'networking.search.no_results': 'No results found',
    'networking.search_room': 'Search Networking Rooms',
    'networking.success.appointment_cancelled': 'Appointment cancelled',
    'networking.success.generated': 'Recommendations generated successfully',
    'networking.success.recommendations': 'Recommendations loaded',
    'payment.pending_description': 'Your payment is being processed',
    'payment.pending_title': 'Payment Pending',
    'payment.see_bank_details': 'Bank Transfer Details',
    'products.error_saving_images': 'Error saving product images',
    'products.min_one_image': 'Please add at least one product image',
    'products.product_images': 'Product Images',
    'products.upload_images_desc': 'Upload up to 5 product images',
    'profile.about_placeholder': 'Tell us about yourself and your interests',
    'profile.change_photo': 'Change Photo',
    'profile.country': 'Country',
    'profile.first_name': 'First Name',
    'profile.last_name': 'Last Name',
    'profile.not_found': 'Profile not found',
    'profile.position': 'Position',
    'quota.remaining_unlimited': 'Unlimited appointments',
    'quota.unlimited': 'Unlimited',
    'quota.upgrade_for_more': 'Upgrade to get more appointments',
    'status.available': 'Available',
    'status.full': 'Full',
    'status.no_spots': 'No spots available',
    'status.spots_available': 'Spots available',
    'sub.info.title1': 'About',
    'sub.info.titleHighlight': 'the event',
    'ui.add_remove_favorite': 'Add to Favorites',
    'ui.backward_10s': 'Rewind 10s',
    'ui.book_appointment': 'Book Appointment',
    'ui.contact_directly': 'Contact Directly',
    'ui.contact_info': 'Contact Information',
    'ui.forward_10s': 'Forward 10s',
    'ui.search': 'Search',
    'upload.max_size': 'Maximum file size is 5MB',
    'upload.must_be_image': 'File must be an image',
    'upload.upload_error': 'Upload error',
    'visitor.action_required': 'Action Required',
    'visitor.appointment_with': 'Appointment with',
    'visitor.b2b_reserved_message': 'B2B appointments are reserved for Premium and VIP visitors',
    'visitor.browse_program': 'Browse Program',
    'visitor.my_schedule': 'My Schedule',
    'visitor.networking_hub': 'Networking Hub',
    'visitor.networking_hub_desc': 'Your personal networking and contact management space',
    'visitor.new_invitations': 'New Invitations',
    'visitor.no_message': 'No messages',
    'visitor.no_registered_events': 'No registered events',
    'visitor.personal': 'My',
    'visitor.view_full_program': 'View Full Program',
    'whatsapp.available_24_7': 'Available 24/7',
    'whatsapp.chat_team': 'Chat with our team',
    'whatsapp.contact_whatsapp': 'Contact via WhatsApp',
    'whatsapp.need_help': 'Need Help?',
    'pages.webinars.title': 'SIPORT Webinars',
    'pages.webinars.description': 'Discover our sponsored webinars in replay. Exclusive sessions with experts in the maritime and port industry.',
    'pages.webinars.loading': 'Loading webinars...',
    'pages.webinars.total_webinars': 'Webinars total',
    'pages.webinars.hours_content': 'hours of content',
    'pages.webinars.expert_speakers': 'industry experts',
    'pages.webinars.filter_all': 'All',
    'pages.webinars.filter_recent': 'Recent',
    'pages.webinars.filter_popular': 'Popular',
    'pages.webinars.search_webinars': 'Search webinars...',
    'pages.webinars.no_results': 'No webinars found',
    'pages.webinars.no_category': 'Uncategorized',
    'pages.webinars.duration': 'Duration',
    'pages.webinars.participants': 'Participants',
    'pages.capsules.title': 'SIPORT Video Capsules',
    'pages.capsules.description': 'Short and impactful content on the port industry. Stay informed about the latest news in less than 5 minutes.',
    'pages.capsules.loading': 'Loading capsules...',
    'pages.capsules.total_capsules': 'Capsules available',
    'pages.capsules.total_views': 'total views',
    'pages.capsules.trending_now': 'Trending now',
    'pages.capsules.filter_all': 'All',
    'pages.capsules.filter_recent': 'Recent',
    'pages.capsules.filter_popular': 'Popular',
    'pages.capsules.search_capsules': 'Search capsules...',
    'pages.capsules.no_results': 'No capsules found',
    'pages.capsules.add_to_favorites': 'Add to favorites',
    'pages.capsules.remove_from_favorites': 'Remove from favorites',
    'pages.live.title': 'SIPORT Live Studio',
    'pages.live.description': 'Join our live broadcasts. Interviews, debates and maritime industry news in real time.',
    'pages.live.loading': 'Loading broadcasts...',
    'pages.live.coming_soon': 'Coming Soon',
    'pages.live.past_streams': 'Past Broadcasts',
    'pages.live.total_viewers': 'viewers',
    'pages.live.scheduled_broadcasts': 'Scheduled Broadcasts',
    'pages.live.average_duration': 'Average Duration',
    'pages.live.filter_all': 'All',
    'pages.live.filter_upcoming': 'Upcoming',
    'pages.live.filter_past': 'Past',
    'pages.live.search_streams': 'Search broadcasts...',
    'pages.live.no_results': 'No broadcasts found',
    'pages.moments.title': 'SIPORT Best Moments',
    'pages.moments.description': 'Relive the best moments of SIPORT. Interviews, major announcements and memorable moments from the event.',
    'pages.moments.loading': 'Loading moments...',
    'pages.moments.featured_moments': 'Featured Moments',
    'pages.moments.total_moments': 'Moments available',
    'pages.moments.event_highlights': 'Event Highlights',
    'pages.moments.curated_by': 'Curated by SIPORT Team',
    'pages.moments.filter_all': 'All',
    'pages.moments.filter_recent': 'Recent',
    'pages.moments.filter_popular': 'Popular',
    'pages.moments.search_moments': 'Search moments...',
    'pages.moments.no_results': 'No moments found',
    'pages.moments.share_moment': 'Share this moment',
    'media.back_to_home': 'Back to Home',
    'media.loading_content': 'Loading content...',
    'media.error_loading': 'Error loading content',
    'media.retry': 'Retry',
    'common.featured': 'Featured',
    'common.speakers': 'Speakers',
    'common.watch_replay': 'Watch Replay',
    'common.results': 'Results',
    'common.all_items': 'All Items',
    'common.modify_filters': 'Try modifying your search filters',
    'common.coming_soon': 'Content will be available soon',
    'common.back': 'Back',

    // Calendar & Availability
    'calendar.error_loading_slots': 'Error loading time slots',
    'calendar.error_fill_all_fields': 'Please fill in all required fields',
    'calendar.error_end_after_start': 'End time must be after start time',
    'calendar.error_past_date': 'Cannot create a time slot for a past date',
    'calendar.error_slot_exists': 'This time slot already exists at this date and time',
    'calendar.error_adding_slot': 'Error adding the time slot',
    'calendar.error_overlapping_slot': 'This time slot overlaps with an existing one',
    'calendar.error_status_update': 'Error updating slot status',
    'calendar.error_deletion': 'Error deleting',
    'calendar.error_deleting_slot': 'Error deleting the time slot',
    'calendar.success_added': 'Time slot added successfully',
    'calendar.success_modified': 'Time slot modified successfully',
    'calendar.success_deleted': 'Time slot deleted successfully',
    'calendar.success_reopened': 'Time slot reopened',
    'calendar.success_closed': 'Time slot temporarily closed',
    'calendar.success_period_blocked': 'slot(s) deleted — period blocked from',
    'calendar.confirm_reopen_slot': 'The slot is full. Do you want to increase the capacity to reopen it?',
    'calendar.confirm_close_slot': 'Do you want to close this time slot?',
    'calendar.confirm_delete': 'Are you sure you want to delete this time slot?',
    'calendar.confirm_block_with_bookings': 'slot(s) will be deleted including {{count}} existing appointment(s). Affected visitors will need to be notified. Continue?',
    'calendar.confirm_block_no_bookings': 'slot(s) will be deleted. Continue?',
    'calendar.info_no_slots_to_block': 'No time slots to block in this period',
    'calendar.block_period': 'Block a period',
    'calendar.block_period_subtitle': 'Deletes all time slots within the selected time range',
    'calendar.block_this_period': 'Block this period',
    'calendar.deleting': 'Deleting...',
    'calendar.auto_generation': 'Auto Generate',
    'calendar.management_title': 'Availability Management',
    'calendar.management_subtitle': 'Create and manage your appointment slots for SIPORT 2026',
    'calendar.exclusive_event': 'Exclusive Event',
    'calendar.no_availability_configured': 'No availability configured',
    'calendar.empty_state_message': 'Start by adding your availability slots to allow visitors to book appointments with you during SIPORT 2026.',
    'calendar.generate_all_schedule': 'Generate my full schedule',
    'calendar.create_manual_slot': 'Create a manual slot',
    'calendar.slot_generator': 'Slot generator',
    'calendar.edit_slot': 'Edit time slot',
    'calendar.single_slot': 'Single slot',
    'calendar.bulk_generator': 'Bulk generator',
    'calendar.block_start': 'Start',
    'calendar.block_end': 'End',
    'calendar.slots_affected': 'slot(s) affected',
    'calendar.no_appointments': 'No appointments',
    'calendar.appointments_warning': 'Warning: {{count}} existing appointment(s) will be cancelled',
    'calendar.appointments_booked': 'Appointments booked',
    'calendar.slot_date_label': 'Slot date',
    'calendar.meeting_type_label': 'Meeting type',
    'calendar.start_time': 'Start time',
    'calendar.end_time': 'End time',
    'calendar.max_participants': 'Max participants',
    'calendar.location_label': 'Location / Video conference link',
    'calendar.location_placeholder': 'Booth A12, Room B, https://meet.google.com/...',
    'calendar.location_hint': 'For virtual meetings, enter the video conference link',
    'calendar.description_label': 'Description (optional)',
    'calendar.description_placeholder': 'Meeting topic, agenda, required preparation...',
    'calendar.saving': 'Saving...',
    'calendar.create_slot': 'Create time slot',
    'calendar.modify': 'Modify',
    'calendar.cancel': 'Cancel',
    'calendar.date': 'Date',
    'calendar.mandatory_management': 'Time slot management required',
    'calendar.mandatory_management_desc_exhibitor': 'As an exhibitor, you must define your availability slots to allow other participants to book appointments. These slots will appear on your profile and be visible in AI recommendations.',
    'calendar.mandatory_management_desc_partner': 'As a partner, you must define your availability slots to allow other participants to book appointments. These slots will appear on your profile and be visible in AI recommendations.',

    // Slot types
    'slot_type.in_person': 'In-person',
    'slot_type.virtual': 'Virtual',
    'slot_type.hybrid': 'Hybrid',

    // Actions
    'actions.reopen': 'Reopen',
    'actions.close_slot': 'Close slot',
    'actions.remove': 'Remove',

    // Appointment notifications
    'appointment.notification_confirmed': 'Appointment confirmed',
    'appointment.notification_rejected': 'Appointment rejected',
    'appointment.notification_cancelled': 'Appointment cancelled',
    'appointment.toast_confirmed': 'Appointment confirmed!',
    'appointment.toast_confirmed_desc': 'Participants have been notified.',
    'appointment.toast_rejected': 'Appointment rejected',
    'appointment.toast_rejected_desc': 'The visitor has been notified.',
    'appointment.error_booking_in_progress': 'A booking is already in progress. Please wait.',
    'appointment.error_not_authenticated': 'You must be logged in to book an appointment.',
    'appointment.error_booking': 'Error booking appointment',
    'appointment.error_cancel_not_authenticated': 'You must be logged in to cancel an appointment.',
    'appointment.error_already_booked': 'You have already booked this slot',
    'appointment.error_already_booked_exhibitor': 'You already have an appointment with this exhibitor/partner',
    'appointment.error_slot_not_found': 'Slot not found. Please refresh the page.',
    'appointment.error_no_owner': 'This slot has no valid owner. Please contact support.',
    'appointment.error_past_slot': 'This slot is in the past. Please choose a future slot.',
    'appointment.error_outside_dates': 'This slot is outside the event dates (April 1-3, 2026)',
    'appointment.error_slot_full': 'This slot is full. Please choose another one.',
    'appointment.error_no_valid_date': 'This slot has no valid date',

    // Email templates
    'email.subject_appointment_confirmed': 'Appointment confirmed',
    'email.subject_appointment_confirmed_prefix': 'Confirmation',
    'email.subject_appointment_rejected': 'Appointment rejected',
    'email.subject_appointment_cancelled': 'Appointment cancelled with',
    'email.subject_new_request': 'New appointment request from',
    'email.subject_welcome': 'Welcome to SIPORT 2026',
    'email.subject_welcome_suffix': 'Registration',
    'email.subject_payment_confirmed': 'Payment confirmed - SIPORT 2026',
    'email.label_date': 'Date',
    'email.label_time': 'Time',
    'email.label_type': 'Type',
    'email.label_location': 'Location',
    'email.label_name': 'Name',
    'email.label_email': 'Email',
    'email.label_position': 'Position',
    'email.label_company': 'Company',
    'email.label_amount': 'Amount',
    'email.label_receipt': 'Receipt #',
    'email.label_level': 'Level',
    'email.label_status': 'Status',
    'email.label_with': 'With',
    'email.confirmed_title': 'Appointment confirmed',
    'email.confirmed_body_visitor': 'Your appointment with {{name}} has been confirmed.',
    'email.confirmed_body_exhibitor': 'You have confirmed the appointment with {{name}}.',
    'email.rejected_title': 'Appointment rejected',
    'email.rejected_body': 'Unfortunately, your appointment request with {{name}} has been rejected.',
    'email.rejected_action': 'You can propose another time slot or browse other available exhibitors.',
    'email.cancelled_title': 'Appointment cancelled',
    'email.cancelled_body': 'The appointment with {{name}} scheduled on {{date}} at {{time}} has been cancelled by {{cancelledBy}}.',
    'email.cancelled_by_visitor': 'the visitor',
    'email.cancelled_by_exhibitor': 'the exhibitor',
    'email.cancelled_reschedule': 'Feel free to book a new appointment if needed.',
    'email.new_request_title': 'New appointment request',
    'email.new_request_body': '{{name}} would like to schedule an appointment with you.',
    'email.new_request_action': 'You can confirm or decline this request from your dashboard.',
    'email.visitor_information': 'Visitor information',
    'email.requested_slot': 'Requested slot',
    'email.visitor_message': 'Visitor message',
    'email.welcome_title': 'Welcome to SIPORT 2026!',
    'email.welcome_body': 'Your registration as a {{level}} Visitor has been successfully confirmed!',
    'email.summary': 'Summary',
    'email.status_confirmed': 'Confirmed',
    'email.payment_instructions_title': 'Payment instructions',
    'email.payment_instructions_body': 'To activate your {{level}} badge, please proceed with payment via bank transfer from your dashboard.',
    'email.event_information': 'Event information',
    'email.event_dates': 'Dates: April 1-3, 2026',
    'email.event_location': "Venue: Mohammed VI Exhibition Park, El Jadida, Morocco",
    'email.event_hours': 'Hours: 9:00 AM - 6:00 PM',
    'email.payment_confirmed_title': 'Payment confirmed',
    'email.payment_confirmed_body': 'We have received your payment. Your {{level}} badge is now active!',
    'email.payment_confirmed_access': 'You now have access to all {{level}} features.',
    'email.keep_for_confirmation': 'Keep this email as confirmation of your registration.',
    'email.keep_for_payment': 'Keep this email as proof of payment.',
    'email.subject_payment_approved': 'Payment approved - SIPORT 2026',
    'email.payment_approved_title': 'Payment approved',
    'email.payment_approved_body': 'Your payment has been validated by our team. Your {{level}} badge is now active!',
    'email.payment_approved_badge_active': 'Badge active',
    'email.subject_payment_rejected': 'Payment rejected - SIPORT 2026',
    'email.payment_rejected_title': 'Payment rejected',
    'email.payment_rejected_body': 'Unfortunately, your payment request could not be validated.',
    'email.payment_rejected_reason': 'Reason',
    'email.payment_rejected_action': 'You can submit a new payment or contact our support for more information.',
    'email.payment_rejected_retry': 'Retry',
    'email.contact_support': 'Contact support',
    'email.subject_level_changed': 'Level changed - SIPORT 2026',
    'email.level_changed_title': 'Your level has been updated',
    'email.level_changed_body_upgrade': 'Great news! Your access level has been upgraded.',
    'email.level_changed_body_downgrade': 'Your access level has been updated.',
    'email.level_changed_old_level': 'Previous level',
    'email.level_changed_new_level': 'New level',
    'email.level_changed_new_features': 'Discover the new features available in your dashboard.',
    'email.reminder_24h': 'We will remind you of this appointment 24 hours in advance.',
    'email.view_my_appointments': 'View my appointments',
    'email.view_available_exhibitors': 'View available exhibitors',
    'email.manage_requests': 'Manage my requests',
    'email.access_dashboard': 'Access my dashboard',
    'email.sign_off_soon': 'See you soon,',
    'email.sign_off_regards': 'Best regards,',
    'email.sign_off_thanks': 'Thank you for your trust,',
    'email.team_signature': 'The SIPORT 2026 Team',
    'email.greeting': 'Hello',
    'email.header_subtitle': 'International Port Exhibition',
    'email.footer_title': 'SIPORTS 2026 - International Port Exhibition',
    'email.footer_location': 'April 1-3, 2026, Mohammed VI Exhibition Park, El Jadida, Morocco',
    'email.footer_unsubscribe': 'You are receiving this email because you are registered on siportevent.com',
    'email.label_requested_date': 'Requested date',
    'email.label_requested_time': 'Requested time',
    'email.label_exhibitor': 'Exhibitor',

    // Visitor levels
    'visitor.level_free': 'Free',
    'visitor.level_premium': 'Premium',
    'visitor.level_vip': 'VIP',
  }

};
